// @ts-nocheck
/* eslint-disable */

import { AllTypesProps, ReturnTypes, Ops } from './const';


export const HOST="Specify host"


export const HEADERS = {}
export const apiSubscription = (options: chainOptions) => (query: string) => {
  try {
    const queryString = options[0] + '?query=' + encodeURIComponent(query);
    const wsString = queryString.replace('http', 'ws');
    const host = (options.length > 1 && options[1]?.websocket?.[0]) || wsString;
    const webSocketOptions = options[1]?.websocket || [host];
    const ws = new WebSocket(...webSocketOptions);
    return {
      ws,
      on: (e: (args: any) => void) => {
        ws.onmessage = (event: any) => {
          if (event.data) {
            const parsed = JSON.parse(event.data);
            const data = parsed.data;
            return e(data);
          }
        };
      },
      off: (e: (args: any) => void) => {
        ws.onclose = e;
      },
      error: (e: (args: any) => void) => {
        ws.onerror = e;
      },
      open: (e: () => void) => {
        ws.onopen = e;
      },
    };
  } catch {
    throw new Error('No websockets implemented');
  }
};
export const apiSubscriptionSSE = (options: chainOptions) => (query: string, variables?: Record<string, unknown>) => {
  const url = options[0];
  const fetchOptions = options[1] || {};

  let abortController: AbortController | null = null;
  let reader: ReadableStreamDefaultReader<Uint8Array> | null = null;
  let onCallback: ((args: unknown) => void) | null = null;
  let errorCallback: ((args: unknown) => void) | null = null;
  let openCallback: (() => void) | null = null;
  let offCallback: ((args: unknown) => void) | null = null;
  let isClosing = false; // Flag to track intentional close

  const startStream = async () => {
    try {
      abortController = new AbortController();

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Accept: 'text/event-stream',
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          ...fetchOptions.headers,
        },
        body: JSON.stringify({ query, variables }),
        signal: abortController.signal,
        ...fetchOptions,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      if (openCallback) {
        openCallback();
      }

      reader = response.body?.getReader() || null;
      if (!reader) {
        throw new Error('No response body');
      }

      const decoder = new TextDecoder();
      let buffer = '';

      while (true) {
        const { done, value } = await reader.read();

        if (done) {
          if (offCallback) {
            offCallback({ data: null, code: 1000, reason: 'Stream completed' });
          }
          break;
        }

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n');
        buffer = lines.pop() || '';

        for (const line of lines) {
          if (line.startsWith('data: ')) {
            try {
              const data = line.slice(6);
              const parsed = JSON.parse(data);

              if (parsed.errors) {
                if (errorCallback) {
                  errorCallback({ data: parsed.data, errors: parsed.errors });
                }
              } else if (onCallback && parsed.data) {
                onCallback(parsed.data);
              }
            } catch {
              if (errorCallback) {
                errorCallback({ errors: ['Failed to parse SSE data'] });
              }
            }
          }
        }
      }
    } catch (err: unknown) {
      const error = err as Error;
      // Don't report errors if we're intentionally closing (AbortError) or during cleanup
      if (error.name !== 'AbortError' && !isClosing && errorCallback) {
        errorCallback({ errors: [error.message || 'Unknown error'] });
      }
    }
  };

  return {
    on: (e: (args: unknown) => void) => {
      onCallback = e;
    },
    off: (e: (args: unknown) => void) => {
      offCallback = e;
    },
    error: (e: (args: unknown) => void) => {
      errorCallback = e;
    },
    open: (e?: () => void) => {
      if (e) {
        openCallback = e;
      }
      startStream();
    },
    close: () => {
      isClosing = true; // Mark as intentionally closing to suppress error callbacks
      if (abortController) {
        abortController.abort();
      }
      if (reader) {
        // Wrap in try-catch to suppress AbortError during cleanup
        reader.cancel().catch(() => {
          // Ignore cancel errors - stream may already be closed
        });
      }
    },
  };
};
const handleFetchResponse = (response: Response): Promise<GraphQLResponse> => {
  if (!response.ok) {
    return new Promise((_, reject) => {
      response
        .text()
        .then((text) => {
          try {
            reject(JSON.parse(text));
          } catch (err) {
            reject(text);
          }
        })
        .catch(reject);
    });
  }
  return response.json() as Promise<GraphQLResponse>;
};

export const apiFetch =
  (options: fetchOptions) =>
  (query: string, variables: Record<string, unknown> = {}) => {
    const fetchOptions = options[1] || {};
    if (fetchOptions.method && fetchOptions.method === 'GET') {
      return fetch(`${options[0]}?query=${encodeURIComponent(query)}`, fetchOptions)
        .then(handleFetchResponse)
        .then((response: GraphQLResponse) => {
          if (response.errors) {
            throw new GraphQLError(response);
          }
          return response.data;
        });
    }
    return fetch(`${options[0]}`, {
      body: JSON.stringify({ query, variables }),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      ...fetchOptions,
    })
      .then(handleFetchResponse)
      .then((response: GraphQLResponse) => {
        if (response.errors) {
          throw new GraphQLError(response);
        }
        return response.data;
      });
  };

export const InternalsBuildQuery = ({
  ops,
  props,
  returns,
  options,
  scalars,
}: {
  props: AllTypesPropsType;
  returns: ReturnTypesType;
  ops: Operations;
  options?: OperationOptions;
  scalars?: ScalarDefinition;
}) => {
  const ibb = (
    k: string,
    o: InputValueType | VType,
    p = '',
    root = true,
    vars: Array<{ name: string; graphQLType: string }> = [],
  ): string => {
    const keyForPath = purifyGraphQLKey(k);
    const newPath = [p, keyForPath].join(SEPARATOR);
    if (!o) {
      return '';
    }
    if (typeof o === 'boolean' || typeof o === 'number') {
      return k;
    }
    if (typeof o === 'string') {
      return `${k} ${o}`;
    }
    if (Array.isArray(o)) {
      const args = InternalArgsBuilt({
        props,
        returns,
        ops,
        scalars,
        vars,
      })(o[0], newPath);
      return `${ibb(args ? `${k}(${args})` : k, o[1], p, false, vars)}`;
    }
    if (k === '__alias') {
      return Object.entries(o)
        .map(([alias, objectUnderAlias]) => {
          if (typeof objectUnderAlias !== 'object' || Array.isArray(objectUnderAlias)) {
            throw new Error(
              'Invalid alias it should be __alias:{ YOUR_ALIAS_NAME: { OPERATION_NAME: { ...selectors }}}',
            );
          }
          const operationName = Object.keys(objectUnderAlias)[0];
          const operation = objectUnderAlias[operationName];
          return ibb(`${alias}:${operationName}`, operation, p, false, vars);
        })
        .join('\n');
    }
    const hasOperationName = root && options?.operationName ? ' ' + options.operationName : '';
    const keyForDirectives = o.__directives ?? '';
    const query = `{${Object.entries(o)
      .filter(([k]) => k !== '__directives')
      .map((e) => ibb(...e, [p, `field<>${keyForPath}`].join(SEPARATOR), false, vars))
      .join('\n')}}`;
    if (!root) {
      return `${k} ${keyForDirectives}${hasOperationName} ${query}`;
    }
    const varsString = vars.map((v) => `${v.name}: ${v.graphQLType}`).join(', ');
    return `${k} ${keyForDirectives}${hasOperationName}${varsString ? `(${varsString})` : ''} ${query}`;
  };
  return ibb;
};

type UnionOverrideKeys<T, U> = Omit<T, keyof U> & U;

export const Thunder =
  <SCLR extends ScalarDefinition>(fn: FetchFunction, thunderGraphQLOptions?: ThunderGraphQLOptions<SCLR>) =>
  <O extends keyof typeof Ops, OVERRIDESCLR extends SCLR, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<OVERRIDESCLR>,
  ) =>
  <Z extends ValueTypes[R]>(
    o: Z & {
      [P in keyof Z]: P extends keyof ValueTypes[R] ? Z[P] : never;
    },
    ops?: OperationOptions & { variables?: Record<string, unknown> },
  ) => {
    const options = {
      ...thunderGraphQLOptions,
      ...graphqlOptions,
    };
    return fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: options?.scalars,
      }),
      ops?.variables,
    ).then((data) => {
      if (options?.scalars) {
        return decodeScalarsInResponse({
          response: data,
          initialOp: operation,
          initialZeusQuery: o as VType,
          returns: ReturnTypes,
          scalars: options.scalars,
          ops: Ops,
        });
      }
      return data;
    }) as Promise<InputType<GraphQLTypes[R], Z, UnionOverrideKeys<SCLR, OVERRIDESCLR>>>;
  };

export const Chain = (...options: chainOptions) => Thunder(apiFetch(options));

export const SubscriptionThunder =
  <SCLR extends ScalarDefinition>(fn: SubscriptionFunction, thunderGraphQLOptions?: ThunderGraphQLOptions<SCLR>) =>
  <O extends keyof typeof Ops, OVERRIDESCLR extends SCLR, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<OVERRIDESCLR>,
  ) =>
  <Z extends ValueTypes[R]>(
    o: Z & {
      [P in keyof Z]: P extends keyof ValueTypes[R] ? Z[P] : never;
    },
    ops?: OperationOptions & { variables?: Record<string, unknown> },
  ) => {
    const options = {
      ...thunderGraphQLOptions,
      ...graphqlOptions,
    };
    type CombinedSCLR = UnionOverrideKeys<SCLR, OVERRIDESCLR>;
    const returnedFunction = fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: options?.scalars,
      }),
    ) as SubscriptionToGraphQL<Z, GraphQLTypes[R], CombinedSCLR>;
    if (returnedFunction?.on && options?.scalars) {
      const wrapped = returnedFunction.on;
      returnedFunction.on = (fnToCall: (args: InputType<GraphQLTypes[R], Z, CombinedSCLR>) => void) =>
        wrapped((data: InputType<GraphQLTypes[R], Z, CombinedSCLR>) => {
          if (options?.scalars) {
            return fnToCall(
              decodeScalarsInResponse({
                response: data,
                initialOp: operation,
                initialZeusQuery: o as VType,
                returns: ReturnTypes,
                scalars: options.scalars,
                ops: Ops,
              }),
            );
          }
          return fnToCall(data);
        });
    }
    return returnedFunction;
  };

export const Subscription = (...options: chainOptions) => SubscriptionThunder(apiSubscription(options));
export type SubscriptionToGraphQLSSE<Z, T, SCLR extends ScalarDefinition> = {
  on: (fn: (args: InputType<T, Z, SCLR>) => void) => void;
  off: (fn: (e: { data?: InputType<T, Z, SCLR>; code?: number; reason?: string; message?: string }) => void) => void;
  error: (fn: (e: { data?: InputType<T, Z, SCLR>; errors?: string[] }) => void) => void;
  open: (fn?: () => void) => void;
  close: () => void;
};

export const SubscriptionThunderSSE =
  <SCLR extends ScalarDefinition>(fn: SubscriptionFunction, thunderGraphQLOptions?: ThunderGraphQLOptions<SCLR>) =>
  <O extends keyof typeof Ops, OVERRIDESCLR extends SCLR, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<OVERRIDESCLR>,
  ) =>
  <Z extends ValueTypes[R]>(
    o: Z & {
      [P in keyof Z]: P extends keyof ValueTypes[R] ? Z[P] : never;
    },
    ops?: OperationOptions & { variables?: Record<string, unknown> },
  ) => {
    const options = {
      ...thunderGraphQLOptions,
      ...graphqlOptions,
    };
    type CombinedSCLR = UnionOverrideKeys<SCLR, OVERRIDESCLR>;
    const returnedFunction = fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: options?.scalars,
      }),
      ops?.variables,
    ) as SubscriptionToGraphQLSSE<Z, GraphQLTypes[R], CombinedSCLR>;
    if (returnedFunction?.on && options?.scalars) {
      const wrapped = returnedFunction.on;
      returnedFunction.on = (fnToCall: (args: InputType<GraphQLTypes[R], Z, CombinedSCLR>) => void) =>
        wrapped((data: InputType<GraphQLTypes[R], Z, CombinedSCLR>) => {
          if (options?.scalars) {
            return fnToCall(
              decodeScalarsInResponse({
                response: data,
                initialOp: operation,
                initialZeusQuery: o as VType,
                returns: ReturnTypes,
                scalars: options.scalars,
                ops: Ops,
              }),
            );
          }
          return fnToCall(data);
        });
    }
    return returnedFunction;
  };
export const SubscriptionSSE = (...options: chainOptions) => SubscriptionThunderSSE(apiSubscriptionSSE(options));
export const Zeus = <
  Z extends ValueTypes[R],
  O extends keyof typeof Ops,
  R extends keyof ValueTypes = GenericOperation<O>,
>(
  operation: O,
  o: Z,
  ops?: {
    operationOptions?: OperationOptions;
    scalars?: ScalarDefinition;
  },
) =>
  InternalsBuildQuery({
    props: AllTypesProps,
    returns: ReturnTypes,
    ops: Ops,
    options: ops?.operationOptions,
    scalars: ops?.scalars,
  })(operation, o as VType);

export const ZeusSelect = <T>() => ((t: unknown) => t) as SelectionFunction<T>;

export const Selector = <T extends keyof ValueTypes>(key: T) => key && ZeusSelect<ValueTypes[T]>();

export const TypeFromSelector = <T extends keyof ValueTypes>(key: T) => key && ZeusSelect<ValueTypes[T]>();
export const Gql = Chain(HOST, {
  headers: {
    'Content-Type': 'application/json',
    ...HEADERS,
  },
});

export const ZeusScalars = ZeusSelect<ScalarCoders>();

type BaseSymbol = number | string | undefined | boolean | null;

type ScalarsSelector<T, V> = {
  [X in Required<{
    [P in keyof T]: P extends keyof V
      ? V[P] extends Array<any> | undefined
        ? never
        : T[P] extends BaseSymbol | Array<BaseSymbol>
        ? P
        : never
      : never;
  }>[keyof T]]: true;
};

export const fields = <T extends keyof ModelTypes>(k: T) => {
  const t = ReturnTypes[k];
  const fnType = k in AllTypesProps ? AllTypesProps[k as keyof typeof AllTypesProps] : undefined;
  const hasFnTypes = typeof fnType === 'object' ? fnType : undefined;
  const o = Object.fromEntries(
    Object.entries(t)
      .filter(([k, value]) => {
        const isFunctionType = hasFnTypes && k in hasFnTypes && !!hasFnTypes[k as keyof typeof hasFnTypes];
        if (isFunctionType) return false;
        const isReturnType = ReturnTypes[value as string];
        if (!isReturnType) return true;
        if (typeof isReturnType !== 'string') return false;
        if (isReturnType.startsWith('scalar.')) {
          return true;
        }
        return false;
      })
      .map(([key]) => [key, true as const]),
  );
  return o as ScalarsSelector<ModelTypes[T], T extends keyof ValueTypes ? ValueTypes[T] : never>;
};

export const decodeScalarsInResponse = <O extends Operations>({
  response,
  scalars,
  returns,
  ops,
  initialZeusQuery,
  initialOp,
}: {
  ops: O;
  response: any;
  returns: ReturnTypesType;
  scalars?: Record<string, ScalarResolver | undefined>;
  initialOp: keyof O;
  initialZeusQuery: InputValueType | VType;
}) => {
  if (!scalars) {
    return response;
  }
  const builder = PrepareScalarPaths({
    ops,
    returns,
  });

  const scalarPaths = builder(initialOp as string, ops[initialOp], initialZeusQuery);
  if (scalarPaths) {
    const r = traverseResponse({ scalarPaths, resolvers: scalars })(initialOp as string, response, [ops[initialOp]]);
    return r;
  }
  return response;
};

export const traverseResponse = ({
  resolvers,
  scalarPaths,
}: {
  scalarPaths: { [x: string]: `scalar.${string}` };
  resolvers: {
    [x: string]: ScalarResolver | undefined;
  };
}) => {
  const ibb = (k: string, o: InputValueType | VType, p: string[] = []): unknown => {
    if (Array.isArray(o)) {
      return o.map((eachO) => ibb(k, eachO, p));
    }
    if (o == null) {
      return o;
    }
    const scalarPathString = p.join(SEPARATOR);
    const currentScalarString = scalarPaths[scalarPathString];
    if (currentScalarString) {
      const currentDecoder = resolvers[currentScalarString.split('.')[1]]?.decode;
      if (currentDecoder) {
        return currentDecoder(o);
      }
    }
    if (typeof o === 'boolean' || typeof o === 'number' || typeof o === 'string' || !o) {
      return o;
    }
    const entries = Object.entries(o).map(([k, v]) => [k, ibb(k, v, [...p, purifyGraphQLKey(k)])] as const);
    const objectFromEntries = entries.reduce<Record<string, unknown>>((a, [k, v]) => {
      a[k] = v;
      return a;
    }, {});
    return objectFromEntries;
  };
  return ibb;
};

export type AllTypesPropsType = {
  [x: string]:
    | undefined
    | `scalar.${string}`
    | 'enum'
    | {
        [x: string]:
          | undefined
          | string
          | {
              [x: string]: string | undefined;
            };
      };
};

export type ReturnTypesType = {
  [x: string]:
    | {
        [x: string]: string | undefined;
      }
    | `scalar.${string}`
    | undefined;
};
export type InputValueType = {
  [x: string]: undefined | boolean | string | number | [any, undefined | boolean | InputValueType] | InputValueType;
};
export type VType =
  | undefined
  | boolean
  | string
  | number
  | [any, undefined | boolean | InputValueType]
  | InputValueType;

export type PlainType = boolean | number | string | null | undefined;
export type ZeusArgsType =
  | PlainType
  | {
      [x: string]: ZeusArgsType;
    }
  | Array<ZeusArgsType>;

export type Operations = Record<string, string>;

export type VariableDefinition = {
  [x: string]: unknown;
};

export const SEPARATOR = '|';

export type fetchOptions = Parameters<typeof fetch>;
type websocketOptions = typeof WebSocket extends new (...args: infer R) => WebSocket ? R : never;
export type chainOptions = [fetchOptions[0], fetchOptions[1] & { websocket?: websocketOptions }] | [fetchOptions[0]];
export type FetchFunction = (query: string, variables?: Record<string, unknown>) => Promise<any>;
export type SubscriptionFunction = (query: string, variables?: Record<string, unknown>) => any;
type NotUndefined<T> = T extends undefined ? never : T;
export type ResolverType<F> = NotUndefined<F extends [infer ARGS, any] ? ARGS : undefined>;

export type OperationOptions = {
  operationName?: string;
};

export type ScalarCoder = Record<string, (s: unknown) => string>;

export interface GraphQLResponse {
  data?: Record<string, any>;
  errors?: Array<{
    message: string;
  }>;
}
export class GraphQLError extends Error {
  constructor(public response: GraphQLResponse) {
    super(response.errors?.[0]?.message || 'GraphQL Response Error');
    console.error(response);
  }
  toString() {
    return 'GraphQL Response Error';
  }
}
export type GenericOperation<O> = O extends keyof typeof Ops ? (typeof Ops)[O] : never;
export type ThunderGraphQLOptions<SCLR extends ScalarDefinition> = {
  scalars?: SCLR | ScalarCoders;
};

const ExtractScalar = (mappedParts: string[], returns: ReturnTypesType): `scalar.${string}` | undefined => {
  if (mappedParts.length === 0) {
    return;
  }
  const oKey = mappedParts[0];
  const returnP1 = returns[oKey];
  if (typeof returnP1 === 'object') {
    const returnP2 = returnP1[mappedParts[1]];
    if (returnP2) {
      return ExtractScalar([returnP2, ...mappedParts.slice(2)], returns);
    }
    return undefined;
  }
  return returnP1 as `scalar.${string}` | undefined;
};

export const PrepareScalarPaths = ({ ops, returns }: { returns: ReturnTypesType; ops: Operations }) => {
  const ibb = (
    k: string,
    originalKey: string,
    o: InputValueType | VType,
    p: string[] = [],
    pOriginals: string[] = [],
    root = true,
  ): { [x: string]: `scalar.${string}` } | undefined => {
    if (!o) {
      return;
    }
    if (typeof o === 'boolean' || typeof o === 'number' || typeof o === 'string') {
      const extractionArray = [...pOriginals, originalKey];
      const isScalar = ExtractScalar(extractionArray, returns);
      if (isScalar?.startsWith('scalar')) {
        const partOfTree = {
          [[...p, k].join(SEPARATOR)]: isScalar,
        };
        return partOfTree;
      }
      return {};
    }
    if (Array.isArray(o)) {
      return ibb(k, k, o[1], p, pOriginals, false);
    }
    if (k === '__alias') {
      return Object.entries(o)
        .map(([alias, objectUnderAlias]) => {
          if (typeof objectUnderAlias !== 'object' || Array.isArray(objectUnderAlias)) {
            throw new Error(
              'Invalid alias it should be __alias:{ YOUR_ALIAS_NAME: { OPERATION_NAME: { ...selectors }}}',
            );
          }
          const operationName = Object.keys(objectUnderAlias)[0];
          const operation = objectUnderAlias[operationName];
          return ibb(alias, operationName, operation, p, pOriginals, false);
        })
        .reduce((a, b) => ({
          ...a,
          ...b,
        }));
    }
    const keyName = root ? ops[k] : k;
    return Object.entries(o)
      .filter(([k]) => k !== '__directives')
      .map(([k, v]) => {
        // Inline fragments shouldn't be added to the path as they aren't a field
        const isInlineFragment = originalKey.match(/^...\s*on/) != null;
        return ibb(
          k,
          k,
          v,
          isInlineFragment ? p : [...p, purifyGraphQLKey(keyName || k)],
          isInlineFragment ? pOriginals : [...pOriginals, purifyGraphQLKey(originalKey)],
          false,
        );
      })
      .reduce((a, b) => ({
        ...a,
        ...b,
      }));
  };
  return ibb;
};

export const purifyGraphQLKey = (k: string) => k.replace(/\([^)]*\)/g, '').replace(/^[^:]*\:/g, '');

const mapPart = (p: string) => {
  const [isArg, isField] = p.split('<>');
  if (isField) {
    return {
      v: isField,
      __type: 'field',
    } as const;
  }
  return {
    v: isArg,
    __type: 'arg',
  } as const;
};

type Part = ReturnType<typeof mapPart>;

export const ResolveFromPath = (props: AllTypesPropsType, returns: ReturnTypesType, ops: Operations) => {
  const ResolvePropsType = (mappedParts: Part[]) => {
    const oKey = ops[mappedParts[0].v];
    const propsP1 = oKey ? props[oKey] : props[mappedParts[0].v];
    if (propsP1 === 'enum' && mappedParts.length === 1) {
      return 'enum';
    }
    if (typeof propsP1 === 'string' && propsP1.startsWith('scalar.') && mappedParts.length === 1) {
      return propsP1;
    }
    if (typeof propsP1 === 'object') {
      if (mappedParts.length < 2) {
        return 'not';
      }
      const propsP2 = propsP1[mappedParts[1].v];
      if (typeof propsP2 === 'string') {
        return rpp(
          `${propsP2}${SEPARATOR}${mappedParts
            .slice(2)
            .map((mp) => mp.v)
            .join(SEPARATOR)}`,
        );
      }
      if (typeof propsP2 === 'object') {
        if (mappedParts.length < 3) {
          return 'not';
        }
        const propsP3 = propsP2[mappedParts[2].v];
        if (propsP3 && mappedParts[2].__type === 'arg') {
          return rpp(
            `${propsP3}${SEPARATOR}${mappedParts
              .slice(3)
              .map((mp) => mp.v)
              .join(SEPARATOR)}`,
          );
        }
      }
    }
  };
  const ResolveReturnType = (mappedParts: Part[]) => {
    if (mappedParts.length === 0) {
      return 'not';
    }
    const oKey = ops[mappedParts[0].v];
    const returnP1 = oKey ? returns[oKey] : returns[mappedParts[0].v];
    if (typeof returnP1 === 'object') {
      if (mappedParts.length < 2) return 'not';
      const returnP2 = returnP1[mappedParts[1].v];
      if (returnP2) {
        return rpp(
          `${returnP2}${SEPARATOR}${mappedParts
            .slice(2)
            .map((mp) => mp.v)
            .join(SEPARATOR)}`,
        );
      }
    }
  };
  const rpp = (path: string): 'enum' | 'not' | `scalar.${string}` => {
    const parts = path.split(SEPARATOR).filter((l) => l.length > 0);
    const mappedParts = parts.map(mapPart);
    const propsP1 = ResolvePropsType(mappedParts);
    if (propsP1) {
      return propsP1;
    }
    const returnP1 = ResolveReturnType(mappedParts);
    if (returnP1) {
      return returnP1;
    }
    return 'not';
  };
  return rpp;
};

export const InternalArgsBuilt = ({
  props,
  ops,
  returns,
  scalars,
  vars,
}: {
  props: AllTypesPropsType;
  returns: ReturnTypesType;
  ops: Operations;
  scalars?: ScalarDefinition;
  vars: Array<{ name: string; graphQLType: string }>;
}) => {
  const arb = (a: ZeusArgsType, p = '', root = true): string => {
    if (typeof a === 'string') {
      if (a.startsWith(START_VAR_NAME)) {
        const [varName, graphQLType] = a.replace(START_VAR_NAME, '$').split(GRAPHQL_TYPE_SEPARATOR);
        const v = vars.find((v) => v.name === varName);
        if (!v) {
          vars.push({
            name: varName,
            graphQLType,
          });
        } else {
          if (v.graphQLType !== graphQLType) {
            throw new Error(
              `Invalid variable exists with two different GraphQL Types, "${v.graphQLType}" and ${graphQLType}`,
            );
          }
        }
        return varName;
      }
    }
    const checkType = ResolveFromPath(props, returns, ops)(p);
    if (checkType.startsWith('scalar.')) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const [_, ...splittedScalar] = checkType.split('.');
      const scalarKey = splittedScalar.join('.');
      return (scalars?.[scalarKey]?.encode?.(a) as string) || JSON.stringify(a);
    }
    if (Array.isArray(a)) {
      return `[${a.map((arr) => arb(arr, p, false)).join(', ')}]`;
    }
    if (typeof a === 'string') {
      if (checkType === 'enum') {
        return a;
      }
      return `${JSON.stringify(a)}`;
    }
    if (typeof a === 'object') {
      if (a === null) {
        return `null`;
      }
      const returnedObjectString = Object.entries(a)
        .filter(([, v]) => typeof v !== 'undefined')
        .map(([k, v]) => `${k}: ${arb(v, [p, k].join(SEPARATOR), false)}`)
        .join(',\n');
      if (!root) {
        return `{${returnedObjectString}}`;
      }
      return returnedObjectString;
    }
    return `${a}`;
  };
  return arb;
};

export const resolverFor = <X, T extends keyof ResolverInputTypes, Z extends keyof ResolverInputTypes[T]>(
  _type: T,
  _field: Z,
  fn: (
    args: Required<ResolverInputTypes[T]>[Z] extends [infer Input, any] ? Input : any,
    source: any,
  ) => Z extends keyof ModelTypes[T] ? ModelTypes[T][Z] | Promise<ModelTypes[T][Z]> | X : never,
) => fn as (args?: any, source?: any) => ReturnType<typeof fn>;

export type UnwrapPromise<T> = T extends Promise<infer R> ? R : T;
export type ZeusState<T extends (...args: any[]) => Promise<any>> = NonNullable<UnwrapPromise<ReturnType<T>>>;
export type ZeusHook<
  T extends (...args: any[]) => Record<string, (...args: any[]) => Promise<any>>,
  N extends keyof ReturnType<T>,
> = ZeusState<ReturnType<T>[N]>;

export type WithTypeNameValue<T> = T & {
  __typename?: boolean;
  __directives?: string;
};
export type AliasType<T> = WithTypeNameValue<T> & {
  __alias?: Record<string, WithTypeNameValue<T>>;
};
type DeepAnify<T> = {
  [P in keyof T]?: any;
};
type IsPayLoad<T> = T extends [any, infer PayLoad] ? PayLoad : T;
export type ScalarDefinition = Record<string, ScalarResolver>;

type IsScalar<S, SCLR extends ScalarDefinition> = S extends 'scalar' & { name: infer T }
  ? T extends keyof SCLR
    ? SCLR[T]['decode'] extends (s: unknown) => unknown
      ? ReturnType<SCLR[T]['decode']>
      : unknown
    : unknown
  : S extends Array<infer R>
  ? Array<IsScalar<R, SCLR>>
  : S;

type IsArray<T, U, SCLR extends ScalarDefinition> = T extends Array<infer R>
  ? InputType<R, U, SCLR>[]
  : InputType<T, U, SCLR>;
type FlattenArray<T> = T extends Array<infer R> ? R : T;
type BaseZeusResolver = boolean | 1 | string | Variable<any, string>;

type IsInterfaced<SRC extends DeepAnify<DST>, DST, SCLR extends ScalarDefinition> = FlattenArray<SRC> extends
  | ZEUS_INTERFACES
  | ZEUS_UNIONS
  ? {
      [P in keyof SRC]: SRC[P] extends '__union' & infer R
        ? P extends keyof DST
          ? IsArray<R, '__typename' extends keyof DST ? DST[P] & { __typename: true } : DST[P], SCLR>
          : IsArray<R, '__typename' extends keyof DST ? { __typename: true } : Record<string, never>, SCLR>
        : never;
    }[keyof SRC] & {
      [P in keyof Omit<
        Pick<
          SRC,
          {
            [P in keyof DST]: SRC[P] extends '__union' & infer _R ? never : P;
          }[keyof DST]
        >,
        '__typename'
      >]: IsPayLoad<DST[P]> extends BaseZeusResolver ? IsScalar<SRC[P], SCLR> : IsArray<SRC[P], DST[P], SCLR>;
    }
  : {
      [P in keyof Pick<SRC, keyof DST>]: IsPayLoad<DST[P]> extends BaseZeusResolver
        ? IsScalar<SRC[P], SCLR>
        : IsArray<SRC[P], DST[P], SCLR>;
    };

export type MapType<SRC, DST, SCLR extends ScalarDefinition> = SRC extends DeepAnify<DST>
  ? IsInterfaced<SRC, DST, SCLR>
  : never;
// eslint-disable-next-line @typescript-eslint/ban-types
export type InputType<SRC, DST, SCLR extends ScalarDefinition = {}> = IsPayLoad<DST> extends { __alias: infer R }
  ? {
      [P in keyof R]: MapType<SRC, R[P], SCLR>[keyof MapType<SRC, R[P], SCLR>];
    } & MapType<SRC, Omit<IsPayLoad<DST>, '__alias'>, SCLR>
  : MapType<SRC, IsPayLoad<DST>, SCLR>;
export type SubscriptionToGraphQL<Z, T, SCLR extends ScalarDefinition> = {
  ws: WebSocket;
  on: (fn: (args: InputType<T, Z, SCLR>) => void) => void;
  off: (fn: (e: { data?: InputType<T, Z, SCLR>; code?: number; reason?: string; message?: string }) => void) => void;
  error: (fn: (e: { data?: InputType<T, Z, SCLR>; errors?: string[] }) => void) => void;
  open: () => void;
};

// eslint-disable-next-line @typescript-eslint/ban-types
export type FromSelector<SELECTOR, NAME extends keyof GraphQLTypes, SCLR extends ScalarDefinition = {}> = InputType<
  GraphQLTypes[NAME],
  SELECTOR,
  SCLR
>;

export type ScalarResolver = {
  encode?: (s: unknown) => string;
  decode?: (s: unknown) => unknown;
};

export type SelectionFunction<V> = <Z extends V>(
  t: Z & {
    [P in keyof Z]: P extends keyof V ? Z[P] : never;
  },
) => Z;

type BuiltInVariableTypes = {
  ['String']: string;
  ['Int']: number;
  ['Float']: number;
  ['Boolean']: boolean;
};
type AllVariableTypes = keyof BuiltInVariableTypes | keyof ZEUS_VARIABLES;
type VariableRequired<T extends string> = `${T}!` | T | `[${T}]` | `[${T}]!` | `[${T}!]` | `[${T}!]!`;
type VR<T extends string> = VariableRequired<VariableRequired<T>>;

export type GraphQLVariableType = VR<AllVariableTypes>;

type ExtractVariableTypeString<T extends string> = T extends VR<infer R1>
  ? R1 extends VR<infer R2>
    ? R2 extends VR<infer R3>
      ? R3 extends VR<infer R4>
        ? R4 extends VR<infer R5>
          ? R5
          : R4
        : R3
      : R2
    : R1
  : T;

type DecomposeType<T, Type> = T extends `[${infer R}]`
  ? Array<DecomposeType<R, Type>> | undefined
  : T extends `${infer R}!`
  ? NonNullable<DecomposeType<R, Type>>
  : Type | undefined;

type ExtractTypeFromGraphQLType<T extends string> = T extends keyof ZEUS_VARIABLES
  ? ZEUS_VARIABLES[T]
  : T extends keyof BuiltInVariableTypes
  ? BuiltInVariableTypes[T]
  : any;

export type GetVariableType<T extends string> = DecomposeType<
  T,
  ExtractTypeFromGraphQLType<ExtractVariableTypeString<T>>
>;

type UndefinedKeys<T> = {
  [K in keyof T]-?: T[K] extends NonNullable<T[K]> ? never : K;
}[keyof T];

type WithNullableKeys<T> = Pick<T, UndefinedKeys<T>>;
type WithNonNullableKeys<T> = Omit<T, UndefinedKeys<T>>;

type OptionalKeys<T> = {
  [P in keyof T]?: T[P];
};

export type WithOptionalNullables<T> = OptionalKeys<WithNullableKeys<T>> & WithNonNullableKeys<T>;

export type ComposableSelector<T extends keyof ValueTypes> = ReturnType<SelectionFunction<ValueTypes[T]>>;

export type Variable<T extends GraphQLVariableType, Name extends string> = {
  ' __zeus_name': Name;
  ' __zeus_type': T;
};

export type ExtractVariablesDeep<Query> = Query extends Variable<infer VType, infer VName>
  ? { [key in VName]: GetVariableType<VType> }
  : Query extends string | number | boolean | Array<string | number | boolean>
  ? // eslint-disable-next-line @typescript-eslint/ban-types
    {}
  : UnionToIntersection<{ [K in keyof Query]: WithOptionalNullables<ExtractVariablesDeep<Query[K]>> }[keyof Query]>;

export type ExtractVariables<Query> = Query extends Variable<infer VType, infer VName>
  ? { [key in VName]: GetVariableType<VType> }
  : Query extends [infer Inputs, infer Outputs]
  ? ExtractVariablesDeep<Inputs> & ExtractVariables<Outputs>
  : Query extends string | number | boolean | Array<string | number | boolean>
  ? // eslint-disable-next-line @typescript-eslint/ban-types
    {}
  : UnionToIntersection<{ [K in keyof Query]: WithOptionalNullables<ExtractVariables<Query[K]>> }[keyof Query]>;

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void ? I : never;

export const START_VAR_NAME = `$ZEUS_VAR`;
export const GRAPHQL_TYPE_SEPARATOR = `__$GRAPHQL__`;

export const $ = <Type extends GraphQLVariableType, Name extends string>(name: Name, graphqlType: Type) => {
  return (START_VAR_NAME + name + GRAPHQL_TYPE_SEPARATOR + graphqlType) as unknown as Variable<Type, Name>;
};
type ZEUS_INTERFACES = never
export type ScalarCoders = {
	DateTime?: ScalarResolver;
	ID?: ScalarResolver;
}
type ZEUS_UNIONS = GraphQLTypes["AuthType"]

export type ValueTypes = {
    ["Permissions"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	roles?:ValueTypes["Role"],
		__typename?: boolean | `@${string}`,
	['...on Permissions']?: Omit<ValueTypes["Permissions"], "...on Permissions">
}>;
	/** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
["DateTime"]:unknown;
	["UserGroupModel"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on UserGroupModel']?: Omit<ValueTypes["UserGroupModel"], "...on UserGroupModel">
}>;
	["Users"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	emailVerified?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	company?:boolean | `@${string}`,
	department?:boolean | `@${string}`,
	lastConnectionAt?:boolean | `@${string}`,
	role?:ValueTypes["Role"],
	roleId?:boolean | `@${string}`,
	groups?:ValueTypes["UserGroupModel"],
		__typename?: boolean | `@${string}`,
	['...on Users']?: Omit<ValueTypes["Users"], "...on Users">
}>;
	["AccountStatus"]:AccountStatus;
	["UserPagination"]: AliasType<{
	users?:ValueTypes["Users"],
	total?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on UserPagination']?: Omit<ValueTypes["UserPagination"], "...on UserPagination">
}>;
	["ImportUserError"]: AliasType<{
	line?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	reason?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ImportUserError']?: Omit<ValueTypes["ImportUserError"], "...on ImportUserError">
}>;
	["ImportUsersReport"]: AliasType<{
	createdCount?:boolean | `@${string}`,
	errorCount?:boolean | `@${string}`,
	errors?:ValueTypes["ImportUserError"],
		__typename?: boolean | `@${string}`,
	['...on ImportUsersReport']?: Omit<ValueTypes["ImportUsersReport"], "...on ImportUsersReport">
}>;
	["Role"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	permissions?:ValueTypes["Permissions"],
	users?:ValueTypes["Users"],
		__typename?: boolean | `@${string}`,
	['...on Role']?: Omit<ValueTypes["Role"], "...on Role">
}>;
	["DisabilityReferentModel"]: AliasType<{
	name?:boolean | `@${string}`,
	contact?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on DisabilityReferentModel']?: Omit<ValueTypes["DisabilityReferentModel"], "...on DisabilityReferentModel">
}>;
	["AccommodationRequestModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	needs?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	response?:boolean | `@${string}`,
	handledAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on AccommodationRequestModel']?: Omit<ValueTypes["AccommodationRequestModel"], "...on AccommodationRequestModel">
}>;
	["AccommodationStatus"]:AccommodationStatus;
	["OrgAccommodationRequestModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	needs?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	response?:boolean | `@${string}`,
	handledAt?:boolean | `@${string}`,
	learnerName?:boolean | `@${string}`,
	learnerEmail?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on OrgAccommodationRequestModel']?: Omit<ValueTypes["OrgAccommodationRequestModel"], "...on OrgAccommodationRequestModel">
}>;
	["MyAccommodationModel"]: AliasType<{
	referent?:ValueTypes["DisabilityReferentModel"],
	request?:ValueTypes["AccommodationRequestModel"],
		__typename?: boolean | `@${string}`,
	['...on MyAccommodationModel']?: Omit<ValueTypes["MyAccommodationModel"], "...on MyAccommodationModel">
}>;
	["UniqueAuth"]: AliasType<{
	access_token?:boolean | `@${string}`,
	refresh_token?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on UniqueAuth']?: Omit<ValueTypes["UniqueAuth"], "...on UniqueAuth">
}>;
	["Invitation"]: AliasType<{
	status?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on Invitation']?: Omit<ValueTypes["Invitation"], "...on Invitation">
}>;
	["InvitationStatus"]:InvitationStatus;
	["UserInfo"]: AliasType<{
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	roles?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	orgId?:boolean | `@${string}`,
	impersonatorId?:boolean | `@${string}`,
	capabilities?:boolean | `@${string}`,
	orgSlug?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on UserInfo']?: Omit<ValueTypes["UserInfo"], "...on UserInfo">
}>;
	["RoleEnum"]:RoleEnum;
	/** Ce que le rôle Formateur peut faire, réglable par organisation (#11) */
["TrainerCapability"]:TrainerCapability;
	["Mail"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	key?:boolean | `@${string}`,
	to?:boolean | `@${string}`,
	data?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on Mail']?: Omit<ValueTypes["Mail"], "...on Mail">
}>;
	["BillingAccountModel"]: AliasType<{
	id?:boolean | `@${string}`,
	tier?:boolean | `@${string}`,
	paymentTerm?:boolean | `@${string}`,
	mode?:boolean | `@${string}`,
	tierChangedAt?:boolean | `@${string}`,
	subscriptionStatus?:boolean | `@${string}`,
	currentPeriodEnd?:boolean | `@${string}`,
	cancelAtPeriodEnd?:boolean | `@${string}`,
	scheduledTier?:boolean | `@${string}`,
	scheduledPaymentTerm?:boolean | `@${string}`,
	scheduledChangeAt?:boolean | `@${string}`,
	cancelAt?:boolean | `@${string}`,
	companyName?:boolean | `@${string}`,
	addressLine1?:boolean | `@${string}`,
	addressLine2?:boolean | `@${string}`,
	postalCode?:boolean | `@${string}`,
	city?:boolean | `@${string}`,
	country?:boolean | `@${string}`,
	vatNumber?:boolean | `@${string}`,
	billingEmail?:boolean | `@${string}`,
	subscribed?:boolean | `@${string}`,
	billingPortalAvailable?:boolean | `@${string}`,
	paymentFailed?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on BillingAccountModel']?: Omit<ValueTypes["BillingAccountModel"], "...on BillingAccountModel">
}>;
	["BillingTier"]:BillingTier;
	["BillingPaymentTerm"]:BillingPaymentTerm;
	["BillingMode"]:BillingMode;
	["BillingOfferModel"]: AliasType<{
	tier?:boolean | `@${string}`,
	capacity?:boolean | `@${string}`,
	monthlyPriceCents?:boolean | `@${string}`,
	upfrontYearlyAmountCents?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on BillingOfferModel']?: Omit<ValueTypes["BillingOfferModel"], "...on BillingOfferModel">
}>;
	["LearnerCountersModel"]: AliasType<{
	orgId?:boolean | `@${string}`,
	orgName?:boolean | `@${string}`,
	orgSlug?:boolean | `@${string}`,
	month?:boolean | `@${string}`,
	monthlyActive?:boolean | `@${string}`,
	learnerCount?:boolean | `@${string}`,
	registeredLearners?:boolean | `@${string}`,
	leavingWithinThreeMonths?:boolean | `@${string}`,
	subscribedTier?:boolean | `@${string}`,
	effectiveTier?:boolean | `@${string}`,
	billedTier?:boolean | `@${string}`,
	placesRemaining?:boolean | `@${string}`,
	nextTier?:boolean | `@${string}`,
	paymentTerm?:boolean | `@${string}`,
	estimatedRevenueCents?:boolean | `@${string}`,
	managed?:boolean | `@${string}`,
	overCapacity?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on LearnerCountersModel']?: Omit<ValueTypes["LearnerCountersModel"], "...on LearnerCountersModel">
}>;
	["BillingEstimateModel"]: AliasType<{
	month?:boolean | `@${string}`,
	subscribedTier?:boolean | `@${string}`,
	effectiveTier?:boolean | `@${string}`,
	billedTier?:boolean | `@${string}`,
	paymentTerm?:boolean | `@${string}`,
	learnerCount?:boolean | `@${string}`,
	monthlyActive?:boolean | `@${string}`,
	registeredLearners?:boolean | `@${string}`,
	placesRemaining?:boolean | `@${string}`,
	nextTier?:boolean | `@${string}`,
	leavingWithinThreeMonths?:boolean | `@${string}`,
	monthlyPriceCents?:boolean | `@${string}`,
	monthlyAmountCents?:boolean | `@${string}`,
	upfrontYearlyAmountCents?:boolean | `@${string}`,
	isCustom?:boolean | `@${string}`,
	managed?:boolean | `@${string}`,
	overCapacity?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on BillingEstimateModel']?: Omit<ValueTypes["BillingEstimateModel"], "...on BillingEstimateModel">
}>;
	["BillingHistoryEntryModel"]: AliasType<{
	month?:boolean | `@${string}`,
	monthlyActive?:boolean | `@${string}`,
	learnerCount?:boolean | `@${string}`,
	tier?:boolean | `@${string}`,
	amountCents?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on BillingHistoryEntryModel']?: Omit<ValueTypes["BillingHistoryEntryModel"], "...on BillingHistoryEntryModel">
}>;
	["CapacityAlertModel"]: AliasType<{
	learnerCount?:boolean | `@${string}`,
	tier?:boolean | `@${string}`,
	neededTier?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on CapacityAlertModel']?: Omit<ValueTypes["CapacityAlertModel"], "...on CapacityAlertModel">
}>;
	["MyAccount"]: AliasType<{
	id?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
	organizationName?:boolean | `@${string}`,
	lastConnectionAt?:boolean | `@${string}`,
	hasPassword?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on MyAccount']?: Omit<ValueTypes["MyAccount"], "...on MyAccount">
}>;
	["AppConfigModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	appName?:boolean | `@${string}`,
	logo?:boolean | `@${string}`,
	logoDark?:boolean | `@${string}`,
	favicon?:boolean | `@${string}`,
	primaryColor?:boolean | `@${string}`,
	primaryForeground?:boolean | `@${string}`,
	accentColor?:boolean | `@${string}`,
	accentForeground?:boolean | `@${string}`,
	footerText?:boolean | `@${string}`,
	defaultLocale?:boolean | `@${string}`,
	timezone?:boolean | `@${string}`,
	signupCtaVisible?:boolean | `@${string}`,
	billingSelfService?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on AppConfigModel']?: Omit<ValueTypes["AppConfigModel"], "...on AppConfigModel">
}>;
	["TrainerCapabilityModel"]: AliasType<{
	capability?:boolean | `@${string}`,
	granted?:boolean | `@${string}`,
	dependsOn?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on TrainerCapabilityModel']?: Omit<ValueTypes["TrainerCapabilityModel"], "...on TrainerCapabilityModel">
}>;
	["GroupMemberModel"]: AliasType<{
	id?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on GroupMemberModel']?: Omit<ValueTypes["GroupMemberModel"], "...on GroupMemberModel">
}>;
	["GroupModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	memberCount?:boolean | `@${string}`,
	members?:ValueTypes["GroupMemberModel"],
	memberIds?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on GroupModel']?: Omit<ValueTypes["GroupModel"], "...on GroupModel">
}>;
	["LoginEventModel"]: AliasType<{
	id?:boolean | `@${string}`,
	at?:boolean | `@${string}`,
	method?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on LoginEventModel']?: Omit<ValueTypes["LoginEventModel"], "...on LoginEventModel">
}>;
	["LoginMethod"]:LoginMethod;
	["LoginEventPage"]: AliasType<{
	events?:ValueTypes["LoginEventModel"],
	total?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on LoginEventPage']?: Omit<ValueTypes["LoginEventPage"], "...on LoginEventPage">
}>;
	["LearnerProfile"]: AliasType<{
	id?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	company?:boolean | `@${string}`,
	department?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	roleName?:boolean | `@${string}`,
	roleId?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	groups?:ValueTypes["UserGroupModel"],
	trainingSeconds?:boolean | `@${string}`,
	loginCount?:boolean | `@${string}`,
	lastLoginAt?:boolean | `@${string}`,
	averageDaysBetweenLogins?:boolean | `@${string}`,
	completedModules?:boolean | `@${string}`,
	totalModules?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on LearnerProfile']?: Omit<ValueTypes["LearnerProfile"], "...on LearnerProfile">
}>;
	["UsernameCredentials"]: AliasType<{
	userId?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	password?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on UsernameCredentials']?: Omit<ValueTypes["UsernameCredentials"], "...on UsernameCredentials">
}>;
	["UsernameImportError"]: AliasType<{
	line?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	reason?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on UsernameImportError']?: Omit<ValueTypes["UsernameImportError"], "...on UsernameImportError">
}>;
	["UsernameImportReport"]: AliasType<{
	created?:ValueTypes["UsernameCredentials"],
	errors?:ValueTypes["UsernameImportError"],
		__typename?: boolean | `@${string}`,
	['...on UsernameImportReport']?: Omit<ValueTypes["UsernameImportReport"], "...on UsernameImportReport">
}>;
	["CertificateTemplateModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	isDefault?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	body?:boolean | `@${string}`,
	signature?:boolean | `@${string}`,
	showScore?:boolean | `@${string}`,
	showDate?:boolean | `@${string}`,
	showTotalTime?:boolean | `@${string}`,
	emailOnUnlock?:boolean | `@${string}`,
	logo?:boolean | `@${string}`,
	orientation?:boolean | `@${string}`,
	hasSkeleton?:boolean | `@${string}`,
	marginTop?:boolean | `@${string}`,
	marginBottom?:boolean | `@${string}`,
	marginLeft?:boolean | `@${string}`,
	marginRight?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on CertificateTemplateModel']?: Omit<ValueTypes["CertificateTemplateModel"], "...on CertificateTemplateModel">
}>;
	["CertificateOrientation"]:CertificateOrientation;
	["CertificateTemplateOptionModel"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	isDefault?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on CertificateTemplateOptionModel']?: Omit<ValueTypes["CertificateTemplateOptionModel"], "...on CertificateTemplateOptionModel">
}>;
	["ComplaintModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	category?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	origin?:boolean | `@${string}`,
	subject?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
	response?:boolean | `@${string}`,
	respondedAt?:boolean | `@${string}`,
	resolvedAt?:boolean | `@${string}`,
	authorName?:boolean | `@${string}`,
	authorEmail?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ComplaintModel']?: Omit<ValueTypes["ComplaintModel"], "...on ComplaintModel">
}>;
	/** Nature d'une demande ou réclamation (#325) ; REPORT = signalement de violence, harcèlement ou discrimination. */
["ComplaintCategory"]:ComplaintCategory;
	["ComplaintStatus"]:ComplaintStatus;
	["ComplaintOrigin"]:ComplaintOrigin;
	["TrainingDocumentModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	fileName?:boolean | `@${string}`,
	sizeBytes?:boolean | `@${string}`,
	requiredBeforeStart?:boolean | `@${string}`,
	sessionId?:boolean | `@${string}`,
	sessionName?:boolean | `@${string}`,
	acknowledgementCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on TrainingDocumentModel']?: Omit<ValueTypes["TrainingDocumentModel"], "...on TrainingDocumentModel">
}>;
	["DocumentAcknowledgementModel"]: AliasType<{
	at?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on DocumentAcknowledgementModel']?: Omit<ValueTypes["DocumentAcknowledgementModel"], "...on DocumentAcknowledgementModel">
}>;
	["DownloadFile"]: AliasType<{
	fileName?:boolean | `@${string}`,
	fileMimeType?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on DownloadFile']?: Omit<ValueTypes["DownloadFile"], "...on DownloadFile">
}>;
	["MyFiles"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	eTag?:boolean | `@${string}`,
	location?:boolean | `@${string}`,
	fileName?:boolean | `@${string}`,
	fileMimeType?:boolean | `@${string}`,
	ownerId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on MyFiles']?: Omit<ValueTypes["MyFiles"], "...on MyFiles">
}>;
	["UploadPreSignedUrl"]: AliasType<{
	url?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on UploadPreSignedUrl']?: Omit<ValueTypes["UploadPreSignedUrl"], "...on UploadPreSignedUrl">
}>;
	["HomeCompletionModel"]: AliasType<{
	sessionId?:boolean | `@${string}`,
	sessionName?:boolean | `@${string}`,
	moduleId?:boolean | `@${string}`,
	moduleTitle?:boolean | `@${string}`,
	learners?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on HomeCompletionModel']?: Omit<ValueTypes["HomeCompletionModel"], "...on HomeCompletionModel">
}>;
	["HomeSessionModel"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	startDate?:boolean | `@${string}`,
	endDate?:boolean | `@${string}`,
	enrolledLearners?:boolean | `@${string}`,
	pendingLearners?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on HomeSessionModel']?: Omit<ValueTypes["HomeSessionModel"], "...on HomeSessionModel">
}>;
	["BackOfficeHomeModel"]: AliasType<{
	firstName?:boolean | `@${string}`,
	timezone?:boolean | `@${string}`,
	completedToday?:ValueTypes["HomeCompletionModel"],
	startingSoon?:ValueTypes["HomeSessionModel"],
	endingSoon?:ValueTypes["HomeSessionModel"],
	overdue?:ValueTypes["HomeSessionModel"],
	overdueLearners?:boolean | `@${string}`,
	overdueSessions?:boolean | `@${string}`,
	neverStartedLearners?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on BackOfficeHomeModel']?: Omit<ValueTypes["BackOfficeHomeModel"], "...on BackOfficeHomeModel">
}>;
	["OrganizationModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	slug?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	userCount?:boolean | `@${string}`,
	tier?:boolean | `@${string}`,
	billingMode?:boolean | `@${string}`,
	billingNote?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on OrganizationModel']?: Omit<ValueTypes["OrganizationModel"], "...on OrganizationModel">
}>;
	["OrganizationStatus"]:OrganizationStatus;
	["OrgMemberModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on OrgMemberModel']?: Omit<ValueTypes["OrgMemberModel"], "...on OrgMemberModel">
}>;
	["PositioningRatingModel"]: AliasType<{
	objective?:boolean | `@${string}`,
	level?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on PositioningRatingModel']?: Omit<ValueTypes["PositioningRatingModel"], "...on PositioningRatingModel">
}>;
	["PositioningAnswerModel"]: AliasType<{
	answeredAt?:boolean | `@${string}`,
	ratings?:ValueTypes["PositioningRatingModel"],
	needs?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on PositioningAnswerModel']?: Omit<ValueTypes["PositioningAnswerModel"], "...on PositioningAnswerModel">
}>;
	["SessionPositioningModel"]: AliasType<{
	sessionId?:boolean | `@${string}`,
	sessionName?:boolean | `@${string}`,
	entry?:ValueTypes["PositioningAnswerModel"],
	exit?:ValueTypes["PositioningAnswerModel"],
		__typename?: boolean | `@${string}`,
	['...on SessionPositioningModel']?: Omit<ValueTypes["SessionPositioningModel"], "...on SessionPositioningModel">
}>;
	["ImprovementActionModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	origin?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	owner?:boolean | `@${string}`,
	dueDate?:boolean | `@${string}`,
	effect?:boolean | `@${string}`,
	doneAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ImprovementActionModel']?: Omit<ValueTypes["ImprovementActionModel"], "...on ImprovementActionModel">
}>;
	/** Le retour qui a fait naître une action d'amélioration (#328). */
["ImprovementOrigin"]:ImprovementOrigin;
	["ImprovementStatus"]:ImprovementStatus;
	["QualityRiskModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	/** Probabilité, de 1 (faible) à 3 (forte). */
	likelihood?:boolean | `@${string}`,
	/** Impact, de 1 (faible) à 3 (fort). */
	impact?:boolean | `@${string}`,
	/** Gravité = probabilité × impact, de 1 à 9. */
	severity?:boolean | `@${string}`,
	mitigation?:boolean | `@${string}`,
	owner?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on QualityRiskModel']?: Omit<ValueTypes["QualityRiskModel"], "...on QualityRiskModel">
}>;
	["QualityRiskStatus"]:QualityRiskStatus;
	["ReminderSettingsModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	enabled?:boolean | `@${string}`,
	firstDelayDays?:boolean | `@${string}`,
	frequencyDays?:boolean | `@${string}`,
	maxReminders?:boolean | `@${string}`,
	sendHour?:boolean | `@${string}`,
	subject?:boolean | `@${string}`,
	body?:boolean | `@${string}`,
	completionDigestEnabled?:boolean | `@${string}`,
	convocationEnabled?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ReminderSettingsModel']?: Omit<ValueTypes["ReminderSettingsModel"], "...on ReminderSettingsModel">
}>;
	["ReminderTestResultModel"]: AliasType<{
	sent?:boolean | `@${string}`,
	to?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ReminderTestResultModel']?: Omit<ValueTypes["ReminderTestResultModel"], "...on ReminderTestResultModel">
}>;
	["ReportPeriodModel"]: AliasType<{
	kind?:boolean | `@${string}`,
	from?:boolean | `@${string}`,
	to?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ReportPeriodModel']?: Omit<ValueTypes["ReportPeriodModel"], "...on ReportPeriodModel">
}>;
	["ReportPeriodKind"]:ReportPeriodKind;
	["ReportFiltersModel"]: AliasType<{
	sessionIds?:boolean | `@${string}`,
	groupIds?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
	period?:ValueTypes["ReportPeriodModel"],
		__typename?: boolean | `@${string}`,
	['...on ReportFiltersModel']?: Omit<ValueTypes["ReportFiltersModel"], "...on ReportFiltersModel">
}>;
	["UserProgress"]:UserProgress;
	["ReportScheduleModel"]: AliasType<{
	frequency?:boolean | `@${string}`,
	weekday?:boolean | `@${string}`,
	monthDay?:boolean | `@${string}`,
	hour?:boolean | `@${string}`,
	recipientIds?:boolean | `@${string}`,
	enabled?:boolean | `@${string}`,
	lastSentAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ReportScheduleModel']?: Omit<ValueTypes["ReportScheduleModel"], "...on ReportScheduleModel">
}>;
	["ReportFrequency"]:ReportFrequency;
	["ReportTemplateModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	granularity?:boolean | `@${string}`,
	columns?:boolean | `@${string}`,
	filters?:ValueTypes["ReportFiltersModel"],
	schedule?:ValueTypes["ReportScheduleModel"],
		__typename?: boolean | `@${string}`,
	['...on ReportTemplateModel']?: Omit<ValueTypes["ReportTemplateModel"], "...on ReportTemplateModel">
}>;
	/** Ce qu'est une ligne du rapport (#163). */
["ReportGranularity"]:ReportGranularity;
	["ReportColumnLabelModel"]: AliasType<{
	fr?:boolean | `@${string}`,
	en?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ReportColumnLabelModel']?: Omit<ValueTypes["ReportColumnLabelModel"], "...on ReportColumnLabelModel">
}>;
	["ReportColumnModel"]: AliasType<{
	key?:boolean | `@${string}`,
	level?:boolean | `@${string}`,
	label?:ValueTypes["ReportColumnLabelModel"],
		__typename?: boolean | `@${string}`,
	['...on ReportColumnModel']?: Omit<ValueTypes["ReportColumnModel"], "...on ReportColumnModel">
}>;
	["ReportRecipientModel"]: AliasType<{
	id?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ReportRecipientModel']?: Omit<ValueTypes["ReportRecipientModel"], "...on ReportRecipientModel">
}>;
	["StorageUsageModel"]: AliasType<{
	orgId?:boolean | `@${string}`,
	orgName?:boolean | `@${string}`,
	orgSlug?:boolean | `@${string}`,
	usedBytes?:boolean | `@${string}`,
	quotaBytes?:boolean | `@${string}`,
	remainingBytes?:boolean | `@${string}`,
	plan?:boolean | `@${string}`,
	moduleCount?:boolean | `@${string}`,
	overQuota?:boolean | `@${string}`,
	maxUploadBytes?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on StorageUsageModel']?: Omit<ValueTypes["StorageUsageModel"], "...on StorageUsageModel">
}>;
	["ScormModuleModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	scormVersion?:boolean | `@${string}`,
	launchUrl?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	masteryScore?:boolean | `@${string}`,
	durationMinutes?:boolean | `@${string}`,
	sizeBytes?:boolean | `@${string}`,
	contentUpdatedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ScormModuleModel']?: Omit<ValueTypes["ScormModuleModel"], "...on ScormModuleModel">
}>;
	["ScormModuleStatus"]:ScormModuleStatus;
	["ScormScoModel"]: AliasType<{
	identifier?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	href?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
	masteryScore?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ScormScoModel']?: Omit<ValueTypes["ScormScoModel"], "...on ScormScoModel">
}>;
	["ScoreCorrectionModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	score?:boolean | `@${string}`,
	previousScore?:boolean | `@${string}`,
	reason?:boolean | `@${string}`,
	correctedBy?:boolean | `@${string}`,
	revokedAt?:boolean | `@${string}`,
	revokedBy?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ScoreCorrectionModel']?: Omit<ValueTypes["ScoreCorrectionModel"], "...on ScoreCorrectionModel">
}>;
	["ScormInteractionModel"]: AliasType<{
	scoIdentifier?:boolean | `@${string}`,
	index?:boolean | `@${string}`,
	interactionId?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	correctResponses?:boolean | `@${string}`,
	learnerResponse?:boolean | `@${string}`,
	result?:boolean | `@${string}`,
	weighting?:boolean | `@${string}`,
	latency?:boolean | `@${string}`,
	timestamp?:boolean | `@${string}`,
	objectiveIds?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ScormInteractionModel']?: Omit<ValueTypes["ScormInteractionModel"], "...on ScormInteractionModel">
}>;
	["QuestionAnswerModel"]: AliasType<{
	userId?:boolean | `@${string}`,
	response?:boolean | `@${string}`,
	result?:boolean | `@${string}`,
	score?:boolean | `@${string}`,
	attemptNumber?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on QuestionAnswerModel']?: Omit<ValueTypes["QuestionAnswerModel"], "...on QuestionAnswerModel">
}>;
	["QuestionStatModel"]: AliasType<{
	scoIdentifier?:boolean | `@${string}`,
	interactionId?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	correctResponses?:boolean | `@${string}`,
	respondents?:boolean | `@${string}`,
	correctRate?:boolean | `@${string}`,
	averageScore?:boolean | `@${string}`,
	buckets?:boolean | `@${string}`,
	answers?:ValueTypes["QuestionAnswerModel"],
		__typename?: boolean | `@${string}`,
	['...on QuestionStatModel']?: Omit<ValueTypes["QuestionStatModel"], "...on QuestionStatModel">
}>;
	["QuestionLearnerModel"]: AliasType<{
	id?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on QuestionLearnerModel']?: Omit<ValueTypes["QuestionLearnerModel"], "...on QuestionLearnerModel">
}>;
	["ModuleQuestionStatsModel"]: AliasType<{
	questions?:ValueTypes["QuestionStatModel"],
	learners?:ValueTypes["QuestionLearnerModel"],
		__typename?: boolean | `@${string}`,
	['...on ModuleQuestionStatsModel']?: Omit<ValueTypes["ModuleQuestionStatsModel"], "...on ModuleQuestionStatsModel">
}>;
	["LearnerAttemptModel"]: AliasType<{
	sessionId?:boolean | `@${string}`,
	sessionName?:boolean | `@${string}`,
	number?:boolean | `@${string}`,
	completionStatus?:boolean | `@${string}`,
	successStatus?:boolean | `@${string}`,
	scoreRaw?:boolean | `@${string}`,
	scoreMax?:boolean | `@${string}`,
	scoreScaled?:boolean | `@${string}`,
	totalTime?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	interactions?:ValueTypes["ScormInteractionModel"],
		__typename?: boolean | `@${string}`,
	['...on LearnerAttemptModel']?: Omit<ValueTypes["LearnerAttemptModel"], "...on LearnerAttemptModel">
}>;
	["ScormCompletionStatus"]:ScormCompletionStatus;
	["ScormSuccessStatus"]:ScormSuccessStatus;
	["ScormScoStateModel"]: AliasType<{
	scoIdentifier?:boolean | `@${string}`,
	completionStatus?:boolean | `@${string}`,
	successStatus?:boolean | `@${string}`,
	scoreRaw?:boolean | `@${string}`,
	scoreMin?:boolean | `@${string}`,
	scoreMax?:boolean | `@${string}`,
	scoreScaled?:boolean | `@${string}`,
	totalTime?:boolean | `@${string}`,
	suspendData?:boolean | `@${string}`,
	location?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ScormScoStateModel']?: Omit<ValueTypes["ScormScoStateModel"], "...on ScormScoStateModel">
}>;
	["ScormAttemptModel"]: AliasType<{
	number?:boolean | `@${string}`,
	completionStatus?:boolean | `@${string}`,
	successStatus?:boolean | `@${string}`,
	scoreRaw?:boolean | `@${string}`,
	scoreMin?:boolean | `@${string}`,
	scoreMax?:boolean | `@${string}`,
	scoreScaled?:boolean | `@${string}`,
	totalTime?:boolean | `@${string}`,
	interactions?:ValueTypes["ScormInteractionModel"],
	scoStates?:ValueTypes["ScormScoStateModel"],
		__typename?: boolean | `@${string}`,
	['...on ScormAttemptModel']?: Omit<ValueTypes["ScormAttemptModel"], "...on ScormAttemptModel">
}>;
	["ScormTrackingModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	completionStatus?:boolean | `@${string}`,
	successStatus?:boolean | `@${string}`,
	scoreRaw?:boolean | `@${string}`,
	scoreMin?:boolean | `@${string}`,
	scoreMax?:boolean | `@${string}`,
	scoreScaled?:boolean | `@${string}`,
	totalTime?:boolean | `@${string}`,
	totalTimeSeconds?:boolean | `@${string}`,
	sessionTime?:boolean | `@${string}`,
	suspendData?:boolean | `@${string}`,
	location?:boolean | `@${string}`,
	completedAt?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
	sessionId?:boolean | `@${string}`,
	attemptNumber?:boolean | `@${string}`,
	currentAttempt?:ValueTypes["ScormAttemptModel"],
	currentScoIdentifier?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ScormTrackingModel']?: Omit<ValueTypes["ScormTrackingModel"], "...on ScormTrackingModel">
}>;
	["ScormTrackingWithUser"]: AliasType<{
	id?:boolean | `@${string}`,
	correctedScore?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	completionStatus?:boolean | `@${string}`,
	successStatus?:boolean | `@${string}`,
	scoreRaw?:boolean | `@${string}`,
	scoreMin?:boolean | `@${string}`,
	scoreMax?:boolean | `@${string}`,
	scoreScaled?:boolean | `@${string}`,
	totalTime?:boolean | `@${string}`,
	sessionTime?:boolean | `@${string}`,
	suspendData?:boolean | `@${string}`,
	location?:boolean | `@${string}`,
	completedAt?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
	userEmail?:boolean | `@${string}`,
	userUsername?:boolean | `@${string}`,
	userFirstName?:boolean | `@${string}`,
	userLastName?:boolean | `@${string}`,
	sessionId?:boolean | `@${string}`,
	sessionName?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ScormTrackingWithUser']?: Omit<ValueTypes["ScormTrackingWithUser"], "...on ScormTrackingWithUser">
}>;
	["ScormTrackingStats"]: AliasType<{
	total?:boolean | `@${string}`,
	learners?:boolean | `@${string}`,
	completed?:boolean | `@${string}`,
	inProgress?:boolean | `@${string}`,
	notStarted?:boolean | `@${string}`,
	completionUnknown?:boolean | `@${string}`,
	neverOpened?:boolean | `@${string}`,
	notYetUnlocked?:boolean | `@${string}`,
	passed?:boolean | `@${string}`,
	failed?:boolean | `@${string}`,
	averageScorePercent?:boolean | `@${string}`,
	scoredCount?:boolean | `@${string}`,
	averageTimeSeconds?:boolean | `@${string}`,
	timedCount?:boolean | `@${string}`,
	totalTimeSeconds?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ScormTrackingStats']?: Omit<ValueTypes["ScormTrackingStats"], "...on ScormTrackingStats">
}>;
	["ScormCompletionPoint"]: AliasType<{
	day?:boolean | `@${string}`,
	completed?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ScormCompletionPoint']?: Omit<ValueTypes["ScormCompletionPoint"], "...on ScormCompletionPoint">
}>;
	["ScormTrackingPagination"]: AliasType<{
	trackings?:ValueTypes["ScormTrackingWithUser"],
	total?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ScormTrackingPagination']?: Omit<ValueTypes["ScormTrackingPagination"], "...on ScormTrackingPagination">
}>;
	["SessionParticipantResult"]: AliasType<{
	userId?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	groups?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
	completedModules?:boolean | `@${string}`,
	totalModules?:boolean | `@${string}`,
	averageScorePercent?:boolean | `@${string}`,
	timeSpentSeconds?:boolean | `@${string}`,
	lastActivityAt?:boolean | `@${string}`,
	droppedAt?:boolean | `@${string}`,
	dropReason?:boolean | `@${string}`,
	dropNote?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on SessionParticipantResult']?: Omit<ValueTypes["SessionParticipantResult"], "...on SessionParticipantResult">
}>;
	/** Motif d'un abandon déclaré par l'organisme (#324). */
["DropoutReason"]:DropoutReason;
	["SessionModuleResult"]: AliasType<{
	moduleId?:boolean | `@${string}`,
	completedCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on SessionModuleResult']?: Omit<ValueTypes["SessionModuleResult"], "...on SessionModuleResult">
}>;
	["SessionResults"]: AliasType<{
	stats?:ValueTypes["ScormTrackingStats"],
	participants?:ValueTypes["SessionParticipantResult"],
	modules?:ValueTypes["SessionModuleResult"],
		__typename?: boolean | `@${string}`,
	['...on SessionResults']?: Omit<ValueTypes["SessionResults"], "...on SessionResults">
}>;
	["LearnerDocumentModel"]: AliasType<{
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	requiredBeforeStart?:boolean | `@${string}`,
	acknowledgedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on LearnerDocumentModel']?: Omit<ValueTypes["LearnerDocumentModel"], "...on LearnerDocumentModel">
}>;
	["LearnerPositioningModel"]: AliasType<{
	required?:boolean | `@${string}`,
	entryPending?:boolean | `@${string}`,
	entryDone?:boolean | `@${string}`,
	exitDone?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on LearnerPositioningModel']?: Omit<ValueTypes["LearnerPositioningModel"], "...on LearnerPositioningModel">
}>;
	["SessionUserModel"]: AliasType<{
	id?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on SessionUserModel']?: Omit<ValueTypes["SessionUserModel"], "...on SessionUserModel">
}>;
	["SessionTrainerModel"]: AliasType<{
	id?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
	assignedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on SessionTrainerModel']?: Omit<ValueTypes["SessionTrainerModel"], "...on SessionTrainerModel">
}>;
	["SessionSectionModel"]: AliasType<{
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on SessionSectionModel']?: Omit<ValueTypes["SessionSectionModel"], "...on SessionSectionModel">
}>;
	["SessionModuleModel"]: AliasType<{
	id?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
	unlockAt?:boolean | `@${string}`,
	prerequisiteModuleId?:boolean | `@${string}`,
	prerequisiteMinScore?:boolean | `@${string}`,
	allowRetake?:boolean | `@${string}`,
	scoreRetention?:boolean | `@${string}`,
	sectionId?:boolean | `@${string}`,
	module?:ValueTypes["ScormModuleModel"],
	unlocked?:boolean | `@${string}`,
	lockReason?:boolean | `@${string}`,
	myTracking?:ValueTypes["ScormTrackingModel"],
		__typename?: boolean | `@${string}`,
	['...on SessionModuleModel']?: Omit<ValueTypes["SessionModuleModel"], "...on SessionModuleModel">
}>;
	/** Score retenu quand un apprenant refait un module : meilleur, dernier ou moyenne (#84) */
["ScoreRetention"]:ScoreRetention;
	/** Pourquoi un module est fermé — une date à attendre, ou un module à finir. */
["ModuleLockReason"]:ModuleLockReason;
	["SessionProgressModel"]: AliasType<{
	totalModules?:boolean | `@${string}`,
	completedModules?:boolean | `@${string}`,
	completed?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on SessionProgressModel']?: Omit<ValueTypes["SessionProgressModel"], "...on SessionProgressModel">
}>;
	["SessionTagModel"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on SessionTagModel']?: Omit<ValueTypes["SessionTagModel"], "...on SessionTagModel">
}>;
	["SessionCertificateModel"]: AliasType<{
	unlocked?:boolean | `@${string}`,
	reason?:boolean | `@${string}`,
	blockingModuleIds?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on SessionCertificateModel']?: Omit<ValueTypes["SessionCertificateModel"], "...on SessionCertificateModel">
}>;
	/** Pourquoi l'attestation est verrouillée : modules à terminer, à réussir, ou sous le seuil. */
["CertificateLockReason"]:CertificateLockReason;
	["SessionModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	objectives?:boolean | `@${string}`,
	prerequisites?:boolean | `@${string}`,
	audience?:boolean | `@${string}`,
	teachingMethods?:boolean | `@${string}`,
	assessmentMethods?:boolean | `@${string}`,
	accessibility?:boolean | `@${string}`,
	contact?:boolean | `@${string}`,
	startDate?:boolean | `@${string}`,
	endDate?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	progressionMode?:boolean | `@${string}`,
	certificateCondition?:boolean | `@${string}`,
	certificateMinScore?:boolean | `@${string}`,
	certificateTemplateId?:boolean | `@${string}`,
	module?:ValueTypes["ScormModuleModel"],
	modules?:ValueTypes["SessionModuleModel"],
	sections?:ValueTypes["SessionSectionModel"],
	enrolledUsers?:ValueTypes["SessionUserModel"],
	tags?:ValueTypes["SessionTagModel"],
	trainers?:ValueTypes["SessionTrainerModel"],
	myTracking?:ValueTypes["ScormTrackingModel"],
	myEnrolledAt?:boolean | `@${string}`,
	progress?:ValueTypes["SessionProgressModel"],
	certificate?:ValueTypes["SessionCertificateModel"],
	positioningEnabled?:boolean | `@${string}`,
	myPositioning?:ValueTypes["LearnerPositioningModel"],
	documents?:ValueTypes["LearnerDocumentModel"],
		__typename?: boolean | `@${string}`,
	['...on SessionModel']?: Omit<ValueTypes["SessionModel"], "...on SessionModel">
}>;
	["SessionStatus"]:SessionStatus;
	/** Règle d'enchaînement du parcours. Le déblocage par date n'est pas une valeur ici : c'est un second verrou, porté par SessionModule.unlockAt. */
["SessionProgressionMode"]:SessionProgressionMode;
	/** Ce qu'exige l'attestation d'un parcours, au-delà de terminer tous ses modules (#10). */
["CertificateCondition"]:CertificateCondition;
	["RequestTrialResult"]: AliasType<{
	accepted?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on RequestTrialResult']?: Omit<ValueTypes["RequestTrialResult"], "...on RequestTrialResult">
}>;
	["ConfirmTrialResult"]: AliasType<{
	status?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	slug?:boolean | `@${string}`,
	rejectionReason?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ConfirmTrialResult']?: Omit<ValueTypes["ConfirmTrialResult"], "...on ConfirmTrialResult">
}>;
	["TrialReviewStatus"]:TrialReviewStatus;
	["TrialRequestModel"]: AliasType<{
	id?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	orgName?:boolean | `@${string}`,
	jobTitle?:boolean | `@${string}`,
	phone?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	emailConfirmedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on TrialRequestModel']?: Omit<ValueTypes["TrialRequestModel"], "...on TrialRequestModel">
}>;
	["ApproveTrialResult"]: AliasType<{
	slug?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ApproveTrialResult']?: Omit<ValueTypes["ApproveTrialResult"], "...on ApproveTrialResult">
}>;
	["SsoOrgSettingsModel"]: AliasType<{
	enabled?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on SsoOrgSettingsModel']?: Omit<ValueTypes["SsoOrgSettingsModel"], "...on SsoOrgSettingsModel">
}>;
	["SsoPresetModel"]: AliasType<{
	kind?:boolean | `@${string}`,
	protocol?:boolean | `@${string}`,
	defaultLabel?:boolean | `@${string}`,
	defaultIssuer?:boolean | `@${string}`,
	issuerHint?:boolean | `@${string}`,
	sharedIssuer?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on SsoPresetModel']?: Omit<ValueTypes["SsoPresetModel"], "...on SsoPresetModel">
}>;
	/** Fournisseur d'identité pré-listé (#40). */
["SsoProviderKind"]:SsoProviderKind;
	["SsoProviderModel"]: AliasType<{
	id?:boolean | `@${string}`,
	kind?:boolean | `@${string}`,
	protocol?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
	enabled?:boolean | `@${string}`,
	issuer?:boolean | `@${string}`,
	clientId?:boolean | `@${string}`,
	hasClientSecret?:boolean | `@${string}`,
	entryPoint?:boolean | `@${string}`,
	idpIssuer?:boolean | `@${string}`,
	idpCert?:boolean | `@${string}`,
	allowedDomains?:boolean | `@${string}`,
	requiresAllowedDomains?:boolean | `@${string}`,
	callbackUrl?:boolean | `@${string}`,
	metadataUrl?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on SsoProviderModel']?: Omit<ValueTypes["SsoProviderModel"], "...on SsoProviderModel">
}>;
	["PublicSsoProviderModel"]: AliasType<{
	id?:boolean | `@${string}`,
	kind?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
	loginUrl?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on PublicSsoProviderModel']?: Omit<ValueTypes["PublicSsoProviderModel"], "...on PublicSsoProviderModel">
}>;
	["SurveyQuestionModel"]: AliasType<{
	id?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
	kind?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
	isOverall?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on SurveyQuestionModel']?: Omit<ValueTypes["SurveyQuestionModel"], "...on SurveyQuestionModel">
}>;
	/** Note de 1 à 5, ou réponse libre (#320). */
["SurveyQuestionKind"]:SurveyQuestionKind;
	["SurveyModuleModel"]: AliasType<{
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on SurveyModuleModel']?: Omit<ValueTypes["SurveyModuleModel"], "...on SurveyModuleModel">
}>;
	["LearnerSurveyModel"]: AliasType<{
	pending?:boolean | `@${string}`,
	questions?:ValueTypes["SurveyQuestionModel"],
	modules?:ValueTypes["SurveyModuleModel"],
		__typename?: boolean | `@${string}`,
	['...on LearnerSurveyModel']?: Omit<ValueTypes["LearnerSurveyModel"], "...on LearnerSurveyModel">
}>;
	["SurveyQuestionAverageModel"]: AliasType<{
	questionId?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
	average?:boolean | `@${string}`,
	count?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on SurveyQuestionAverageModel']?: Omit<ValueTypes["SurveyQuestionAverageModel"], "...on SurveyQuestionAverageModel">
}>;
	["SurveyModuleAverageModel"]: AliasType<{
	moduleId?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	average?:boolean | `@${string}`,
	count?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on SurveyModuleAverageModel']?: Omit<ValueTypes["SurveyModuleAverageModel"], "...on SurveyModuleAverageModel">
}>;
	["SurveyCommentModel"]: AliasType<{
	label?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
	at?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on SurveyCommentModel']?: Omit<ValueTypes["SurveyCommentModel"], "...on SurveyCommentModel">
}>;
	["SurveyResultsModel"]: AliasType<{
	answered?:boolean | `@${string}`,
	skipped?:boolean | `@${string}`,
	satisfactionRate?:boolean | `@${string}`,
	questions?:ValueTypes["SurveyQuestionAverageModel"],
	modules?:ValueTypes["SurveyModuleAverageModel"],
	comments?:ValueTypes["SurveyCommentModel"],
		__typename?: boolean | `@${string}`,
	['...on SurveyResultsModel']?: Omit<ValueTypes["SurveyResultsModel"], "...on SurveyResultsModel">
}>;
	["WebhookEndpointModel"]: AliasType<{
	url?:boolean | `@${string}`,
	enabled?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on WebhookEndpointModel']?: Omit<ValueTypes["WebhookEndpointModel"], "...on WebhookEndpointModel">
}>;
	["WebhookEndpointSaveResult"]: AliasType<{
	endpoint?:ValueTypes["WebhookEndpointModel"],
	secret?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on WebhookEndpointSaveResult']?: Omit<ValueTypes["WebhookEndpointSaveResult"], "...on WebhookEndpointSaveResult">
}>;
	["WebhookDeliveryModel"]: AliasType<{
	id?:boolean | `@${string}`,
	event?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	attempts?:boolean | `@${string}`,
	lastStatusCode?:boolean | `@${string}`,
	lastError?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	nextAttemptAt?:boolean | `@${string}`,
	deliveredAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on WebhookDeliveryModel']?: Omit<ValueTypes["WebhookDeliveryModel"], "...on WebhookDeliveryModel">
}>;
	/** Où en est un appel de webhook (#5) : en file, en cours, reçu ou abandonné. */
["WebhookDeliveryStatus"]:WebhookDeliveryStatus;
	["Health"]: AliasType<{
	env?:boolean | `@${string}`,
	time?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	version?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on Health']?: Omit<ValueTypes["Health"], "...on Health">
}>;
	["StatsNotice"]: AliasType<{
	status?:boolean | `@${string}`,
	acknowledgedAt?:boolean | `@${string}`,
	version?:boolean | `@${string}`,
	currentVersion?:boolean | `@${string}`,
	needsAcknowledgement?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on StatsNotice']?: Omit<ValueTypes["StatsNotice"], "...on StatsNotice">
}>;
	["ConsentStatus"]:ConsentStatus;
	["PendingLegalDocument"]: AliasType<{
	document?:boolean | `@${string}`,
	version?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on PendingLegalDocument']?: Omit<ValueTypes["PendingLegalDocument"], "...on PendingLegalDocument">
}>;
	["LegalDocument"]:LegalDocument;
	["LegalAcceptance"]: AliasType<{
	pending?:ValueTypes["PendingLegalDocument"],
		__typename?: boolean | `@${string}`,
	['...on LegalAcceptance']?: Omit<ValueTypes["LegalAcceptance"], "...on LegalAcceptance">
}>;
	["Query"]: AliasType<{
	getHealthGql?:ValueTypes["Health"],
getRole?: [{	id: string | Variable<any, string>},ValueTypes["Role"]],
	getRoles?:ValueTypes["Role"],
getPermission?: [{	id: string | Variable<any, string>},ValueTypes["Permissions"]],
	getPermissions?:ValueTypes["Permissions"],
	trainerCapabilities?:ValueTypes["TrainerCapabilityModel"],
	webhookEndpoint?:ValueTypes["WebhookEndpointModel"],
	webhookDeliveries?:ValueTypes["WebhookDeliveryModel"],
getMail?: [{	id: string | Variable<any, string>},ValueTypes["Mail"]],
	getMails?:ValueTypes["Mail"],
	appConfig?:ValueTypes["AppConfigModel"],
learnerCounters?: [{	month?: string | undefined | null | Variable<any, string>},ValueTypes["LearnerCountersModel"]],
	capacityAlert?:ValueTypes["CapacityAlertModel"],
learnerCountersByOrganization?: [{	month?: string | undefined | null | Variable<any, string>},ValueTypes["LearnerCountersModel"]],
	billingAccount?:ValueTypes["BillingAccountModel"],
	billingOffers?:ValueTypes["BillingOfferModel"],
billingEstimate?: [{	month?: string | undefined | null | Variable<any, string>},ValueTypes["BillingEstimateModel"]],
billingHistory?: [{	months?: number | undefined | null | Variable<any, string>},ValueTypes["BillingHistoryEntryModel"]],
invitation?: [{	token: string | Variable<any, string>},ValueTypes["Invitation"]],
	me?:ValueTypes["UserInfo"],
	myAccount?:ValueTypes["MyAccount"],
	complaints?:ValueTypes["ComplaintModel"],
mySurvey?: [{	sessionId: ValueTypes["ID"] | Variable<any, string>},ValueTypes["LearnerSurveyModel"]],
	surveyQuestions?:ValueTypes["SurveyQuestionModel"],
surveyResults?: [{	sessionId: ValueTypes["ID"] | Variable<any, string>},ValueTypes["SurveyResultsModel"]],
	improvementActions?:ValueTypes["ImprovementActionModel"],
	qualityRisks?:ValueTypes["QualityRiskModel"],
learnerPositioning?: [{	userId: ValueTypes["ID"] | Variable<any, string>},ValueTypes["SessionPositioningModel"]],
	getUsers?:ValueTypes["Users"],
getExistingUserEmails?: [{	emails: Array<string> | Variable<any, string>},boolean | `@${string}`],
getFilteredUsers?: [{	findManyUserWithFiltersInput: ValueTypes["FindManyUserWithFiltersInput"] | Variable<any, string>},ValueTypes["UserPagination"]],
learnerProfile?: [{	userId: ValueTypes["ID"] | Variable<any, string>},ValueTypes["LearnerProfile"]],
learnerLogins?: [{	userId: ValueTypes["ID"] | Variable<any, string>,	skip: number | Variable<any, string>,	take: number | Variable<any, string>},ValueTypes["LoginEventPage"]],
	groups?:ValueTypes["GroupModel"],
group?: [{	id: ValueTypes["ID"] | Variable<any, string>},ValueTypes["GroupModel"]],
	trainingDocuments?:ValueTypes["TrainingDocumentModel"],
documentAcknowledgements?: [{	documentId: ValueTypes["ID"] | Variable<any, string>},ValueTypes["DocumentAcknowledgementModel"]],
	myAccommodation?:ValueTypes["MyAccommodationModel"],
	accommodationRequests?:ValueTypes["OrgAccommodationRequestModel"],
	disabilityReferent?:ValueTypes["DisabilityReferentModel"],
	ssoProviders?:ValueTypes["PublicSsoProviderModel"],
	ssoSettings?:ValueTypes["SsoOrgSettingsModel"],
	ssoPresets?:ValueTypes["SsoPresetModel"],
	ssoProviderConfigs?:ValueTypes["SsoProviderModel"],
	scormModules?:ValueTypes["ScormModuleModel"],
scormModule?: [{	id: ValueTypes["ID"] | Variable<any, string>},ValueTypes["ScormModuleModel"]],
moduleScos?: [{	moduleId: ValueTypes["ID"] | Variable<any, string>},ValueTypes["ScormScoModel"]],
	storageUsage?:ValueTypes["StorageUsageModel"],
	storageUsageByOrganization?:ValueTypes["StorageUsageModel"],
getMyScormTracking?: [{	sessionId: ValueTypes["ID"] | Variable<any, string>,	moduleId?: ValueTypes["ID"] | undefined | null | Variable<any, string>},ValueTypes["ScormTrackingModel"]],
myScormResume?: [{	sessionId: ValueTypes["ID"] | Variable<any, string>,	moduleId: ValueTypes["ID"] | Variable<any, string>},ValueTypes["ScormTrackingModel"]],
getScormTrackings?: [{	input: ValueTypes["FindManyScormTrackingWithFiltersInput"] | Variable<any, string>},ValueTypes["ScormTrackingPagination"]],
getScormTrackingStats?: [{	input: ValueTypes["ScormTrackingStatsInput"] | Variable<any, string>},ValueTypes["ScormTrackingStats"]],
getScormCompletionsByDay?: [{	input: ValueTypes["ScormTrendInput"] | Variable<any, string>},ValueTypes["ScormCompletionPoint"]],
moduleQuestionStats?: [{	input: ValueTypes["ModuleQuestionsInput"] | Variable<any, string>},ValueTypes["ModuleQuestionStatsModel"]],
learnerModuleAttempts?: [{	input: ValueTypes["LearnerModuleAttemptsInput"] | Variable<any, string>},ValueTypes["LearnerAttemptModel"]],
scoreCorrections?: [{	trackingId: ValueTypes["ID"] | Variable<any, string>},ValueTypes["ScoreCorrectionModel"]],
sessionResults?: [{	sessionId: ValueTypes["ID"] | Variable<any, string>},ValueTypes["SessionResults"]],
	sessions?:ValueTypes["SessionModel"],
session?: [{	id: ValueTypes["ID"] | Variable<any, string>},ValueTypes["SessionModel"]],
userSessions?: [{	userId: ValueTypes["ID"] | Variable<any, string>},ValueTypes["SessionModel"]],
	mySessions?:ValueTypes["SessionModel"],
	pendingTrialRequests?:ValueTypes["TrialRequestModel"],
	backOfficeHome?:ValueTypes["BackOfficeHomeModel"],
	certificateTemplates?:ValueTypes["CertificateTemplateModel"],
	certificateTemplateOptions?:ValueTypes["CertificateTemplateOptionModel"],
certificateTemplate?: [{	id?: ValueTypes["ID"] | undefined | null | Variable<any, string>},ValueTypes["CertificateTemplateModel"]],
downloadFile?: [{	eTag: string | Variable<any, string>},ValueTypes["DownloadFile"]],
	getAllMyFiles?:ValueTypes["MyFiles"],
publishBasicSubscription?: [{	from: string | Variable<any, string>,	to: string | Variable<any, string>},boolean | `@${string}`],
	myStatsNotice?:ValueTypes["StatsNotice"],
	myLegalAcceptance?:ValueTypes["LegalAcceptance"],
	organizations?:ValueTypes["OrganizationModel"],
organizationMembers?: [{	orgId: ValueTypes["ID"] | Variable<any, string>},ValueTypes["OrgMemberModel"]],
findOrganization?: [{	query: string | Variable<any, string>},boolean | `@${string}`],
	reminderSettings?:ValueTypes["ReminderSettingsModel"],
	reportTemplates?:ValueTypes["ReportTemplateModel"],
reportTemplate?: [{	id: ValueTypes["ID"] | Variable<any, string>},ValueTypes["ReportTemplateModel"]],
reportColumns?: [{	granularity: ValueTypes["ReportGranularity"] | Variable<any, string>},ValueTypes["ReportColumnModel"]],
	reportRecipients?:ValueTypes["ReportRecipientModel"],
		__typename?: boolean | `@${string}`,
	['...on Query']?: Omit<ValueTypes["Query"], "...on Query">
}>;
	["FindManyUserWithFiltersInput"]: {
	skip: number | Variable<any, string>,
	take: number | Variable<any, string>,
	searchInput: string | Variable<any, string>,
	orderBy?: ValueTypes["UserOrderByInput"] | undefined | null | Variable<any, string>,
	filterBy?: ValueTypes["UserFilterByInput"] | undefined | null | Variable<any, string>
};
	["UserOrderByInput"]: {
	email?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	firstName?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	lastName?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	lastConnectionAt?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	role?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	status?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>
};
	["OrderByEnum"]:OrderByEnum;
	["UserFilterByInput"]: {
	role?: Array<string> | undefined | null | Variable<any, string>,
	group?: Array<ValueTypes["ID"]> | undefined | null | Variable<any, string>,
	progress?: ValueTypes["UserProgress"] | undefined | null | Variable<any, string>
};
	["FindManyScormTrackingWithFiltersInput"]: {
	skip: number | Variable<any, string>,
	take: number | Variable<any, string>,
	searchInput?: string | undefined | null | Variable<any, string>,
	orderBy?: ValueTypes["ScormTrackingOrderByInput"] | undefined | null | Variable<any, string>,
	filterBy?: ValueTypes["ScormTrackingFilterByInput"] | undefined | null | Variable<any, string>
};
	["ScormTrackingOrderByInput"]: {
	userEmail?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	userFirstName?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	userLastName?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	completionStatus?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	successStatus?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	scoreRaw?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	completedAt?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>
};
	["ScormTrackingFilterByInput"]: {
	completionStatus?: ValueTypes["ScormCompletionStatus"] | undefined | null | Variable<any, string>,
	successStatus?: ValueTypes["ScormSuccessStatus"] | undefined | null | Variable<any, string>,
	sessionId?: ValueTypes["ID"] | undefined | null | Variable<any, string>,
	groupId?: ValueTypes["ID"] | undefined | null | Variable<any, string>
};
	["ScormTrackingStatsInput"]: {
	searchInput?: string | undefined | null | Variable<any, string>,
	filterBy?: ValueTypes["ScormStatsScopeInput"] | undefined | null | Variable<any, string>
};
	["ScormStatsScopeInput"]: {
	sessionId?: ValueTypes["ID"] | undefined | null | Variable<any, string>,
	groupId?: ValueTypes["ID"] | undefined | null | Variable<any, string>
};
	["ScormTrendInput"]: {
	days?: number | undefined | null | Variable<any, string>,
	filterBy?: ValueTypes["ScormStatsScopeInput"] | undefined | null | Variable<any, string>
};
	["ModuleQuestionsInput"]: {
	moduleId: ValueTypes["ID"] | Variable<any, string>,
	sessionId?: ValueTypes["ID"] | undefined | null | Variable<any, string>,
	groupId?: ValueTypes["ID"] | undefined | null | Variable<any, string>,
	from?: string | undefined | null | Variable<any, string>,
	to?: string | undefined | null | Variable<any, string>
};
	["LearnerModuleAttemptsInput"]: {
	userId: ValueTypes["ID"] | Variable<any, string>,
	moduleId: ValueTypes["ID"] | Variable<any, string>,
	sessionId?: ValueTypes["ID"] | undefined | null | Variable<any, string>
};
	["Mutation"]: AliasType<{
updateTrainerCapabilities?: [{	grants: Array<ValueTypes["TrainerCapabilityGrantInput"]> | Variable<any, string>},ValueTypes["TrainerCapabilityModel"]],
saveWebhookEndpoint?: [{	input: ValueTypes["SaveWebhookEndpointInput"] | Variable<any, string>},ValueTypes["WebhookEndpointSaveResult"]],
	regenerateWebhookSecret?:boolean | `@${string}`,
	sendWebhookTest?:boolean | `@${string}`,
updateAppConfig?: [{	input: ValueTypes["UpdateAppConfigInput"] | Variable<any, string>},ValueTypes["AppConfigModel"]],
updateBillingProfile?: [{	input: ValueTypes["UpdateBillingProfileInput"] | Variable<any, string>},ValueTypes["BillingAccountModel"]],
startCheckout?: [{	input: ValueTypes["StartCheckoutInput"] | Variable<any, string>},boolean | `@${string}`],
	openBillingPortal?:boolean | `@${string}`,
setOrganizationPlan?: [{	orgId: ValueTypes["ID"] | Variable<any, string>,	input: ValueTypes["ChangeBillingPlanInput"] | Variable<any, string>},ValueTypes["BillingAccountModel"]],
setOrganizationBillingMode?: [{	orgId: ValueTypes["ID"] | Variable<any, string>,	input: ValueTypes["SetBillingModeInput"] | Variable<any, string>},ValueTypes["BillingAccountModel"]],
login?: [{	/** E-mail, or username of a learner without email */
	identifier: string | Variable<any, string>,	password: string | Variable<any, string>},ValueTypes["AuthType"]],
requestMagicLink?: [{	email: string | Variable<any, string>},boolean | `@${string}`],
loginWithMagicLink?: [{	token: string | Variable<any, string>},ValueTypes["AuthType"]],
askForResetPassword?: [{	email: string | Variable<any, string>},boolean | `@${string}`],
reSendEmailValidation?: [{	email: string | Variable<any, string>},boolean | `@${string}`],
resetPassword?: [{	email: string | Variable<any, string>,	password: string | Variable<any, string>,	token: string | Variable<any, string>},boolean | `@${string}`],
verifyEmail?: [{	email: string | Variable<any, string>,	token: string | Variable<any, string>},boolean | `@${string}`],
finishRegister?: [{	password: string | Variable<any, string>,	token: string | Variable<any, string>},boolean | `@${string}`],
	refresh?:ValueTypes["AuthType"],
	logout?:boolean | `@${string}`,
uniqueAuthFromSso?: [{	token: string | Variable<any, string>},ValueTypes["UniqueAuth"]],
impersonateUser?: [{	userId: string | Variable<any, string>},ValueTypes["AuthType"]],
	stopImpersonate?:ValueTypes["AuthType"],
updateMyProfile?: [{	input: ValueTypes["UpdateMyProfileInput"] | Variable<any, string>},ValueTypes["MyAccount"]],
changeMyPassword?: [{	currentPassword: string | Variable<any, string>,	newPassword: string | Variable<any, string>},boolean | `@${string}`],
createComplaint?: [{	input: ValueTypes["CreateComplaintInput"] | Variable<any, string>},ValueTypes["ComplaintModel"]],
updateComplaint?: [{	input: ValueTypes["UpdateComplaintInput"] | Variable<any, string>},ValueTypes["ComplaintModel"]],
sendContactRequest?: [{	input: ValueTypes["ContactRequestInput"] | Variable<any, string>},boolean | `@${string}`],
replaceSurveyQuestions?: [{	questions: Array<ValueTypes["SurveyQuestionInput"]> | Variable<any, string>},ValueTypes["SurveyQuestionModel"]],
submitSurvey?: [{	input: ValueTypes["SubmitSurveyInput"] | Variable<any, string>},boolean | `@${string}`],
skipSurvey?: [{	sessionId: ValueTypes["ID"] | Variable<any, string>},boolean | `@${string}`],
createImprovementAction?: [{	input: ValueTypes["CreateImprovementActionInput"] | Variable<any, string>},ValueTypes["ImprovementActionModel"]],
updateImprovementAction?: [{	input: ValueTypes["UpdateImprovementActionInput"] | Variable<any, string>},ValueTypes["ImprovementActionModel"]],
createQualityRisk?: [{	input: ValueTypes["CreateQualityRiskInput"] | Variable<any, string>},ValueTypes["QualityRiskModel"]],
updateQualityRisk?: [{	input: ValueTypes["UpdateQualityRiskInput"] | Variable<any, string>},ValueTypes["QualityRiskModel"]],
submitPositioning?: [{	input: ValueTypes["SubmitPositioningInput"] | Variable<any, string>},boolean | `@${string}`],
createUser?: [{	createUserInput: ValueTypes["CreateUserInput"] | Variable<any, string>},ValueTypes["Users"]],
importUsers?: [{	users: Array<ValueTypes["ImportUserInput"]> | Variable<any, string>},ValueTypes["ImportUsersReport"]],
updateUser?: [{	updateUserInput: ValueTypes["UpdateUserInput"] | Variable<any, string>},ValueTypes["Users"]],
deleteUser?: [{	id: string | Variable<any, string>},boolean | `@${string}`],
createUsernameLearner?: [{	input: ValueTypes["CreateUsernameLearnerInput"] | Variable<any, string>},ValueTypes["UsernameCredentials"]],
importUsernameLearners?: [{	learners: Array<ValueTypes["ImportUsernameLearnerInput"]> | Variable<any, string>},ValueTypes["UsernameImportReport"]],
resetUsernameLearnerPassword?: [{	userId: string | Variable<any, string>},ValueTypes["UsernameCredentials"]],
createGroup?: [{	input: ValueTypes["CreateGroupInput"] | Variable<any, string>},ValueTypes["GroupModel"]],
updateGroup?: [{	id: ValueTypes["ID"] | Variable<any, string>,	input: ValueTypes["UpdateGroupInput"] | Variable<any, string>},ValueTypes["GroupModel"]],
deleteGroup?: [{	id: ValueTypes["ID"] | Variable<any, string>},boolean | `@${string}`],
addUsersToGroup?: [{	groupId: ValueTypes["ID"] | Variable<any, string>,	userIds: Array<ValueTypes["ID"]> | Variable<any, string>},boolean | `@${string}`],
removeUsersFromGroup?: [{	groupId: ValueTypes["ID"] | Variable<any, string>,	userIds: Array<ValueTypes["ID"]> | Variable<any, string>},boolean | `@${string}`],
updateTrainingDocument?: [{	input: ValueTypes["UpdateTrainingDocumentInput"] | Variable<any, string>},ValueTypes["TrainingDocumentModel"]],
archiveTrainingDocument?: [{	id: ValueTypes["ID"] | Variable<any, string>},boolean | `@${string}`],
acknowledgeDocument?: [{	id: ValueTypes["ID"] | Variable<any, string>},boolean | `@${string}`],
submitAccommodation?: [{	input: ValueTypes["SubmitAccommodationInput"] | Variable<any, string>},ValueTypes["AccommodationRequestModel"]],
	withdrawAccommodation?:boolean | `@${string}`,
respondAccommodation?: [{	input: ValueTypes["RespondAccommodationInput"] | Variable<any, string>},boolean | `@${string}`],
updateDisabilityReferent?: [{	input: ValueTypes["DisabilityReferentInput"] | Variable<any, string>},ValueTypes["DisabilityReferentModel"]],
setSsoEnabled?: [{	enabled: boolean | Variable<any, string>},ValueTypes["SsoOrgSettingsModel"]],
upsertSsoProvider?: [{	input: ValueTypes["UpsertSsoProviderInput"] | Variable<any, string>},ValueTypes["SsoProviderModel"]],
deleteSsoProvider?: [{	kind: ValueTypes["SsoProviderKind"] | Variable<any, string>},boolean | `@${string}`],
renameScormModule?: [{	id: ValueTypes["ID"] | Variable<any, string>,	title: string | Variable<any, string>},ValueTypes["ScormModuleModel"]],
deleteScormModule?: [{	id: ValueTypes["ID"] | Variable<any, string>},boolean | `@${string}`],
applyModuleReplacement?: [{	revisionId: ValueTypes["ID"] | Variable<any, string>},ValueTypes["ScormModuleModel"]],
cancelModuleReplacement?: [{	revisionId: ValueTypes["ID"] | Variable<any, string>},boolean | `@${string}`],
startScormAttempt?: [{	sessionId: ValueTypes["ID"] | Variable<any, string>,	moduleId?: ValueTypes["ID"] | undefined | null | Variable<any, string>},ValueTypes["ScormTrackingModel"]],
upsertScormTracking?: [{	input: ValueTypes["UpsertScormTrackingInput"] | Variable<any, string>},ValueTypes["ScormTrackingModel"]],
correctScore?: [{	input: ValueTypes["CorrectScoreInput"] | Variable<any, string>},boolean | `@${string}`],
revokeScoreCorrection?: [{	trackingId: ValueTypes["ID"] | Variable<any, string>},boolean | `@${string}`],
createSession?: [{	input: ValueTypes["CreateSessionInput"] | Variable<any, string>},ValueTypes["SessionModel"]],
updateSession?: [{	id: ValueTypes["ID"] | Variable<any, string>,	input: ValueTypes["UpdateSessionInput"] | Variable<any, string>},ValueTypes["SessionModel"]],
deleteSession?: [{	id: ValueTypes["ID"] | Variable<any, string>},boolean | `@${string}`],
declareDropout?: [{	input: ValueTypes["DeclareDropoutInput"] | Variable<any, string>},boolean | `@${string}`],
cancelDropout?: [{	input: ValueTypes["SessionEnrollmentRefInput"] | Variable<any, string>},boolean | `@${string}`],
requestTrialOrganization?: [{	input: ValueTypes["RequestTrialInput"] | Variable<any, string>},ValueTypes["RequestTrialResult"]],
confirmTrialOrganization?: [{	token: string | Variable<any, string>},ValueTypes["ConfirmTrialResult"]],
approveTrialRequest?: [{	id: string | Variable<any, string>},ValueTypes["ApproveTrialResult"]],
rejectTrialRequest?: [{	id: string | Variable<any, string>,	reason?: string | undefined | null | Variable<any, string>},boolean | `@${string}`],
createCertificateTemplate?: [{	name: string | Variable<any, string>},ValueTypes["CertificateTemplateModel"]],
duplicateCertificateTemplate?: [{	id: ValueTypes["ID"] | Variable<any, string>,	name?: string | undefined | null | Variable<any, string>},ValueTypes["CertificateTemplateModel"]],
setDefaultCertificateTemplate?: [{	id: ValueTypes["ID"] | Variable<any, string>},ValueTypes["CertificateTemplateModel"]],
deleteCertificateTemplate?: [{	id: ValueTypes["ID"] | Variable<any, string>},boolean | `@${string}`],
updateCertificateTemplate?: [{	input: ValueTypes["UpdateCertificateTemplateInput"] | Variable<any, string>,	id?: ValueTypes["ID"] | undefined | null | Variable<any, string>},ValueTypes["CertificateTemplateModel"]],
deleteFile?: [{	fileId: string | Variable<any, string>},boolean | `@${string}`],
uploadPreSignedUrl?: [{	mimeType: string | Variable<any, string>,	fileName: string | Variable<any, string>},ValueTypes["UploadPreSignedUrl"]],
confirmUpload?: [{	id: string | Variable<any, string>,	status: boolean | Variable<any, string>},boolean | `@${string}`],
	acknowledgeStatsNotice?:ValueTypes["StatsNotice"],
acceptLegalDocuments?: [{	documents: Array<ValueTypes["LegalDocument"]> | Variable<any, string>},ValueTypes["LegalAcceptance"]],
createOrganization?: [{	input: ValueTypes["CreateOrganizationInput"] | Variable<any, string>},ValueTypes["OrganizationModel"]],
setOrganizationStatus?: [{	id: string | Variable<any, string>,	status: ValueTypes["OrganizationStatus"] | Variable<any, string>},ValueTypes["OrganizationModel"]],
updateOrganization?: [{	input: ValueTypes["UpdateOrganizationInput"] | Variable<any, string>},ValueTypes["OrganizationModel"]],
deleteOrganization?: [{	id: ValueTypes["ID"] | Variable<any, string>},boolean | `@${string}`],
inviteOrgMember?: [{	input: ValueTypes["InviteOrgMemberInput"] | Variable<any, string>},ValueTypes["OrgMemberModel"]],
setOrgMemberRole?: [{	input: ValueTypes["SetOrgMemberRoleInput"] | Variable<any, string>},ValueTypes["OrgMemberModel"]],
removeOrgMember?: [{	orgId: ValueTypes["ID"] | Variable<any, string>,	userId: ValueTypes["ID"] | Variable<any, string>},boolean | `@${string}`],
updateReminderSettings?: [{	input: ValueTypes["UpdateReminderSettingsInput"] | Variable<any, string>},ValueTypes["ReminderSettingsModel"]],
sendReminderTest?: [{	input?: ValueTypes["UpdateReminderSettingsInput"] | undefined | null | Variable<any, string>},ValueTypes["ReminderTestResultModel"]],
createReportTemplate?: [{	input: ValueTypes["ReportTemplateInput"] | Variable<any, string>},ValueTypes["ReportTemplateModel"]],
updateReportTemplate?: [{	id: ValueTypes["ID"] | Variable<any, string>,	input: ValueTypes["ReportTemplateInput"] | Variable<any, string>},ValueTypes["ReportTemplateModel"]],
duplicateReportTemplate?: [{	id: ValueTypes["ID"] | Variable<any, string>,	name?: string | undefined | null | Variable<any, string>},ValueTypes["ReportTemplateModel"]],
upsertReportSchedule?: [{	templateId: ValueTypes["ID"] | Variable<any, string>,	input: ValueTypes["ReportScheduleInput"] | Variable<any, string>},ValueTypes["ReportTemplateModel"]],
deleteReportSchedule?: [{	templateId: ValueTypes["ID"] | Variable<any, string>},ValueTypes["ReportTemplateModel"]],
deleteReportTemplate?: [{	id: ValueTypes["ID"] | Variable<any, string>},boolean | `@${string}`],
		__typename?: boolean | `@${string}`,
	['...on Mutation']?: Omit<ValueTypes["Mutation"], "...on Mutation">
}>;
	["TrainerCapabilityGrantInput"]: {
	capability: ValueTypes["TrainerCapability"] | Variable<any, string>,
	granted: boolean | Variable<any, string>
};
	["SaveWebhookEndpointInput"]: {
	url: string | Variable<any, string>,
	enabled: boolean | Variable<any, string>
};
	["UpdateAppConfigInput"]: {
	appName?: string | undefined | null | Variable<any, string>,
	logo?: string | undefined | null | Variable<any, string>,
	logoDark?: string | undefined | null | Variable<any, string>,
	favicon?: string | undefined | null | Variable<any, string>,
	primaryColor?: string | undefined | null | Variable<any, string>,
	primaryForeground?: string | undefined | null | Variable<any, string>,
	accentColor?: string | undefined | null | Variable<any, string>,
	accentForeground?: string | undefined | null | Variable<any, string>,
	footerText?: string | undefined | null | Variable<any, string>,
	defaultLocale?: string | undefined | null | Variable<any, string>
};
	["UpdateBillingProfileInput"]: {
	companyName?: string | undefined | null | Variable<any, string>,
	addressLine1?: string | undefined | null | Variable<any, string>,
	addressLine2?: string | undefined | null | Variable<any, string>,
	postalCode?: string | undefined | null | Variable<any, string>,
	city?: string | undefined | null | Variable<any, string>,
	country?: string | undefined | null | Variable<any, string>,
	vatNumber?: string | undefined | null | Variable<any, string>,
	billingEmail?: string | undefined | null | Variable<any, string>
};
	["StartCheckoutInput"]: {
	tier: ValueTypes["BillingTier"] | Variable<any, string>,
	paymentTerm: ValueTypes["BillingPaymentTerm"] | Variable<any, string>
};
	["ChangeBillingPlanInput"]: {
	tier: ValueTypes["BillingTier"] | Variable<any, string>,
	paymentTerm?: ValueTypes["BillingPaymentTerm"] | undefined | null | Variable<any, string>
};
	["SetBillingModeInput"]: {
	mode: ValueTypes["BillingMode"] | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>
};
	["AuthType"]: AliasType<{		["...on UserInfo"]?: ValueTypes["UserInfo"],
		["...on CustomError"]?: ValueTypes["CustomError"]
		__typename?: boolean | `@${string}`
}>;
	["CustomError"]: AliasType<{
	error?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on CustomError']?: Omit<ValueTypes["CustomError"], "...on CustomError">
}>;
	["EError"]:EError;
	["UpdateMyProfileInput"]: {
	firstName: string | Variable<any, string>,
	lastName: string | Variable<any, string>
};
	["CreateComplaintInput"]: {
	category: ValueTypes["ComplaintCategory"] | Variable<any, string>,
	subject: string | Variable<any, string>,
	message: string | Variable<any, string>,
	authorId?: ValueTypes["ID"] | undefined | null | Variable<any, string>
};
	["UpdateComplaintInput"]: {
	id: ValueTypes["ID"] | Variable<any, string>,
	category?: ValueTypes["ComplaintCategory"] | undefined | null | Variable<any, string>,
	status?: ValueTypes["ComplaintStatus"] | undefined | null | Variable<any, string>,
	response?: string | undefined | null | Variable<any, string>
};
	["ContactRequestInput"]: {
	subject: string | Variable<any, string>,
	message: string | Variable<any, string>,
	pageUrl: string | Variable<any, string>,
	locale: string | Variable<any, string>,
	attachment?: string | undefined | null | Variable<any, string>,
	category?: ValueTypes["ComplaintCategory"] | undefined | null | Variable<any, string>
};
	["SurveyQuestionInput"]: {
	kind: ValueTypes["SurveyQuestionKind"] | Variable<any, string>,
	label: string | Variable<any, string>,
	isOverall?: boolean | undefined | null | Variable<any, string>
};
	["SubmitSurveyInput"]: {
	sessionId: ValueTypes["ID"] | Variable<any, string>,
	answers: Array<ValueTypes["SurveyAnswerInput"]> | Variable<any, string>,
	moduleRatings: Array<ValueTypes["ModuleRatingInput"]> | Variable<any, string>
};
	["SurveyAnswerInput"]: {
	questionId: ValueTypes["ID"] | Variable<any, string>,
	rating?: number | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>
};
	["ModuleRatingInput"]: {
	moduleId: ValueTypes["ID"] | Variable<any, string>,
	rating: number | Variable<any, string>
};
	["CreateImprovementActionInput"]: {
	origin: ValueTypes["ImprovementOrigin"] | Variable<any, string>,
	title: string | Variable<any, string>,
	description: string | Variable<any, string>,
	owner?: string | undefined | null | Variable<any, string>,
	dueDate?: string | undefined | null | Variable<any, string>
};
	["UpdateImprovementActionInput"]: {
	id: ValueTypes["ID"] | Variable<any, string>,
	origin?: ValueTypes["ImprovementOrigin"] | undefined | null | Variable<any, string>,
	status?: ValueTypes["ImprovementStatus"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	owner?: string | undefined | null | Variable<any, string>,
	dueDate?: string | undefined | null | Variable<any, string>,
	effect?: string | undefined | null | Variable<any, string>
};
	["CreateQualityRiskInput"]: {
	title: string | Variable<any, string>,
	description: string | Variable<any, string>,
	likelihood: number | Variable<any, string>,
	impact: number | Variable<any, string>,
	mitigation?: string | undefined | null | Variable<any, string>,
	owner?: string | undefined | null | Variable<any, string>
};
	["UpdateQualityRiskInput"]: {
	id: ValueTypes["ID"] | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	likelihood?: number | undefined | null | Variable<any, string>,
	impact?: number | undefined | null | Variable<any, string>,
	mitigation?: string | undefined | null | Variable<any, string>,
	owner?: string | undefined | null | Variable<any, string>,
	status?: ValueTypes["QualityRiskStatus"] | undefined | null | Variable<any, string>
};
	["SubmitPositioningInput"]: {
	sessionId: ValueTypes["ID"] | Variable<any, string>,
	phase: ValueTypes["PositioningPhase"] | Variable<any, string>,
	ratings: Array<ValueTypes["PositioningRatingInput"]> | Variable<any, string>,
	needs?: string | undefined | null | Variable<any, string>
};
	/** Positionnement d'entrée (obligatoire si demandé) ou de sortie (facultatif), #321. */
["PositioningPhase"]:PositioningPhase;
	["PositioningRatingInput"]: {
	index: number | Variable<any, string>,
	level: number | Variable<any, string>
};
	["CreateUserInput"]: {
	email: string | Variable<any, string>,
	password?: string | undefined | null | Variable<any, string>,
	firstName: string | Variable<any, string>,
	lastName: string | Variable<any, string>,
	roleId: string | Variable<any, string>,
	group?: string | undefined | null | Variable<any, string>,
	company?: string | undefined | null | Variable<any, string>,
	department?: string | undefined | null | Variable<any, string>
};
	["ImportUserInput"]: {
	email: string | Variable<any, string>,
	firstName: string | Variable<any, string>,
	lastName: string | Variable<any, string>,
	group?: string | undefined | null | Variable<any, string>,
	company?: string | undefined | null | Variable<any, string>,
	department?: string | undefined | null | Variable<any, string>
};
	["UpdateUserInput"]: {
	email?: string | undefined | null | Variable<any, string>,
	firstName?: string | undefined | null | Variable<any, string>,
	lastName?: string | undefined | null | Variable<any, string>,
	roleId?: string | undefined | null | Variable<any, string>,
	company?: string | undefined | null | Variable<any, string>,
	department?: string | undefined | null | Variable<any, string>,
	id: string | Variable<any, string>
};
	["CreateUsernameLearnerInput"]: {
	username: string | Variable<any, string>,
	firstName?: string | undefined | null | Variable<any, string>,
	lastName?: string | undefined | null | Variable<any, string>,
	password?: string | undefined | null | Variable<any, string>,
	group?: string | undefined | null | Variable<any, string>,
	company?: string | undefined | null | Variable<any, string>,
	department?: string | undefined | null | Variable<any, string>
};
	["ImportUsernameLearnerInput"]: {
	username: string | Variable<any, string>,
	firstName?: string | undefined | null | Variable<any, string>,
	lastName?: string | undefined | null | Variable<any, string>,
	group?: string | undefined | null | Variable<any, string>,
	company?: string | undefined | null | Variable<any, string>,
	department?: string | undefined | null | Variable<any, string>
};
	["CreateGroupInput"]: {
	name: string | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	userIds?: Array<ValueTypes["ID"]> | undefined | null | Variable<any, string>
};
	["UpdateGroupInput"]: {
	name?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	userIds?: Array<ValueTypes["ID"]> | undefined | null | Variable<any, string>
};
	["UpdateTrainingDocumentInput"]: {
	id: ValueTypes["ID"] | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	sessionId?: ValueTypes["ID"] | undefined | null | Variable<any, string>,
	requiredBeforeStart?: boolean | undefined | null | Variable<any, string>
};
	["SubmitAccommodationInput"]: {
	needs: string | Variable<any, string>,
	consent: boolean | Variable<any, string>
};
	["RespondAccommodationInput"]: {
	id: ValueTypes["ID"] | Variable<any, string>,
	response?: string | undefined | null | Variable<any, string>,
	handled: boolean | Variable<any, string>
};
	["DisabilityReferentInput"]: {
	name?: string | undefined | null | Variable<any, string>,
	contact?: string | undefined | null | Variable<any, string>
};
	["UpsertSsoProviderInput"]: {
	kind: ValueTypes["SsoProviderKind"] | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	enabled?: boolean | undefined | null | Variable<any, string>,
	issuer?: string | undefined | null | Variable<any, string>,
	clientId?: string | undefined | null | Variable<any, string>,
	clientSecret?: string | undefined | null | Variable<any, string>,
	entryPoint?: string | undefined | null | Variable<any, string>,
	idpIssuer?: string | undefined | null | Variable<any, string>,
	idpCert?: string | undefined | null | Variable<any, string>,
	allowedDomains?: Array<string> | undefined | null | Variable<any, string>
};
	["UpsertScormTrackingInput"]: {
	sessionId: ValueTypes["ID"] | Variable<any, string>,
	moduleId?: ValueTypes["ID"] | undefined | null | Variable<any, string>,
	attemptNumber?: number | undefined | null | Variable<any, string>,
	completionStatus?: ValueTypes["ScormCompletionStatus"] | undefined | null | Variable<any, string>,
	successStatus?: ValueTypes["ScormSuccessStatus"] | undefined | null | Variable<any, string>,
	scoreRaw?: number | undefined | null | Variable<any, string>,
	scoreMin?: number | undefined | null | Variable<any, string>,
	scoreMax?: number | undefined | null | Variable<any, string>,
	scoreScaled?: number | undefined | null | Variable<any, string>,
	totalTime?: string | undefined | null | Variable<any, string>,
	sessionTime?: string | undefined | null | Variable<any, string>,
	suspendData?: string | undefined | null | Variable<any, string>,
	location?: string | undefined | null | Variable<any, string>,
	interactions?: Array<ValueTypes["ScormInteractionInput"]> | undefined | null | Variable<any, string>,
	scoIdentifier?: string | undefined | null | Variable<any, string>
};
	["ScormInteractionInput"]: {
	index: number | Variable<any, string>,
	id: string | Variable<any, string>,
	type?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	correctResponses?: Array<string> | undefined | null | Variable<any, string>,
	learnerResponse?: string | undefined | null | Variable<any, string>,
	result?: string | undefined | null | Variable<any, string>,
	weighting?: number | undefined | null | Variable<any, string>,
	latency?: string | undefined | null | Variable<any, string>,
	timestamp?: string | undefined | null | Variable<any, string>,
	objectiveIds?: Array<string> | undefined | null | Variable<any, string>
};
	["CorrectScoreInput"]: {
	trackingId: ValueTypes["ID"] | Variable<any, string>,
	percent: number | Variable<any, string>,
	reason: string | Variable<any, string>
};
	["CreateSessionInput"]: {
	name: string | Variable<any, string>,
	modules: Array<ValueTypes["SessionModuleInput"]> | Variable<any, string>,
	sections?: Array<ValueTypes["SessionSectionInput"]> | undefined | null | Variable<any, string>,
	progressionMode?: ValueTypes["SessionProgressionMode"] | undefined | null | Variable<any, string>,
	tags?: Array<string> | undefined | null | Variable<any, string>,
	certificateCondition?: ValueTypes["CertificateCondition"] | undefined | null | Variable<any, string>,
	certificateMinScore?: number | undefined | null | Variable<any, string>,
	certificateTemplateId?: ValueTypes["ID"] | undefined | null | Variable<any, string>,
	/** Jour civil au format AAAA-MM-JJ */
	startDate?: string | undefined | null | Variable<any, string>,
	/** Jour civil au format AAAA-MM-JJ */
	endDate?: string | undefined | null | Variable<any, string>,
	userIds?: Array<ValueTypes["ID"]> | undefined | null | Variable<any, string>,
	trainerIds?: Array<ValueTypes["ID"]> | undefined | null | Variable<any, string>,
	sheet?: ValueTypes["TrainingSheetInput"] | undefined | null | Variable<any, string>
};
	["SessionModuleInput"]: {
	moduleId: ValueTypes["ID"] | Variable<any, string>,
	/** Jour civil au format AAAA-MM-JJ */
	unlockAt?: string | undefined | null | Variable<any, string>,
	prerequisiteModuleId?: ValueTypes["ID"] | undefined | null | Variable<any, string>,
	prerequisiteMinScore?: number | undefined | null | Variable<any, string>,
	allowRetake?: boolean | undefined | null | Variable<any, string>,
	scoreRetention?: ValueTypes["ScoreRetention"] | undefined | null | Variable<any, string>,
	sectionIndex?: number | undefined | null | Variable<any, string>
};
	["SessionSectionInput"]: {
	title: string | Variable<any, string>
};
	["TrainingSheetInput"]: {
	objectives?: Array<string> | undefined | null | Variable<any, string>,
	prerequisites?: string | undefined | null | Variable<any, string>,
	audience?: string | undefined | null | Variable<any, string>,
	teachingMethods?: string | undefined | null | Variable<any, string>,
	assessmentMethods?: string | undefined | null | Variable<any, string>,
	accessibility?: string | undefined | null | Variable<any, string>,
	contact?: string | undefined | null | Variable<any, string>,
	positioningEnabled?: boolean | undefined | null | Variable<any, string>
};
	["UpdateSessionInput"]: {
	name?: string | undefined | null | Variable<any, string>,
	/** Jour civil au format AAAA-MM-JJ */
	startDate?: string | undefined | null | Variable<any, string>,
	/** Jour civil au format AAAA-MM-JJ */
	endDate?: string | undefined | null | Variable<any, string>,
	status?: ValueTypes["SessionStatus"] | undefined | null | Variable<any, string>,
	tags?: Array<string> | undefined | null | Variable<any, string>,
	certificateCondition?: ValueTypes["CertificateCondition"] | undefined | null | Variable<any, string>,
	certificateMinScore?: number | undefined | null | Variable<any, string>,
	certificateTemplateId?: ValueTypes["ID"] | undefined | null | Variable<any, string>,
	progressionMode?: ValueTypes["SessionProgressionMode"] | undefined | null | Variable<any, string>,
	modules?: Array<ValueTypes["SessionModuleInput"]> | undefined | null | Variable<any, string>,
	sections?: Array<ValueTypes["SessionSectionInput"]> | undefined | null | Variable<any, string>,
	userIds?: Array<ValueTypes["ID"]> | undefined | null | Variable<any, string>,
	trainerIds?: Array<ValueTypes["ID"]> | undefined | null | Variable<any, string>,
	sheet?: ValueTypes["TrainingSheetInput"] | undefined | null | Variable<any, string>
};
	["DeclareDropoutInput"]: {
	sessionId: ValueTypes["ID"] | Variable<any, string>,
	userId: ValueTypes["ID"] | Variable<any, string>,
	reason: ValueTypes["DropoutReason"] | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>
};
	["SessionEnrollmentRefInput"]: {
	sessionId: ValueTypes["ID"] | Variable<any, string>,
	userId: ValueTypes["ID"] | Variable<any, string>
};
	["RequestTrialInput"]: {
	email: string | Variable<any, string>,
	firstName: string | Variable<any, string>,
	lastName: string | Variable<any, string>,
	orgName: string | Variable<any, string>,
	phone?: string | undefined | null | Variable<any, string>,
	jobTitle?: string | undefined | null | Variable<any, string>,
	acceptTerms: boolean | Variable<any, string>
};
	["UpdateCertificateTemplateInput"]: {
	name?: string | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	body?: string | undefined | null | Variable<any, string>,
	signature?: string | undefined | null | Variable<any, string>,
	showScore?: boolean | undefined | null | Variable<any, string>,
	showDate?: boolean | undefined | null | Variable<any, string>,
	showTotalTime?: boolean | undefined | null | Variable<any, string>,
	emailOnUnlock?: boolean | undefined | null | Variable<any, string>,
	logo?: string | undefined | null | Variable<any, string>,
	orientation?: ValueTypes["CertificateOrientation"] | undefined | null | Variable<any, string>,
	skeletonPdf?: string | undefined | null | Variable<any, string>,
	marginTop?: number | undefined | null | Variable<any, string>,
	marginBottom?: number | undefined | null | Variable<any, string>,
	marginLeft?: number | undefined | null | Variable<any, string>,
	marginRight?: number | undefined | null | Variable<any, string>
};
	["CreateOrganizationInput"]: {
	name: string | Variable<any, string>,
	slug: string | Variable<any, string>,
	adminEmail: string | Variable<any, string>,
	adminFirstName: string | Variable<any, string>,
	adminLastName: string | Variable<any, string>
};
	["UpdateOrganizationInput"]: {
	id: ValueTypes["ID"] | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	slug?: string | undefined | null | Variable<any, string>,
	status?: ValueTypes["OrganizationStatus"] | undefined | null | Variable<any, string>
};
	["InviteOrgMemberInput"]: {
	orgId: ValueTypes["ID"] | Variable<any, string>,
	email: string | Variable<any, string>,
	firstName: string | Variable<any, string>,
	lastName: string | Variable<any, string>,
	role: ValueTypes["RoleEnum"] | Variable<any, string>
};
	["SetOrgMemberRoleInput"]: {
	orgId: ValueTypes["ID"] | Variable<any, string>,
	userId: ValueTypes["ID"] | Variable<any, string>,
	role: ValueTypes["RoleEnum"] | Variable<any, string>
};
	["UpdateReminderSettingsInput"]: {
	enabled?: boolean | undefined | null | Variable<any, string>,
	firstDelayDays?: number | undefined | null | Variable<any, string>,
	frequencyDays?: number | undefined | null | Variable<any, string>,
	maxReminders?: number | undefined | null | Variable<any, string>,
	sendHour?: number | undefined | null | Variable<any, string>,
	subject?: string | undefined | null | Variable<any, string>,
	body?: string | undefined | null | Variable<any, string>,
	completionDigestEnabled?: boolean | undefined | null | Variable<any, string>,
	convocationEnabled?: boolean | undefined | null | Variable<any, string>
};
	["ReportTemplateInput"]: {
	name: string | Variable<any, string>,
	granularity: ValueTypes["ReportGranularity"] | Variable<any, string>,
	columns: Array<string> | Variable<any, string>,
	filters?: ValueTypes["ReportFiltersInput"] | undefined | null | Variable<any, string>
};
	["ReportFiltersInput"]: {
	sessionIds?: Array<ValueTypes["ID"]> | undefined | null | Variable<any, string>,
	groupIds?: Array<ValueTypes["ID"]> | undefined | null | Variable<any, string>,
	state?: ValueTypes["UserProgress"] | undefined | null | Variable<any, string>,
	period?: ValueTypes["ReportPeriodInput"] | undefined | null | Variable<any, string>
};
	["ReportPeriodInput"]: {
	kind: ValueTypes["ReportPeriodKind"] | Variable<any, string>,
	from?: string | undefined | null | Variable<any, string>,
	to?: string | undefined | null | Variable<any, string>
};
	["ReportScheduleInput"]: {
	frequency: ValueTypes["ReportFrequency"] | Variable<any, string>,
	weekday?: number | undefined | null | Variable<any, string>,
	monthDay?: number | undefined | null | Variable<any, string>,
	hour: number | Variable<any, string>,
	recipientIds: Array<ValueTypes["ID"]> | Variable<any, string>,
	enabled?: boolean | undefined | null | Variable<any, string>
};
	["Subscription"]: AliasType<{
basicSubscription?: [{	email: string | Variable<any, string>},boolean | `@${string}`],
		__typename?: boolean | `@${string}`,
	['...on Subscription']?: Omit<ValueTypes["Subscription"], "...on Subscription">
}>;
	["ID"]:unknown
  }

export type ResolverInputTypes = {
    ["Permissions"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	roles?:ResolverInputTypes["Role"],
		__typename?: boolean | `@${string}`
}>;
	/** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
["DateTime"]:unknown;
	["UserGroupModel"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Users"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	emailVerified?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	company?:boolean | `@${string}`,
	department?:boolean | `@${string}`,
	lastConnectionAt?:boolean | `@${string}`,
	role?:ResolverInputTypes["Role"],
	roleId?:boolean | `@${string}`,
	groups?:ResolverInputTypes["UserGroupModel"],
		__typename?: boolean | `@${string}`
}>;
	["AccountStatus"]:AccountStatus;
	["UserPagination"]: AliasType<{
	users?:ResolverInputTypes["Users"],
	total?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ImportUserError"]: AliasType<{
	line?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	reason?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ImportUsersReport"]: AliasType<{
	createdCount?:boolean | `@${string}`,
	errorCount?:boolean | `@${string}`,
	errors?:ResolverInputTypes["ImportUserError"],
		__typename?: boolean | `@${string}`
}>;
	["Role"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	permissions?:ResolverInputTypes["Permissions"],
	users?:ResolverInputTypes["Users"],
		__typename?: boolean | `@${string}`
}>;
	["DisabilityReferentModel"]: AliasType<{
	name?:boolean | `@${string}`,
	contact?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AccommodationRequestModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	needs?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	response?:boolean | `@${string}`,
	handledAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AccommodationStatus"]:AccommodationStatus;
	["OrgAccommodationRequestModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	needs?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	response?:boolean | `@${string}`,
	handledAt?:boolean | `@${string}`,
	learnerName?:boolean | `@${string}`,
	learnerEmail?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["MyAccommodationModel"]: AliasType<{
	referent?:ResolverInputTypes["DisabilityReferentModel"],
	request?:ResolverInputTypes["AccommodationRequestModel"],
		__typename?: boolean | `@${string}`
}>;
	["UniqueAuth"]: AliasType<{
	access_token?:boolean | `@${string}`,
	refresh_token?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Invitation"]: AliasType<{
	status?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["InvitationStatus"]:InvitationStatus;
	["UserInfo"]: AliasType<{
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	roles?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	orgId?:boolean | `@${string}`,
	impersonatorId?:boolean | `@${string}`,
	capabilities?:boolean | `@${string}`,
	orgSlug?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RoleEnum"]:RoleEnum;
	/** Ce que le rôle Formateur peut faire, réglable par organisation (#11) */
["TrainerCapability"]:TrainerCapability;
	["Mail"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	key?:boolean | `@${string}`,
	to?:boolean | `@${string}`,
	data?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["BillingAccountModel"]: AliasType<{
	id?:boolean | `@${string}`,
	tier?:boolean | `@${string}`,
	paymentTerm?:boolean | `@${string}`,
	mode?:boolean | `@${string}`,
	tierChangedAt?:boolean | `@${string}`,
	subscriptionStatus?:boolean | `@${string}`,
	currentPeriodEnd?:boolean | `@${string}`,
	cancelAtPeriodEnd?:boolean | `@${string}`,
	scheduledTier?:boolean | `@${string}`,
	scheduledPaymentTerm?:boolean | `@${string}`,
	scheduledChangeAt?:boolean | `@${string}`,
	cancelAt?:boolean | `@${string}`,
	companyName?:boolean | `@${string}`,
	addressLine1?:boolean | `@${string}`,
	addressLine2?:boolean | `@${string}`,
	postalCode?:boolean | `@${string}`,
	city?:boolean | `@${string}`,
	country?:boolean | `@${string}`,
	vatNumber?:boolean | `@${string}`,
	billingEmail?:boolean | `@${string}`,
	subscribed?:boolean | `@${string}`,
	billingPortalAvailable?:boolean | `@${string}`,
	paymentFailed?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["BillingTier"]:BillingTier;
	["BillingPaymentTerm"]:BillingPaymentTerm;
	["BillingMode"]:BillingMode;
	["BillingOfferModel"]: AliasType<{
	tier?:boolean | `@${string}`,
	capacity?:boolean | `@${string}`,
	monthlyPriceCents?:boolean | `@${string}`,
	upfrontYearlyAmountCents?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["LearnerCountersModel"]: AliasType<{
	orgId?:boolean | `@${string}`,
	orgName?:boolean | `@${string}`,
	orgSlug?:boolean | `@${string}`,
	month?:boolean | `@${string}`,
	monthlyActive?:boolean | `@${string}`,
	learnerCount?:boolean | `@${string}`,
	registeredLearners?:boolean | `@${string}`,
	leavingWithinThreeMonths?:boolean | `@${string}`,
	subscribedTier?:boolean | `@${string}`,
	effectiveTier?:boolean | `@${string}`,
	billedTier?:boolean | `@${string}`,
	placesRemaining?:boolean | `@${string}`,
	nextTier?:boolean | `@${string}`,
	paymentTerm?:boolean | `@${string}`,
	estimatedRevenueCents?:boolean | `@${string}`,
	managed?:boolean | `@${string}`,
	overCapacity?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["BillingEstimateModel"]: AliasType<{
	month?:boolean | `@${string}`,
	subscribedTier?:boolean | `@${string}`,
	effectiveTier?:boolean | `@${string}`,
	billedTier?:boolean | `@${string}`,
	paymentTerm?:boolean | `@${string}`,
	learnerCount?:boolean | `@${string}`,
	monthlyActive?:boolean | `@${string}`,
	registeredLearners?:boolean | `@${string}`,
	placesRemaining?:boolean | `@${string}`,
	nextTier?:boolean | `@${string}`,
	leavingWithinThreeMonths?:boolean | `@${string}`,
	monthlyPriceCents?:boolean | `@${string}`,
	monthlyAmountCents?:boolean | `@${string}`,
	upfrontYearlyAmountCents?:boolean | `@${string}`,
	isCustom?:boolean | `@${string}`,
	managed?:boolean | `@${string}`,
	overCapacity?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["BillingHistoryEntryModel"]: AliasType<{
	month?:boolean | `@${string}`,
	monthlyActive?:boolean | `@${string}`,
	learnerCount?:boolean | `@${string}`,
	tier?:boolean | `@${string}`,
	amountCents?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CapacityAlertModel"]: AliasType<{
	learnerCount?:boolean | `@${string}`,
	tier?:boolean | `@${string}`,
	neededTier?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["MyAccount"]: AliasType<{
	id?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
	organizationName?:boolean | `@${string}`,
	lastConnectionAt?:boolean | `@${string}`,
	hasPassword?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AppConfigModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	appName?:boolean | `@${string}`,
	logo?:boolean | `@${string}`,
	logoDark?:boolean | `@${string}`,
	favicon?:boolean | `@${string}`,
	primaryColor?:boolean | `@${string}`,
	primaryForeground?:boolean | `@${string}`,
	accentColor?:boolean | `@${string}`,
	accentForeground?:boolean | `@${string}`,
	footerText?:boolean | `@${string}`,
	defaultLocale?:boolean | `@${string}`,
	timezone?:boolean | `@${string}`,
	signupCtaVisible?:boolean | `@${string}`,
	billingSelfService?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TrainerCapabilityModel"]: AliasType<{
	capability?:boolean | `@${string}`,
	granted?:boolean | `@${string}`,
	dependsOn?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GroupMemberModel"]: AliasType<{
	id?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GroupModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	memberCount?:boolean | `@${string}`,
	members?:ResolverInputTypes["GroupMemberModel"],
	memberIds?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["LoginEventModel"]: AliasType<{
	id?:boolean | `@${string}`,
	at?:boolean | `@${string}`,
	method?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["LoginMethod"]:LoginMethod;
	["LoginEventPage"]: AliasType<{
	events?:ResolverInputTypes["LoginEventModel"],
	total?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["LearnerProfile"]: AliasType<{
	id?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	company?:boolean | `@${string}`,
	department?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	roleName?:boolean | `@${string}`,
	roleId?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	groups?:ResolverInputTypes["UserGroupModel"],
	trainingSeconds?:boolean | `@${string}`,
	loginCount?:boolean | `@${string}`,
	lastLoginAt?:boolean | `@${string}`,
	averageDaysBetweenLogins?:boolean | `@${string}`,
	completedModules?:boolean | `@${string}`,
	totalModules?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UsernameCredentials"]: AliasType<{
	userId?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	password?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UsernameImportError"]: AliasType<{
	line?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	reason?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UsernameImportReport"]: AliasType<{
	created?:ResolverInputTypes["UsernameCredentials"],
	errors?:ResolverInputTypes["UsernameImportError"],
		__typename?: boolean | `@${string}`
}>;
	["CertificateTemplateModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	isDefault?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	body?:boolean | `@${string}`,
	signature?:boolean | `@${string}`,
	showScore?:boolean | `@${string}`,
	showDate?:boolean | `@${string}`,
	showTotalTime?:boolean | `@${string}`,
	emailOnUnlock?:boolean | `@${string}`,
	logo?:boolean | `@${string}`,
	orientation?:boolean | `@${string}`,
	hasSkeleton?:boolean | `@${string}`,
	marginTop?:boolean | `@${string}`,
	marginBottom?:boolean | `@${string}`,
	marginLeft?:boolean | `@${string}`,
	marginRight?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CertificateOrientation"]:CertificateOrientation;
	["CertificateTemplateOptionModel"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	isDefault?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ComplaintModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	category?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	origin?:boolean | `@${string}`,
	subject?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
	response?:boolean | `@${string}`,
	respondedAt?:boolean | `@${string}`,
	resolvedAt?:boolean | `@${string}`,
	authorName?:boolean | `@${string}`,
	authorEmail?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** Nature d'une demande ou réclamation (#325) ; REPORT = signalement de violence, harcèlement ou discrimination. */
["ComplaintCategory"]:ComplaintCategory;
	["ComplaintStatus"]:ComplaintStatus;
	["ComplaintOrigin"]:ComplaintOrigin;
	["TrainingDocumentModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	fileName?:boolean | `@${string}`,
	sizeBytes?:boolean | `@${string}`,
	requiredBeforeStart?:boolean | `@${string}`,
	sessionId?:boolean | `@${string}`,
	sessionName?:boolean | `@${string}`,
	acknowledgementCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DocumentAcknowledgementModel"]: AliasType<{
	at?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DownloadFile"]: AliasType<{
	fileName?:boolean | `@${string}`,
	fileMimeType?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["MyFiles"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	eTag?:boolean | `@${string}`,
	location?:boolean | `@${string}`,
	fileName?:boolean | `@${string}`,
	fileMimeType?:boolean | `@${string}`,
	ownerId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UploadPreSignedUrl"]: AliasType<{
	url?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["HomeCompletionModel"]: AliasType<{
	sessionId?:boolean | `@${string}`,
	sessionName?:boolean | `@${string}`,
	moduleId?:boolean | `@${string}`,
	moduleTitle?:boolean | `@${string}`,
	learners?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["HomeSessionModel"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	startDate?:boolean | `@${string}`,
	endDate?:boolean | `@${string}`,
	enrolledLearners?:boolean | `@${string}`,
	pendingLearners?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["BackOfficeHomeModel"]: AliasType<{
	firstName?:boolean | `@${string}`,
	timezone?:boolean | `@${string}`,
	completedToday?:ResolverInputTypes["HomeCompletionModel"],
	startingSoon?:ResolverInputTypes["HomeSessionModel"],
	endingSoon?:ResolverInputTypes["HomeSessionModel"],
	overdue?:ResolverInputTypes["HomeSessionModel"],
	overdueLearners?:boolean | `@${string}`,
	overdueSessions?:boolean | `@${string}`,
	neverStartedLearners?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["OrganizationModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	slug?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	userCount?:boolean | `@${string}`,
	tier?:boolean | `@${string}`,
	billingMode?:boolean | `@${string}`,
	billingNote?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["OrganizationStatus"]:OrganizationStatus;
	["OrgMemberModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PositioningRatingModel"]: AliasType<{
	objective?:boolean | `@${string}`,
	level?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PositioningAnswerModel"]: AliasType<{
	answeredAt?:boolean | `@${string}`,
	ratings?:ResolverInputTypes["PositioningRatingModel"],
	needs?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SessionPositioningModel"]: AliasType<{
	sessionId?:boolean | `@${string}`,
	sessionName?:boolean | `@${string}`,
	entry?:ResolverInputTypes["PositioningAnswerModel"],
	exit?:ResolverInputTypes["PositioningAnswerModel"],
		__typename?: boolean | `@${string}`
}>;
	["ImprovementActionModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	origin?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	owner?:boolean | `@${string}`,
	dueDate?:boolean | `@${string}`,
	effect?:boolean | `@${string}`,
	doneAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** Le retour qui a fait naître une action d'amélioration (#328). */
["ImprovementOrigin"]:ImprovementOrigin;
	["ImprovementStatus"]:ImprovementStatus;
	["QualityRiskModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	/** Probabilité, de 1 (faible) à 3 (forte). */
	likelihood?:boolean | `@${string}`,
	/** Impact, de 1 (faible) à 3 (fort). */
	impact?:boolean | `@${string}`,
	/** Gravité = probabilité × impact, de 1 à 9. */
	severity?:boolean | `@${string}`,
	mitigation?:boolean | `@${string}`,
	owner?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["QualityRiskStatus"]:QualityRiskStatus;
	["ReminderSettingsModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	enabled?:boolean | `@${string}`,
	firstDelayDays?:boolean | `@${string}`,
	frequencyDays?:boolean | `@${string}`,
	maxReminders?:boolean | `@${string}`,
	sendHour?:boolean | `@${string}`,
	subject?:boolean | `@${string}`,
	body?:boolean | `@${string}`,
	completionDigestEnabled?:boolean | `@${string}`,
	convocationEnabled?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ReminderTestResultModel"]: AliasType<{
	sent?:boolean | `@${string}`,
	to?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ReportPeriodModel"]: AliasType<{
	kind?:boolean | `@${string}`,
	from?:boolean | `@${string}`,
	to?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ReportPeriodKind"]:ReportPeriodKind;
	["ReportFiltersModel"]: AliasType<{
	sessionIds?:boolean | `@${string}`,
	groupIds?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
	period?:ResolverInputTypes["ReportPeriodModel"],
		__typename?: boolean | `@${string}`
}>;
	["UserProgress"]:UserProgress;
	["ReportScheduleModel"]: AliasType<{
	frequency?:boolean | `@${string}`,
	weekday?:boolean | `@${string}`,
	monthDay?:boolean | `@${string}`,
	hour?:boolean | `@${string}`,
	recipientIds?:boolean | `@${string}`,
	enabled?:boolean | `@${string}`,
	lastSentAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ReportFrequency"]:ReportFrequency;
	["ReportTemplateModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	granularity?:boolean | `@${string}`,
	columns?:boolean | `@${string}`,
	filters?:ResolverInputTypes["ReportFiltersModel"],
	schedule?:ResolverInputTypes["ReportScheduleModel"],
		__typename?: boolean | `@${string}`
}>;
	/** Ce qu'est une ligne du rapport (#163). */
["ReportGranularity"]:ReportGranularity;
	["ReportColumnLabelModel"]: AliasType<{
	fr?:boolean | `@${string}`,
	en?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ReportColumnModel"]: AliasType<{
	key?:boolean | `@${string}`,
	level?:boolean | `@${string}`,
	label?:ResolverInputTypes["ReportColumnLabelModel"],
		__typename?: boolean | `@${string}`
}>;
	["ReportRecipientModel"]: AliasType<{
	id?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["StorageUsageModel"]: AliasType<{
	orgId?:boolean | `@${string}`,
	orgName?:boolean | `@${string}`,
	orgSlug?:boolean | `@${string}`,
	usedBytes?:boolean | `@${string}`,
	quotaBytes?:boolean | `@${string}`,
	remainingBytes?:boolean | `@${string}`,
	plan?:boolean | `@${string}`,
	moduleCount?:boolean | `@${string}`,
	overQuota?:boolean | `@${string}`,
	maxUploadBytes?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ScormModuleModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	scormVersion?:boolean | `@${string}`,
	launchUrl?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	masteryScore?:boolean | `@${string}`,
	durationMinutes?:boolean | `@${string}`,
	sizeBytes?:boolean | `@${string}`,
	contentUpdatedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ScormModuleStatus"]:ScormModuleStatus;
	["ScormScoModel"]: AliasType<{
	identifier?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	href?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
	masteryScore?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ScoreCorrectionModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	score?:boolean | `@${string}`,
	previousScore?:boolean | `@${string}`,
	reason?:boolean | `@${string}`,
	correctedBy?:boolean | `@${string}`,
	revokedAt?:boolean | `@${string}`,
	revokedBy?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ScormInteractionModel"]: AliasType<{
	scoIdentifier?:boolean | `@${string}`,
	index?:boolean | `@${string}`,
	interactionId?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	correctResponses?:boolean | `@${string}`,
	learnerResponse?:boolean | `@${string}`,
	result?:boolean | `@${string}`,
	weighting?:boolean | `@${string}`,
	latency?:boolean | `@${string}`,
	timestamp?:boolean | `@${string}`,
	objectiveIds?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["QuestionAnswerModel"]: AliasType<{
	userId?:boolean | `@${string}`,
	response?:boolean | `@${string}`,
	result?:boolean | `@${string}`,
	score?:boolean | `@${string}`,
	attemptNumber?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["QuestionStatModel"]: AliasType<{
	scoIdentifier?:boolean | `@${string}`,
	interactionId?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	correctResponses?:boolean | `@${string}`,
	respondents?:boolean | `@${string}`,
	correctRate?:boolean | `@${string}`,
	averageScore?:boolean | `@${string}`,
	buckets?:boolean | `@${string}`,
	answers?:ResolverInputTypes["QuestionAnswerModel"],
		__typename?: boolean | `@${string}`
}>;
	["QuestionLearnerModel"]: AliasType<{
	id?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ModuleQuestionStatsModel"]: AliasType<{
	questions?:ResolverInputTypes["QuestionStatModel"],
	learners?:ResolverInputTypes["QuestionLearnerModel"],
		__typename?: boolean | `@${string}`
}>;
	["LearnerAttemptModel"]: AliasType<{
	sessionId?:boolean | `@${string}`,
	sessionName?:boolean | `@${string}`,
	number?:boolean | `@${string}`,
	completionStatus?:boolean | `@${string}`,
	successStatus?:boolean | `@${string}`,
	scoreRaw?:boolean | `@${string}`,
	scoreMax?:boolean | `@${string}`,
	scoreScaled?:boolean | `@${string}`,
	totalTime?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	interactions?:ResolverInputTypes["ScormInteractionModel"],
		__typename?: boolean | `@${string}`
}>;
	["ScormCompletionStatus"]:ScormCompletionStatus;
	["ScormSuccessStatus"]:ScormSuccessStatus;
	["ScormScoStateModel"]: AliasType<{
	scoIdentifier?:boolean | `@${string}`,
	completionStatus?:boolean | `@${string}`,
	successStatus?:boolean | `@${string}`,
	scoreRaw?:boolean | `@${string}`,
	scoreMin?:boolean | `@${string}`,
	scoreMax?:boolean | `@${string}`,
	scoreScaled?:boolean | `@${string}`,
	totalTime?:boolean | `@${string}`,
	suspendData?:boolean | `@${string}`,
	location?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ScormAttemptModel"]: AliasType<{
	number?:boolean | `@${string}`,
	completionStatus?:boolean | `@${string}`,
	successStatus?:boolean | `@${string}`,
	scoreRaw?:boolean | `@${string}`,
	scoreMin?:boolean | `@${string}`,
	scoreMax?:boolean | `@${string}`,
	scoreScaled?:boolean | `@${string}`,
	totalTime?:boolean | `@${string}`,
	interactions?:ResolverInputTypes["ScormInteractionModel"],
	scoStates?:ResolverInputTypes["ScormScoStateModel"],
		__typename?: boolean | `@${string}`
}>;
	["ScormTrackingModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	completionStatus?:boolean | `@${string}`,
	successStatus?:boolean | `@${string}`,
	scoreRaw?:boolean | `@${string}`,
	scoreMin?:boolean | `@${string}`,
	scoreMax?:boolean | `@${string}`,
	scoreScaled?:boolean | `@${string}`,
	totalTime?:boolean | `@${string}`,
	totalTimeSeconds?:boolean | `@${string}`,
	sessionTime?:boolean | `@${string}`,
	suspendData?:boolean | `@${string}`,
	location?:boolean | `@${string}`,
	completedAt?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
	sessionId?:boolean | `@${string}`,
	attemptNumber?:boolean | `@${string}`,
	currentAttempt?:ResolverInputTypes["ScormAttemptModel"],
	currentScoIdentifier?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ScormTrackingWithUser"]: AliasType<{
	id?:boolean | `@${string}`,
	correctedScore?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	completionStatus?:boolean | `@${string}`,
	successStatus?:boolean | `@${string}`,
	scoreRaw?:boolean | `@${string}`,
	scoreMin?:boolean | `@${string}`,
	scoreMax?:boolean | `@${string}`,
	scoreScaled?:boolean | `@${string}`,
	totalTime?:boolean | `@${string}`,
	sessionTime?:boolean | `@${string}`,
	suspendData?:boolean | `@${string}`,
	location?:boolean | `@${string}`,
	completedAt?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
	userEmail?:boolean | `@${string}`,
	userUsername?:boolean | `@${string}`,
	userFirstName?:boolean | `@${string}`,
	userLastName?:boolean | `@${string}`,
	sessionId?:boolean | `@${string}`,
	sessionName?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ScormTrackingStats"]: AliasType<{
	total?:boolean | `@${string}`,
	learners?:boolean | `@${string}`,
	completed?:boolean | `@${string}`,
	inProgress?:boolean | `@${string}`,
	notStarted?:boolean | `@${string}`,
	completionUnknown?:boolean | `@${string}`,
	neverOpened?:boolean | `@${string}`,
	notYetUnlocked?:boolean | `@${string}`,
	passed?:boolean | `@${string}`,
	failed?:boolean | `@${string}`,
	averageScorePercent?:boolean | `@${string}`,
	scoredCount?:boolean | `@${string}`,
	averageTimeSeconds?:boolean | `@${string}`,
	timedCount?:boolean | `@${string}`,
	totalTimeSeconds?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ScormCompletionPoint"]: AliasType<{
	day?:boolean | `@${string}`,
	completed?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ScormTrackingPagination"]: AliasType<{
	trackings?:ResolverInputTypes["ScormTrackingWithUser"],
	total?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SessionParticipantResult"]: AliasType<{
	userId?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	groups?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
	completedModules?:boolean | `@${string}`,
	totalModules?:boolean | `@${string}`,
	averageScorePercent?:boolean | `@${string}`,
	timeSpentSeconds?:boolean | `@${string}`,
	lastActivityAt?:boolean | `@${string}`,
	droppedAt?:boolean | `@${string}`,
	dropReason?:boolean | `@${string}`,
	dropNote?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** Motif d'un abandon déclaré par l'organisme (#324). */
["DropoutReason"]:DropoutReason;
	["SessionModuleResult"]: AliasType<{
	moduleId?:boolean | `@${string}`,
	completedCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SessionResults"]: AliasType<{
	stats?:ResolverInputTypes["ScormTrackingStats"],
	participants?:ResolverInputTypes["SessionParticipantResult"],
	modules?:ResolverInputTypes["SessionModuleResult"],
		__typename?: boolean | `@${string}`
}>;
	["LearnerDocumentModel"]: AliasType<{
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	requiredBeforeStart?:boolean | `@${string}`,
	acknowledgedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["LearnerPositioningModel"]: AliasType<{
	required?:boolean | `@${string}`,
	entryPending?:boolean | `@${string}`,
	entryDone?:boolean | `@${string}`,
	exitDone?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SessionUserModel"]: AliasType<{
	id?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SessionTrainerModel"]: AliasType<{
	id?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
	assignedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SessionSectionModel"]: AliasType<{
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SessionModuleModel"]: AliasType<{
	id?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
	unlockAt?:boolean | `@${string}`,
	prerequisiteModuleId?:boolean | `@${string}`,
	prerequisiteMinScore?:boolean | `@${string}`,
	allowRetake?:boolean | `@${string}`,
	scoreRetention?:boolean | `@${string}`,
	sectionId?:boolean | `@${string}`,
	module?:ResolverInputTypes["ScormModuleModel"],
	unlocked?:boolean | `@${string}`,
	lockReason?:boolean | `@${string}`,
	myTracking?:ResolverInputTypes["ScormTrackingModel"],
		__typename?: boolean | `@${string}`
}>;
	/** Score retenu quand un apprenant refait un module : meilleur, dernier ou moyenne (#84) */
["ScoreRetention"]:ScoreRetention;
	/** Pourquoi un module est fermé — une date à attendre, ou un module à finir. */
["ModuleLockReason"]:ModuleLockReason;
	["SessionProgressModel"]: AliasType<{
	totalModules?:boolean | `@${string}`,
	completedModules?:boolean | `@${string}`,
	completed?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SessionTagModel"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SessionCertificateModel"]: AliasType<{
	unlocked?:boolean | `@${string}`,
	reason?:boolean | `@${string}`,
	blockingModuleIds?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** Pourquoi l'attestation est verrouillée : modules à terminer, à réussir, ou sous le seuil. */
["CertificateLockReason"]:CertificateLockReason;
	["SessionModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	objectives?:boolean | `@${string}`,
	prerequisites?:boolean | `@${string}`,
	audience?:boolean | `@${string}`,
	teachingMethods?:boolean | `@${string}`,
	assessmentMethods?:boolean | `@${string}`,
	accessibility?:boolean | `@${string}`,
	contact?:boolean | `@${string}`,
	startDate?:boolean | `@${string}`,
	endDate?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	progressionMode?:boolean | `@${string}`,
	certificateCondition?:boolean | `@${string}`,
	certificateMinScore?:boolean | `@${string}`,
	certificateTemplateId?:boolean | `@${string}`,
	module?:ResolverInputTypes["ScormModuleModel"],
	modules?:ResolverInputTypes["SessionModuleModel"],
	sections?:ResolverInputTypes["SessionSectionModel"],
	enrolledUsers?:ResolverInputTypes["SessionUserModel"],
	tags?:ResolverInputTypes["SessionTagModel"],
	trainers?:ResolverInputTypes["SessionTrainerModel"],
	myTracking?:ResolverInputTypes["ScormTrackingModel"],
	myEnrolledAt?:boolean | `@${string}`,
	progress?:ResolverInputTypes["SessionProgressModel"],
	certificate?:ResolverInputTypes["SessionCertificateModel"],
	positioningEnabled?:boolean | `@${string}`,
	myPositioning?:ResolverInputTypes["LearnerPositioningModel"],
	documents?:ResolverInputTypes["LearnerDocumentModel"],
		__typename?: boolean | `@${string}`
}>;
	["SessionStatus"]:SessionStatus;
	/** Règle d'enchaînement du parcours. Le déblocage par date n'est pas une valeur ici : c'est un second verrou, porté par SessionModule.unlockAt. */
["SessionProgressionMode"]:SessionProgressionMode;
	/** Ce qu'exige l'attestation d'un parcours, au-delà de terminer tous ses modules (#10). */
["CertificateCondition"]:CertificateCondition;
	["RequestTrialResult"]: AliasType<{
	accepted?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ConfirmTrialResult"]: AliasType<{
	status?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	slug?:boolean | `@${string}`,
	rejectionReason?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TrialReviewStatus"]:TrialReviewStatus;
	["TrialRequestModel"]: AliasType<{
	id?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	orgName?:boolean | `@${string}`,
	jobTitle?:boolean | `@${string}`,
	phone?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	emailConfirmedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ApproveTrialResult"]: AliasType<{
	slug?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SsoOrgSettingsModel"]: AliasType<{
	enabled?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SsoPresetModel"]: AliasType<{
	kind?:boolean | `@${string}`,
	protocol?:boolean | `@${string}`,
	defaultLabel?:boolean | `@${string}`,
	defaultIssuer?:boolean | `@${string}`,
	issuerHint?:boolean | `@${string}`,
	sharedIssuer?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** Fournisseur d'identité pré-listé (#40). */
["SsoProviderKind"]:SsoProviderKind;
	["SsoProviderModel"]: AliasType<{
	id?:boolean | `@${string}`,
	kind?:boolean | `@${string}`,
	protocol?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
	enabled?:boolean | `@${string}`,
	issuer?:boolean | `@${string}`,
	clientId?:boolean | `@${string}`,
	hasClientSecret?:boolean | `@${string}`,
	entryPoint?:boolean | `@${string}`,
	idpIssuer?:boolean | `@${string}`,
	idpCert?:boolean | `@${string}`,
	allowedDomains?:boolean | `@${string}`,
	requiresAllowedDomains?:boolean | `@${string}`,
	callbackUrl?:boolean | `@${string}`,
	metadataUrl?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PublicSsoProviderModel"]: AliasType<{
	id?:boolean | `@${string}`,
	kind?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
	loginUrl?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SurveyQuestionModel"]: AliasType<{
	id?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
	kind?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
	isOverall?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** Note de 1 à 5, ou réponse libre (#320). */
["SurveyQuestionKind"]:SurveyQuestionKind;
	["SurveyModuleModel"]: AliasType<{
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["LearnerSurveyModel"]: AliasType<{
	pending?:boolean | `@${string}`,
	questions?:ResolverInputTypes["SurveyQuestionModel"],
	modules?:ResolverInputTypes["SurveyModuleModel"],
		__typename?: boolean | `@${string}`
}>;
	["SurveyQuestionAverageModel"]: AliasType<{
	questionId?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
	average?:boolean | `@${string}`,
	count?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SurveyModuleAverageModel"]: AliasType<{
	moduleId?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	average?:boolean | `@${string}`,
	count?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SurveyCommentModel"]: AliasType<{
	label?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
	at?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SurveyResultsModel"]: AliasType<{
	answered?:boolean | `@${string}`,
	skipped?:boolean | `@${string}`,
	satisfactionRate?:boolean | `@${string}`,
	questions?:ResolverInputTypes["SurveyQuestionAverageModel"],
	modules?:ResolverInputTypes["SurveyModuleAverageModel"],
	comments?:ResolverInputTypes["SurveyCommentModel"],
		__typename?: boolean | `@${string}`
}>;
	["WebhookEndpointModel"]: AliasType<{
	url?:boolean | `@${string}`,
	enabled?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["WebhookEndpointSaveResult"]: AliasType<{
	endpoint?:ResolverInputTypes["WebhookEndpointModel"],
	secret?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["WebhookDeliveryModel"]: AliasType<{
	id?:boolean | `@${string}`,
	event?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	attempts?:boolean | `@${string}`,
	lastStatusCode?:boolean | `@${string}`,
	lastError?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	nextAttemptAt?:boolean | `@${string}`,
	deliveredAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** Où en est un appel de webhook (#5) : en file, en cours, reçu ou abandonné. */
["WebhookDeliveryStatus"]:WebhookDeliveryStatus;
	["Health"]: AliasType<{
	env?:boolean | `@${string}`,
	time?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	version?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["StatsNotice"]: AliasType<{
	status?:boolean | `@${string}`,
	acknowledgedAt?:boolean | `@${string}`,
	version?:boolean | `@${string}`,
	currentVersion?:boolean | `@${string}`,
	needsAcknowledgement?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ConsentStatus"]:ConsentStatus;
	["PendingLegalDocument"]: AliasType<{
	document?:boolean | `@${string}`,
	version?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["LegalDocument"]:LegalDocument;
	["LegalAcceptance"]: AliasType<{
	pending?:ResolverInputTypes["PendingLegalDocument"],
		__typename?: boolean | `@${string}`
}>;
	["Query"]: AliasType<{
	getHealthGql?:ResolverInputTypes["Health"],
getRole?: [{	id: string},ResolverInputTypes["Role"]],
	getRoles?:ResolverInputTypes["Role"],
getPermission?: [{	id: string},ResolverInputTypes["Permissions"]],
	getPermissions?:ResolverInputTypes["Permissions"],
	trainerCapabilities?:ResolverInputTypes["TrainerCapabilityModel"],
	webhookEndpoint?:ResolverInputTypes["WebhookEndpointModel"],
	webhookDeliveries?:ResolverInputTypes["WebhookDeliveryModel"],
getMail?: [{	id: string},ResolverInputTypes["Mail"]],
	getMails?:ResolverInputTypes["Mail"],
	appConfig?:ResolverInputTypes["AppConfigModel"],
learnerCounters?: [{	month?: string | undefined | null},ResolverInputTypes["LearnerCountersModel"]],
	capacityAlert?:ResolverInputTypes["CapacityAlertModel"],
learnerCountersByOrganization?: [{	month?: string | undefined | null},ResolverInputTypes["LearnerCountersModel"]],
	billingAccount?:ResolverInputTypes["BillingAccountModel"],
	billingOffers?:ResolverInputTypes["BillingOfferModel"],
billingEstimate?: [{	month?: string | undefined | null},ResolverInputTypes["BillingEstimateModel"]],
billingHistory?: [{	months?: number | undefined | null},ResolverInputTypes["BillingHistoryEntryModel"]],
invitation?: [{	token: string},ResolverInputTypes["Invitation"]],
	me?:ResolverInputTypes["UserInfo"],
	myAccount?:ResolverInputTypes["MyAccount"],
	complaints?:ResolverInputTypes["ComplaintModel"],
mySurvey?: [{	sessionId: ResolverInputTypes["ID"]},ResolverInputTypes["LearnerSurveyModel"]],
	surveyQuestions?:ResolverInputTypes["SurveyQuestionModel"],
surveyResults?: [{	sessionId: ResolverInputTypes["ID"]},ResolverInputTypes["SurveyResultsModel"]],
	improvementActions?:ResolverInputTypes["ImprovementActionModel"],
	qualityRisks?:ResolverInputTypes["QualityRiskModel"],
learnerPositioning?: [{	userId: ResolverInputTypes["ID"]},ResolverInputTypes["SessionPositioningModel"]],
	getUsers?:ResolverInputTypes["Users"],
getExistingUserEmails?: [{	emails: Array<string>},boolean | `@${string}`],
getFilteredUsers?: [{	findManyUserWithFiltersInput: ResolverInputTypes["FindManyUserWithFiltersInput"]},ResolverInputTypes["UserPagination"]],
learnerProfile?: [{	userId: ResolverInputTypes["ID"]},ResolverInputTypes["LearnerProfile"]],
learnerLogins?: [{	userId: ResolverInputTypes["ID"],	skip: number,	take: number},ResolverInputTypes["LoginEventPage"]],
	groups?:ResolverInputTypes["GroupModel"],
group?: [{	id: ResolverInputTypes["ID"]},ResolverInputTypes["GroupModel"]],
	trainingDocuments?:ResolverInputTypes["TrainingDocumentModel"],
documentAcknowledgements?: [{	documentId: ResolverInputTypes["ID"]},ResolverInputTypes["DocumentAcknowledgementModel"]],
	myAccommodation?:ResolverInputTypes["MyAccommodationModel"],
	accommodationRequests?:ResolverInputTypes["OrgAccommodationRequestModel"],
	disabilityReferent?:ResolverInputTypes["DisabilityReferentModel"],
	ssoProviders?:ResolverInputTypes["PublicSsoProviderModel"],
	ssoSettings?:ResolverInputTypes["SsoOrgSettingsModel"],
	ssoPresets?:ResolverInputTypes["SsoPresetModel"],
	ssoProviderConfigs?:ResolverInputTypes["SsoProviderModel"],
	scormModules?:ResolverInputTypes["ScormModuleModel"],
scormModule?: [{	id: ResolverInputTypes["ID"]},ResolverInputTypes["ScormModuleModel"]],
moduleScos?: [{	moduleId: ResolverInputTypes["ID"]},ResolverInputTypes["ScormScoModel"]],
	storageUsage?:ResolverInputTypes["StorageUsageModel"],
	storageUsageByOrganization?:ResolverInputTypes["StorageUsageModel"],
getMyScormTracking?: [{	sessionId: ResolverInputTypes["ID"],	moduleId?: ResolverInputTypes["ID"] | undefined | null},ResolverInputTypes["ScormTrackingModel"]],
myScormResume?: [{	sessionId: ResolverInputTypes["ID"],	moduleId: ResolverInputTypes["ID"]},ResolverInputTypes["ScormTrackingModel"]],
getScormTrackings?: [{	input: ResolverInputTypes["FindManyScormTrackingWithFiltersInput"]},ResolverInputTypes["ScormTrackingPagination"]],
getScormTrackingStats?: [{	input: ResolverInputTypes["ScormTrackingStatsInput"]},ResolverInputTypes["ScormTrackingStats"]],
getScormCompletionsByDay?: [{	input: ResolverInputTypes["ScormTrendInput"]},ResolverInputTypes["ScormCompletionPoint"]],
moduleQuestionStats?: [{	input: ResolverInputTypes["ModuleQuestionsInput"]},ResolverInputTypes["ModuleQuestionStatsModel"]],
learnerModuleAttempts?: [{	input: ResolverInputTypes["LearnerModuleAttemptsInput"]},ResolverInputTypes["LearnerAttemptModel"]],
scoreCorrections?: [{	trackingId: ResolverInputTypes["ID"]},ResolverInputTypes["ScoreCorrectionModel"]],
sessionResults?: [{	sessionId: ResolverInputTypes["ID"]},ResolverInputTypes["SessionResults"]],
	sessions?:ResolverInputTypes["SessionModel"],
session?: [{	id: ResolverInputTypes["ID"]},ResolverInputTypes["SessionModel"]],
userSessions?: [{	userId: ResolverInputTypes["ID"]},ResolverInputTypes["SessionModel"]],
	mySessions?:ResolverInputTypes["SessionModel"],
	pendingTrialRequests?:ResolverInputTypes["TrialRequestModel"],
	backOfficeHome?:ResolverInputTypes["BackOfficeHomeModel"],
	certificateTemplates?:ResolverInputTypes["CertificateTemplateModel"],
	certificateTemplateOptions?:ResolverInputTypes["CertificateTemplateOptionModel"],
certificateTemplate?: [{	id?: ResolverInputTypes["ID"] | undefined | null},ResolverInputTypes["CertificateTemplateModel"]],
downloadFile?: [{	eTag: string},ResolverInputTypes["DownloadFile"]],
	getAllMyFiles?:ResolverInputTypes["MyFiles"],
publishBasicSubscription?: [{	from: string,	to: string},boolean | `@${string}`],
	myStatsNotice?:ResolverInputTypes["StatsNotice"],
	myLegalAcceptance?:ResolverInputTypes["LegalAcceptance"],
	organizations?:ResolverInputTypes["OrganizationModel"],
organizationMembers?: [{	orgId: ResolverInputTypes["ID"]},ResolverInputTypes["OrgMemberModel"]],
findOrganization?: [{	query: string},boolean | `@${string}`],
	reminderSettings?:ResolverInputTypes["ReminderSettingsModel"],
	reportTemplates?:ResolverInputTypes["ReportTemplateModel"],
reportTemplate?: [{	id: ResolverInputTypes["ID"]},ResolverInputTypes["ReportTemplateModel"]],
reportColumns?: [{	granularity: ResolverInputTypes["ReportGranularity"]},ResolverInputTypes["ReportColumnModel"]],
	reportRecipients?:ResolverInputTypes["ReportRecipientModel"],
		__typename?: boolean | `@${string}`
}>;
	["FindManyUserWithFiltersInput"]: {
	skip: number,
	take: number,
	searchInput: string,
	orderBy?: ResolverInputTypes["UserOrderByInput"] | undefined | null,
	filterBy?: ResolverInputTypes["UserFilterByInput"] | undefined | null
};
	["UserOrderByInput"]: {
	email?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	firstName?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	lastName?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	lastConnectionAt?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	role?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	status?: ResolverInputTypes["OrderByEnum"] | undefined | null
};
	["OrderByEnum"]:OrderByEnum;
	["UserFilterByInput"]: {
	role?: Array<string> | undefined | null,
	group?: Array<ResolverInputTypes["ID"]> | undefined | null,
	progress?: ResolverInputTypes["UserProgress"] | undefined | null
};
	["FindManyScormTrackingWithFiltersInput"]: {
	skip: number,
	take: number,
	searchInput?: string | undefined | null,
	orderBy?: ResolverInputTypes["ScormTrackingOrderByInput"] | undefined | null,
	filterBy?: ResolverInputTypes["ScormTrackingFilterByInput"] | undefined | null
};
	["ScormTrackingOrderByInput"]: {
	userEmail?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	userFirstName?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	userLastName?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	completionStatus?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	successStatus?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	scoreRaw?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	completedAt?: ResolverInputTypes["OrderByEnum"] | undefined | null
};
	["ScormTrackingFilterByInput"]: {
	completionStatus?: ResolverInputTypes["ScormCompletionStatus"] | undefined | null,
	successStatus?: ResolverInputTypes["ScormSuccessStatus"] | undefined | null,
	sessionId?: ResolverInputTypes["ID"] | undefined | null,
	groupId?: ResolverInputTypes["ID"] | undefined | null
};
	["ScormTrackingStatsInput"]: {
	searchInput?: string | undefined | null,
	filterBy?: ResolverInputTypes["ScormStatsScopeInput"] | undefined | null
};
	["ScormStatsScopeInput"]: {
	sessionId?: ResolverInputTypes["ID"] | undefined | null,
	groupId?: ResolverInputTypes["ID"] | undefined | null
};
	["ScormTrendInput"]: {
	days?: number | undefined | null,
	filterBy?: ResolverInputTypes["ScormStatsScopeInput"] | undefined | null
};
	["ModuleQuestionsInput"]: {
	moduleId: ResolverInputTypes["ID"],
	sessionId?: ResolverInputTypes["ID"] | undefined | null,
	groupId?: ResolverInputTypes["ID"] | undefined | null,
	from?: string | undefined | null,
	to?: string | undefined | null
};
	["LearnerModuleAttemptsInput"]: {
	userId: ResolverInputTypes["ID"],
	moduleId: ResolverInputTypes["ID"],
	sessionId?: ResolverInputTypes["ID"] | undefined | null
};
	["Mutation"]: AliasType<{
updateTrainerCapabilities?: [{	grants: Array<ResolverInputTypes["TrainerCapabilityGrantInput"]>},ResolverInputTypes["TrainerCapabilityModel"]],
saveWebhookEndpoint?: [{	input: ResolverInputTypes["SaveWebhookEndpointInput"]},ResolverInputTypes["WebhookEndpointSaveResult"]],
	regenerateWebhookSecret?:boolean | `@${string}`,
	sendWebhookTest?:boolean | `@${string}`,
updateAppConfig?: [{	input: ResolverInputTypes["UpdateAppConfigInput"]},ResolverInputTypes["AppConfigModel"]],
updateBillingProfile?: [{	input: ResolverInputTypes["UpdateBillingProfileInput"]},ResolverInputTypes["BillingAccountModel"]],
startCheckout?: [{	input: ResolverInputTypes["StartCheckoutInput"]},boolean | `@${string}`],
	openBillingPortal?:boolean | `@${string}`,
setOrganizationPlan?: [{	orgId: ResolverInputTypes["ID"],	input: ResolverInputTypes["ChangeBillingPlanInput"]},ResolverInputTypes["BillingAccountModel"]],
setOrganizationBillingMode?: [{	orgId: ResolverInputTypes["ID"],	input: ResolverInputTypes["SetBillingModeInput"]},ResolverInputTypes["BillingAccountModel"]],
login?: [{	/** E-mail, or username of a learner without email */
	identifier: string,	password: string},ResolverInputTypes["AuthType"]],
requestMagicLink?: [{	email: string},boolean | `@${string}`],
loginWithMagicLink?: [{	token: string},ResolverInputTypes["AuthType"]],
askForResetPassword?: [{	email: string},boolean | `@${string}`],
reSendEmailValidation?: [{	email: string},boolean | `@${string}`],
resetPassword?: [{	email: string,	password: string,	token: string},boolean | `@${string}`],
verifyEmail?: [{	email: string,	token: string},boolean | `@${string}`],
finishRegister?: [{	password: string,	token: string},boolean | `@${string}`],
	refresh?:ResolverInputTypes["AuthType"],
	logout?:boolean | `@${string}`,
uniqueAuthFromSso?: [{	token: string},ResolverInputTypes["UniqueAuth"]],
impersonateUser?: [{	userId: string},ResolverInputTypes["AuthType"]],
	stopImpersonate?:ResolverInputTypes["AuthType"],
updateMyProfile?: [{	input: ResolverInputTypes["UpdateMyProfileInput"]},ResolverInputTypes["MyAccount"]],
changeMyPassword?: [{	currentPassword: string,	newPassword: string},boolean | `@${string}`],
createComplaint?: [{	input: ResolverInputTypes["CreateComplaintInput"]},ResolverInputTypes["ComplaintModel"]],
updateComplaint?: [{	input: ResolverInputTypes["UpdateComplaintInput"]},ResolverInputTypes["ComplaintModel"]],
sendContactRequest?: [{	input: ResolverInputTypes["ContactRequestInput"]},boolean | `@${string}`],
replaceSurveyQuestions?: [{	questions: Array<ResolverInputTypes["SurveyQuestionInput"]>},ResolverInputTypes["SurveyQuestionModel"]],
submitSurvey?: [{	input: ResolverInputTypes["SubmitSurveyInput"]},boolean | `@${string}`],
skipSurvey?: [{	sessionId: ResolverInputTypes["ID"]},boolean | `@${string}`],
createImprovementAction?: [{	input: ResolverInputTypes["CreateImprovementActionInput"]},ResolverInputTypes["ImprovementActionModel"]],
updateImprovementAction?: [{	input: ResolverInputTypes["UpdateImprovementActionInput"]},ResolverInputTypes["ImprovementActionModel"]],
createQualityRisk?: [{	input: ResolverInputTypes["CreateQualityRiskInput"]},ResolverInputTypes["QualityRiskModel"]],
updateQualityRisk?: [{	input: ResolverInputTypes["UpdateQualityRiskInput"]},ResolverInputTypes["QualityRiskModel"]],
submitPositioning?: [{	input: ResolverInputTypes["SubmitPositioningInput"]},boolean | `@${string}`],
createUser?: [{	createUserInput: ResolverInputTypes["CreateUserInput"]},ResolverInputTypes["Users"]],
importUsers?: [{	users: Array<ResolverInputTypes["ImportUserInput"]>},ResolverInputTypes["ImportUsersReport"]],
updateUser?: [{	updateUserInput: ResolverInputTypes["UpdateUserInput"]},ResolverInputTypes["Users"]],
deleteUser?: [{	id: string},boolean | `@${string}`],
createUsernameLearner?: [{	input: ResolverInputTypes["CreateUsernameLearnerInput"]},ResolverInputTypes["UsernameCredentials"]],
importUsernameLearners?: [{	learners: Array<ResolverInputTypes["ImportUsernameLearnerInput"]>},ResolverInputTypes["UsernameImportReport"]],
resetUsernameLearnerPassword?: [{	userId: string},ResolverInputTypes["UsernameCredentials"]],
createGroup?: [{	input: ResolverInputTypes["CreateGroupInput"]},ResolverInputTypes["GroupModel"]],
updateGroup?: [{	id: ResolverInputTypes["ID"],	input: ResolverInputTypes["UpdateGroupInput"]},ResolverInputTypes["GroupModel"]],
deleteGroup?: [{	id: ResolverInputTypes["ID"]},boolean | `@${string}`],
addUsersToGroup?: [{	groupId: ResolverInputTypes["ID"],	userIds: Array<ResolverInputTypes["ID"]>},boolean | `@${string}`],
removeUsersFromGroup?: [{	groupId: ResolverInputTypes["ID"],	userIds: Array<ResolverInputTypes["ID"]>},boolean | `@${string}`],
updateTrainingDocument?: [{	input: ResolverInputTypes["UpdateTrainingDocumentInput"]},ResolverInputTypes["TrainingDocumentModel"]],
archiveTrainingDocument?: [{	id: ResolverInputTypes["ID"]},boolean | `@${string}`],
acknowledgeDocument?: [{	id: ResolverInputTypes["ID"]},boolean | `@${string}`],
submitAccommodation?: [{	input: ResolverInputTypes["SubmitAccommodationInput"]},ResolverInputTypes["AccommodationRequestModel"]],
	withdrawAccommodation?:boolean | `@${string}`,
respondAccommodation?: [{	input: ResolverInputTypes["RespondAccommodationInput"]},boolean | `@${string}`],
updateDisabilityReferent?: [{	input: ResolverInputTypes["DisabilityReferentInput"]},ResolverInputTypes["DisabilityReferentModel"]],
setSsoEnabled?: [{	enabled: boolean},ResolverInputTypes["SsoOrgSettingsModel"]],
upsertSsoProvider?: [{	input: ResolverInputTypes["UpsertSsoProviderInput"]},ResolverInputTypes["SsoProviderModel"]],
deleteSsoProvider?: [{	kind: ResolverInputTypes["SsoProviderKind"]},boolean | `@${string}`],
renameScormModule?: [{	id: ResolverInputTypes["ID"],	title: string},ResolverInputTypes["ScormModuleModel"]],
deleteScormModule?: [{	id: ResolverInputTypes["ID"]},boolean | `@${string}`],
applyModuleReplacement?: [{	revisionId: ResolverInputTypes["ID"]},ResolverInputTypes["ScormModuleModel"]],
cancelModuleReplacement?: [{	revisionId: ResolverInputTypes["ID"]},boolean | `@${string}`],
startScormAttempt?: [{	sessionId: ResolverInputTypes["ID"],	moduleId?: ResolverInputTypes["ID"] | undefined | null},ResolverInputTypes["ScormTrackingModel"]],
upsertScormTracking?: [{	input: ResolverInputTypes["UpsertScormTrackingInput"]},ResolverInputTypes["ScormTrackingModel"]],
correctScore?: [{	input: ResolverInputTypes["CorrectScoreInput"]},boolean | `@${string}`],
revokeScoreCorrection?: [{	trackingId: ResolverInputTypes["ID"]},boolean | `@${string}`],
createSession?: [{	input: ResolverInputTypes["CreateSessionInput"]},ResolverInputTypes["SessionModel"]],
updateSession?: [{	id: ResolverInputTypes["ID"],	input: ResolverInputTypes["UpdateSessionInput"]},ResolverInputTypes["SessionModel"]],
deleteSession?: [{	id: ResolverInputTypes["ID"]},boolean | `@${string}`],
declareDropout?: [{	input: ResolverInputTypes["DeclareDropoutInput"]},boolean | `@${string}`],
cancelDropout?: [{	input: ResolverInputTypes["SessionEnrollmentRefInput"]},boolean | `@${string}`],
requestTrialOrganization?: [{	input: ResolverInputTypes["RequestTrialInput"]},ResolverInputTypes["RequestTrialResult"]],
confirmTrialOrganization?: [{	token: string},ResolverInputTypes["ConfirmTrialResult"]],
approveTrialRequest?: [{	id: string},ResolverInputTypes["ApproveTrialResult"]],
rejectTrialRequest?: [{	id: string,	reason?: string | undefined | null},boolean | `@${string}`],
createCertificateTemplate?: [{	name: string},ResolverInputTypes["CertificateTemplateModel"]],
duplicateCertificateTemplate?: [{	id: ResolverInputTypes["ID"],	name?: string | undefined | null},ResolverInputTypes["CertificateTemplateModel"]],
setDefaultCertificateTemplate?: [{	id: ResolverInputTypes["ID"]},ResolverInputTypes["CertificateTemplateModel"]],
deleteCertificateTemplate?: [{	id: ResolverInputTypes["ID"]},boolean | `@${string}`],
updateCertificateTemplate?: [{	input: ResolverInputTypes["UpdateCertificateTemplateInput"],	id?: ResolverInputTypes["ID"] | undefined | null},ResolverInputTypes["CertificateTemplateModel"]],
deleteFile?: [{	fileId: string},boolean | `@${string}`],
uploadPreSignedUrl?: [{	mimeType: string,	fileName: string},ResolverInputTypes["UploadPreSignedUrl"]],
confirmUpload?: [{	id: string,	status: boolean},boolean | `@${string}`],
	acknowledgeStatsNotice?:ResolverInputTypes["StatsNotice"],
acceptLegalDocuments?: [{	documents: Array<ResolverInputTypes["LegalDocument"]>},ResolverInputTypes["LegalAcceptance"]],
createOrganization?: [{	input: ResolverInputTypes["CreateOrganizationInput"]},ResolverInputTypes["OrganizationModel"]],
setOrganizationStatus?: [{	id: string,	status: ResolverInputTypes["OrganizationStatus"]},ResolverInputTypes["OrganizationModel"]],
updateOrganization?: [{	input: ResolverInputTypes["UpdateOrganizationInput"]},ResolverInputTypes["OrganizationModel"]],
deleteOrganization?: [{	id: ResolverInputTypes["ID"]},boolean | `@${string}`],
inviteOrgMember?: [{	input: ResolverInputTypes["InviteOrgMemberInput"]},ResolverInputTypes["OrgMemberModel"]],
setOrgMemberRole?: [{	input: ResolverInputTypes["SetOrgMemberRoleInput"]},ResolverInputTypes["OrgMemberModel"]],
removeOrgMember?: [{	orgId: ResolverInputTypes["ID"],	userId: ResolverInputTypes["ID"]},boolean | `@${string}`],
updateReminderSettings?: [{	input: ResolverInputTypes["UpdateReminderSettingsInput"]},ResolverInputTypes["ReminderSettingsModel"]],
sendReminderTest?: [{	input?: ResolverInputTypes["UpdateReminderSettingsInput"] | undefined | null},ResolverInputTypes["ReminderTestResultModel"]],
createReportTemplate?: [{	input: ResolverInputTypes["ReportTemplateInput"]},ResolverInputTypes["ReportTemplateModel"]],
updateReportTemplate?: [{	id: ResolverInputTypes["ID"],	input: ResolverInputTypes["ReportTemplateInput"]},ResolverInputTypes["ReportTemplateModel"]],
duplicateReportTemplate?: [{	id: ResolverInputTypes["ID"],	name?: string | undefined | null},ResolverInputTypes["ReportTemplateModel"]],
upsertReportSchedule?: [{	templateId: ResolverInputTypes["ID"],	input: ResolverInputTypes["ReportScheduleInput"]},ResolverInputTypes["ReportTemplateModel"]],
deleteReportSchedule?: [{	templateId: ResolverInputTypes["ID"]},ResolverInputTypes["ReportTemplateModel"]],
deleteReportTemplate?: [{	id: ResolverInputTypes["ID"]},boolean | `@${string}`],
		__typename?: boolean | `@${string}`
}>;
	["TrainerCapabilityGrantInput"]: {
	capability: ResolverInputTypes["TrainerCapability"],
	granted: boolean
};
	["SaveWebhookEndpointInput"]: {
	url: string,
	enabled: boolean
};
	["UpdateAppConfigInput"]: {
	appName?: string | undefined | null,
	logo?: string | undefined | null,
	logoDark?: string | undefined | null,
	favicon?: string | undefined | null,
	primaryColor?: string | undefined | null,
	primaryForeground?: string | undefined | null,
	accentColor?: string | undefined | null,
	accentForeground?: string | undefined | null,
	footerText?: string | undefined | null,
	defaultLocale?: string | undefined | null
};
	["UpdateBillingProfileInput"]: {
	companyName?: string | undefined | null,
	addressLine1?: string | undefined | null,
	addressLine2?: string | undefined | null,
	postalCode?: string | undefined | null,
	city?: string | undefined | null,
	country?: string | undefined | null,
	vatNumber?: string | undefined | null,
	billingEmail?: string | undefined | null
};
	["StartCheckoutInput"]: {
	tier: ResolverInputTypes["BillingTier"],
	paymentTerm: ResolverInputTypes["BillingPaymentTerm"]
};
	["ChangeBillingPlanInput"]: {
	tier: ResolverInputTypes["BillingTier"],
	paymentTerm?: ResolverInputTypes["BillingPaymentTerm"] | undefined | null
};
	["SetBillingModeInput"]: {
	mode: ResolverInputTypes["BillingMode"],
	note?: string | undefined | null
};
	["AuthType"]: AliasType<{
	UserInfo?:ResolverInputTypes["UserInfo"],
	CustomError?:ResolverInputTypes["CustomError"],
		__typename?: boolean | `@${string}`
}>;
	["CustomError"]: AliasType<{
	error?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["EError"]:EError;
	["UpdateMyProfileInput"]: {
	firstName: string,
	lastName: string
};
	["CreateComplaintInput"]: {
	category: ResolverInputTypes["ComplaintCategory"],
	subject: string,
	message: string,
	authorId?: ResolverInputTypes["ID"] | undefined | null
};
	["UpdateComplaintInput"]: {
	id: ResolverInputTypes["ID"],
	category?: ResolverInputTypes["ComplaintCategory"] | undefined | null,
	status?: ResolverInputTypes["ComplaintStatus"] | undefined | null,
	response?: string | undefined | null
};
	["ContactRequestInput"]: {
	subject: string,
	message: string,
	pageUrl: string,
	locale: string,
	attachment?: string | undefined | null,
	category?: ResolverInputTypes["ComplaintCategory"] | undefined | null
};
	["SurveyQuestionInput"]: {
	kind: ResolverInputTypes["SurveyQuestionKind"],
	label: string,
	isOverall?: boolean | undefined | null
};
	["SubmitSurveyInput"]: {
	sessionId: ResolverInputTypes["ID"],
	answers: Array<ResolverInputTypes["SurveyAnswerInput"]>,
	moduleRatings: Array<ResolverInputTypes["ModuleRatingInput"]>
};
	["SurveyAnswerInput"]: {
	questionId: ResolverInputTypes["ID"],
	rating?: number | undefined | null,
	text?: string | undefined | null
};
	["ModuleRatingInput"]: {
	moduleId: ResolverInputTypes["ID"],
	rating: number
};
	["CreateImprovementActionInput"]: {
	origin: ResolverInputTypes["ImprovementOrigin"],
	title: string,
	description: string,
	owner?: string | undefined | null,
	dueDate?: string | undefined | null
};
	["UpdateImprovementActionInput"]: {
	id: ResolverInputTypes["ID"],
	origin?: ResolverInputTypes["ImprovementOrigin"] | undefined | null,
	status?: ResolverInputTypes["ImprovementStatus"] | undefined | null,
	title?: string | undefined | null,
	description?: string | undefined | null,
	owner?: string | undefined | null,
	dueDate?: string | undefined | null,
	effect?: string | undefined | null
};
	["CreateQualityRiskInput"]: {
	title: string,
	description: string,
	likelihood: number,
	impact: number,
	mitigation?: string | undefined | null,
	owner?: string | undefined | null
};
	["UpdateQualityRiskInput"]: {
	id: ResolverInputTypes["ID"],
	title?: string | undefined | null,
	description?: string | undefined | null,
	likelihood?: number | undefined | null,
	impact?: number | undefined | null,
	mitigation?: string | undefined | null,
	owner?: string | undefined | null,
	status?: ResolverInputTypes["QualityRiskStatus"] | undefined | null
};
	["SubmitPositioningInput"]: {
	sessionId: ResolverInputTypes["ID"],
	phase: ResolverInputTypes["PositioningPhase"],
	ratings: Array<ResolverInputTypes["PositioningRatingInput"]>,
	needs?: string | undefined | null
};
	/** Positionnement d'entrée (obligatoire si demandé) ou de sortie (facultatif), #321. */
["PositioningPhase"]:PositioningPhase;
	["PositioningRatingInput"]: {
	index: number,
	level: number
};
	["CreateUserInput"]: {
	email: string,
	password?: string | undefined | null,
	firstName: string,
	lastName: string,
	roleId: string,
	group?: string | undefined | null,
	company?: string | undefined | null,
	department?: string | undefined | null
};
	["ImportUserInput"]: {
	email: string,
	firstName: string,
	lastName: string,
	group?: string | undefined | null,
	company?: string | undefined | null,
	department?: string | undefined | null
};
	["UpdateUserInput"]: {
	email?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	roleId?: string | undefined | null,
	company?: string | undefined | null,
	department?: string | undefined | null,
	id: string
};
	["CreateUsernameLearnerInput"]: {
	username: string,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	password?: string | undefined | null,
	group?: string | undefined | null,
	company?: string | undefined | null,
	department?: string | undefined | null
};
	["ImportUsernameLearnerInput"]: {
	username: string,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	group?: string | undefined | null,
	company?: string | undefined | null,
	department?: string | undefined | null
};
	["CreateGroupInput"]: {
	name: string,
	description?: string | undefined | null,
	userIds?: Array<ResolverInputTypes["ID"]> | undefined | null
};
	["UpdateGroupInput"]: {
	name?: string | undefined | null,
	description?: string | undefined | null,
	userIds?: Array<ResolverInputTypes["ID"]> | undefined | null
};
	["UpdateTrainingDocumentInput"]: {
	id: ResolverInputTypes["ID"],
	title?: string | undefined | null,
	sessionId?: ResolverInputTypes["ID"] | undefined | null,
	requiredBeforeStart?: boolean | undefined | null
};
	["SubmitAccommodationInput"]: {
	needs: string,
	consent: boolean
};
	["RespondAccommodationInput"]: {
	id: ResolverInputTypes["ID"],
	response?: string | undefined | null,
	handled: boolean
};
	["DisabilityReferentInput"]: {
	name?: string | undefined | null,
	contact?: string | undefined | null
};
	["UpsertSsoProviderInput"]: {
	kind: ResolverInputTypes["SsoProviderKind"],
	label?: string | undefined | null,
	enabled?: boolean | undefined | null,
	issuer?: string | undefined | null,
	clientId?: string | undefined | null,
	clientSecret?: string | undefined | null,
	entryPoint?: string | undefined | null,
	idpIssuer?: string | undefined | null,
	idpCert?: string | undefined | null,
	allowedDomains?: Array<string> | undefined | null
};
	["UpsertScormTrackingInput"]: {
	sessionId: ResolverInputTypes["ID"],
	moduleId?: ResolverInputTypes["ID"] | undefined | null,
	attemptNumber?: number | undefined | null,
	completionStatus?: ResolverInputTypes["ScormCompletionStatus"] | undefined | null,
	successStatus?: ResolverInputTypes["ScormSuccessStatus"] | undefined | null,
	scoreRaw?: number | undefined | null,
	scoreMin?: number | undefined | null,
	scoreMax?: number | undefined | null,
	scoreScaled?: number | undefined | null,
	totalTime?: string | undefined | null,
	sessionTime?: string | undefined | null,
	suspendData?: string | undefined | null,
	location?: string | undefined | null,
	interactions?: Array<ResolverInputTypes["ScormInteractionInput"]> | undefined | null,
	scoIdentifier?: string | undefined | null
};
	["ScormInteractionInput"]: {
	index: number,
	id: string,
	type?: string | undefined | null,
	description?: string | undefined | null,
	correctResponses?: Array<string> | undefined | null,
	learnerResponse?: string | undefined | null,
	result?: string | undefined | null,
	weighting?: number | undefined | null,
	latency?: string | undefined | null,
	timestamp?: string | undefined | null,
	objectiveIds?: Array<string> | undefined | null
};
	["CorrectScoreInput"]: {
	trackingId: ResolverInputTypes["ID"],
	percent: number,
	reason: string
};
	["CreateSessionInput"]: {
	name: string,
	modules: Array<ResolverInputTypes["SessionModuleInput"]>,
	sections?: Array<ResolverInputTypes["SessionSectionInput"]> | undefined | null,
	progressionMode?: ResolverInputTypes["SessionProgressionMode"] | undefined | null,
	tags?: Array<string> | undefined | null,
	certificateCondition?: ResolverInputTypes["CertificateCondition"] | undefined | null,
	certificateMinScore?: number | undefined | null,
	certificateTemplateId?: ResolverInputTypes["ID"] | undefined | null,
	/** Jour civil au format AAAA-MM-JJ */
	startDate?: string | undefined | null,
	/** Jour civil au format AAAA-MM-JJ */
	endDate?: string | undefined | null,
	userIds?: Array<ResolverInputTypes["ID"]> | undefined | null,
	trainerIds?: Array<ResolverInputTypes["ID"]> | undefined | null,
	sheet?: ResolverInputTypes["TrainingSheetInput"] | undefined | null
};
	["SessionModuleInput"]: {
	moduleId: ResolverInputTypes["ID"],
	/** Jour civil au format AAAA-MM-JJ */
	unlockAt?: string | undefined | null,
	prerequisiteModuleId?: ResolverInputTypes["ID"] | undefined | null,
	prerequisiteMinScore?: number | undefined | null,
	allowRetake?: boolean | undefined | null,
	scoreRetention?: ResolverInputTypes["ScoreRetention"] | undefined | null,
	sectionIndex?: number | undefined | null
};
	["SessionSectionInput"]: {
	title: string
};
	["TrainingSheetInput"]: {
	objectives?: Array<string> | undefined | null,
	prerequisites?: string | undefined | null,
	audience?: string | undefined | null,
	teachingMethods?: string | undefined | null,
	assessmentMethods?: string | undefined | null,
	accessibility?: string | undefined | null,
	contact?: string | undefined | null,
	positioningEnabled?: boolean | undefined | null
};
	["UpdateSessionInput"]: {
	name?: string | undefined | null,
	/** Jour civil au format AAAA-MM-JJ */
	startDate?: string | undefined | null,
	/** Jour civil au format AAAA-MM-JJ */
	endDate?: string | undefined | null,
	status?: ResolverInputTypes["SessionStatus"] | undefined | null,
	tags?: Array<string> | undefined | null,
	certificateCondition?: ResolverInputTypes["CertificateCondition"] | undefined | null,
	certificateMinScore?: number | undefined | null,
	certificateTemplateId?: ResolverInputTypes["ID"] | undefined | null,
	progressionMode?: ResolverInputTypes["SessionProgressionMode"] | undefined | null,
	modules?: Array<ResolverInputTypes["SessionModuleInput"]> | undefined | null,
	sections?: Array<ResolverInputTypes["SessionSectionInput"]> | undefined | null,
	userIds?: Array<ResolverInputTypes["ID"]> | undefined | null,
	trainerIds?: Array<ResolverInputTypes["ID"]> | undefined | null,
	sheet?: ResolverInputTypes["TrainingSheetInput"] | undefined | null
};
	["DeclareDropoutInput"]: {
	sessionId: ResolverInputTypes["ID"],
	userId: ResolverInputTypes["ID"],
	reason: ResolverInputTypes["DropoutReason"],
	note?: string | undefined | null
};
	["SessionEnrollmentRefInput"]: {
	sessionId: ResolverInputTypes["ID"],
	userId: ResolverInputTypes["ID"]
};
	["RequestTrialInput"]: {
	email: string,
	firstName: string,
	lastName: string,
	orgName: string,
	phone?: string | undefined | null,
	jobTitle?: string | undefined | null,
	acceptTerms: boolean
};
	["UpdateCertificateTemplateInput"]: {
	name?: string | undefined | null,
	title?: string | undefined | null,
	body?: string | undefined | null,
	signature?: string | undefined | null,
	showScore?: boolean | undefined | null,
	showDate?: boolean | undefined | null,
	showTotalTime?: boolean | undefined | null,
	emailOnUnlock?: boolean | undefined | null,
	logo?: string | undefined | null,
	orientation?: ResolverInputTypes["CertificateOrientation"] | undefined | null,
	skeletonPdf?: string | undefined | null,
	marginTop?: number | undefined | null,
	marginBottom?: number | undefined | null,
	marginLeft?: number | undefined | null,
	marginRight?: number | undefined | null
};
	["CreateOrganizationInput"]: {
	name: string,
	slug: string,
	adminEmail: string,
	adminFirstName: string,
	adminLastName: string
};
	["UpdateOrganizationInput"]: {
	id: ResolverInputTypes["ID"],
	name?: string | undefined | null,
	slug?: string | undefined | null,
	status?: ResolverInputTypes["OrganizationStatus"] | undefined | null
};
	["InviteOrgMemberInput"]: {
	orgId: ResolverInputTypes["ID"],
	email: string,
	firstName: string,
	lastName: string,
	role: ResolverInputTypes["RoleEnum"]
};
	["SetOrgMemberRoleInput"]: {
	orgId: ResolverInputTypes["ID"],
	userId: ResolverInputTypes["ID"],
	role: ResolverInputTypes["RoleEnum"]
};
	["UpdateReminderSettingsInput"]: {
	enabled?: boolean | undefined | null,
	firstDelayDays?: number | undefined | null,
	frequencyDays?: number | undefined | null,
	maxReminders?: number | undefined | null,
	sendHour?: number | undefined | null,
	subject?: string | undefined | null,
	body?: string | undefined | null,
	completionDigestEnabled?: boolean | undefined | null,
	convocationEnabled?: boolean | undefined | null
};
	["ReportTemplateInput"]: {
	name: string,
	granularity: ResolverInputTypes["ReportGranularity"],
	columns: Array<string>,
	filters?: ResolverInputTypes["ReportFiltersInput"] | undefined | null
};
	["ReportFiltersInput"]: {
	sessionIds?: Array<ResolverInputTypes["ID"]> | undefined | null,
	groupIds?: Array<ResolverInputTypes["ID"]> | undefined | null,
	state?: ResolverInputTypes["UserProgress"] | undefined | null,
	period?: ResolverInputTypes["ReportPeriodInput"] | undefined | null
};
	["ReportPeriodInput"]: {
	kind: ResolverInputTypes["ReportPeriodKind"],
	from?: string | undefined | null,
	to?: string | undefined | null
};
	["ReportScheduleInput"]: {
	frequency: ResolverInputTypes["ReportFrequency"],
	weekday?: number | undefined | null,
	monthDay?: number | undefined | null,
	hour: number,
	recipientIds: Array<ResolverInputTypes["ID"]>,
	enabled?: boolean | undefined | null
};
	["Subscription"]: AliasType<{
basicSubscription?: [{	email: string},boolean | `@${string}`],
		__typename?: boolean | `@${string}`
}>;
	["schema"]: AliasType<{
	query?:ResolverInputTypes["Query"],
	mutation?:ResolverInputTypes["Mutation"],
	subscription?:ResolverInputTypes["Subscription"],
		__typename?: boolean | `@${string}`
}>;
	["ID"]:unknown
  }

export type ModelTypes = {
    ["Permissions"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	name: string,
	roles: Array<ModelTypes["Role"]>
};
	/** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
["DateTime"]:any;
	["UserGroupModel"]: {
		id: ModelTypes["ID"],
	name: string
};
	["Users"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	status: ModelTypes["AccountStatus"],
	email?: string | undefined | null,
	username?: string | undefined | null,
	emailVerified: boolean,
	firstName: string,
	lastName: string,
	company?: string | undefined | null,
	department?: string | undefined | null,
	lastConnectionAt: ModelTypes["DateTime"],
	role: ModelTypes["Role"],
	roleId: string,
	groups?: Array<ModelTypes["UserGroupModel"]> | undefined | null
};
	["AccountStatus"]:AccountStatus;
	["UserPagination"]: {
		users: Array<ModelTypes["Users"] | undefined | null>,
	total: number
};
	["ImportUserError"]: {
		line: number,
	email: string,
	reason: string
};
	["ImportUsersReport"]: {
		createdCount: number,
	errorCount: number,
	errors: Array<ModelTypes["ImportUserError"]>
};
	["Role"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	name: string,
	permissions: Array<ModelTypes["Permissions"] | undefined | null>,
	users: Array<ModelTypes["Users"] | undefined | null>
};
	["DisabilityReferentModel"]: {
		name?: string | undefined | null,
	contact?: string | undefined | null
};
	["AccommodationRequestModel"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	needs: string,
	status: ModelTypes["AccommodationStatus"],
	response?: string | undefined | null,
	handledAt?: ModelTypes["DateTime"] | undefined | null
};
	["AccommodationStatus"]:AccommodationStatus;
	["OrgAccommodationRequestModel"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	needs: string,
	status: ModelTypes["AccommodationStatus"],
	response?: string | undefined | null,
	handledAt?: ModelTypes["DateTime"] | undefined | null,
	learnerName: string,
	learnerEmail?: string | undefined | null
};
	["MyAccommodationModel"]: {
		referent: ModelTypes["DisabilityReferentModel"],
	request?: ModelTypes["AccommodationRequestModel"] | undefined | null
};
	["UniqueAuth"]: {
		access_token: string,
	refresh_token: string,
	firstName: string,
	lastName: string,
	role: string,
	email?: string | undefined | null,
	id: string
};
	["Invitation"]: {
		status: ModelTypes["InvitationStatus"],
	email?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null
};
	["InvitationStatus"]:InvitationStatus;
	["UserInfo"]: {
		firstName: string,
	lastName: string,
	roles: ModelTypes["RoleEnum"],
	email?: string | undefined | null,
	username?: string | undefined | null,
	id: string,
	orgId?: string | undefined | null,
	impersonatorId?: string | undefined | null,
	capabilities: Array<ModelTypes["TrainerCapability"]>,
	orgSlug?: string | undefined | null
};
	["RoleEnum"]:RoleEnum;
	["TrainerCapability"]:TrainerCapability;
	["Mail"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	key: string,
	to: string,
	data: string
};
	["BillingAccountModel"]: {
		id: ModelTypes["ID"],
	tier: ModelTypes["BillingTier"],
	paymentTerm: ModelTypes["BillingPaymentTerm"],
	mode: ModelTypes["BillingMode"],
	tierChangedAt?: ModelTypes["DateTime"] | undefined | null,
	subscriptionStatus?: string | undefined | null,
	currentPeriodEnd?: ModelTypes["DateTime"] | undefined | null,
	cancelAtPeriodEnd: boolean,
	scheduledTier?: ModelTypes["BillingTier"] | undefined | null,
	scheduledPaymentTerm?: ModelTypes["BillingPaymentTerm"] | undefined | null,
	scheduledChangeAt?: ModelTypes["DateTime"] | undefined | null,
	cancelAt?: ModelTypes["DateTime"] | undefined | null,
	companyName?: string | undefined | null,
	addressLine1?: string | undefined | null,
	addressLine2?: string | undefined | null,
	postalCode?: string | undefined | null,
	city?: string | undefined | null,
	country?: string | undefined | null,
	vatNumber?: string | undefined | null,
	billingEmail?: string | undefined | null,
	subscribed: boolean,
	billingPortalAvailable: boolean,
	paymentFailed: boolean
};
	["BillingTier"]:BillingTier;
	["BillingPaymentTerm"]:BillingPaymentTerm;
	["BillingMode"]:BillingMode;
	["BillingOfferModel"]: {
		tier: ModelTypes["BillingTier"],
	capacity: number,
	monthlyPriceCents: number,
	upfrontYearlyAmountCents: number
};
	["LearnerCountersModel"]: {
		orgId: ModelTypes["ID"],
	orgName: string,
	orgSlug: string,
	month: string,
	monthlyActive: number,
	learnerCount: number,
	registeredLearners: number,
	leavingWithinThreeMonths: number,
	subscribedTier: ModelTypes["BillingTier"],
	effectiveTier: ModelTypes["BillingTier"],
	billedTier: ModelTypes["BillingTier"],
	placesRemaining?: number | undefined | null,
	nextTier?: ModelTypes["BillingTier"] | undefined | null,
	paymentTerm: ModelTypes["BillingPaymentTerm"],
	estimatedRevenueCents: number,
	managed: boolean,
	overCapacity: boolean
};
	["BillingEstimateModel"]: {
		month: string,
	subscribedTier: ModelTypes["BillingTier"],
	effectiveTier: ModelTypes["BillingTier"],
	billedTier: ModelTypes["BillingTier"],
	paymentTerm: ModelTypes["BillingPaymentTerm"],
	learnerCount: number,
	monthlyActive: number,
	registeredLearners: number,
	placesRemaining?: number | undefined | null,
	nextTier?: ModelTypes["BillingTier"] | undefined | null,
	leavingWithinThreeMonths: number,
	monthlyPriceCents?: number | undefined | null,
	monthlyAmountCents?: number | undefined | null,
	upfrontYearlyAmountCents?: number | undefined | null,
	isCustom: boolean,
	managed: boolean,
	overCapacity: boolean
};
	["BillingHistoryEntryModel"]: {
		month: string,
	monthlyActive: number,
	learnerCount: number,
	tier: ModelTypes["BillingTier"],
	amountCents: number
};
	["CapacityAlertModel"]: {
		learnerCount: number,
	tier: ModelTypes["BillingTier"],
	neededTier: ModelTypes["BillingTier"]
};
	["MyAccount"]: {
		id: ModelTypes["ID"],
	firstName: string,
	lastName: string,
	email?: string | undefined | null,
	username?: string | undefined | null,
	role: string,
	organizationName?: string | undefined | null,
	lastConnectionAt: ModelTypes["DateTime"],
	hasPassword: boolean
};
	["AppConfigModel"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	appName: string,
	logo?: string | undefined | null,
	logoDark?: string | undefined | null,
	favicon?: string | undefined | null,
	primaryColor?: string | undefined | null,
	primaryForeground?: string | undefined | null,
	accentColor?: string | undefined | null,
	accentForeground?: string | undefined | null,
	footerText?: string | undefined | null,
	defaultLocale: string,
	timezone: string,
	signupCtaVisible: boolean,
	billingSelfService: boolean
};
	["TrainerCapabilityModel"]: {
		capability: ModelTypes["TrainerCapability"],
	granted: boolean,
	dependsOn: Array<ModelTypes["TrainerCapability"]>
};
	["GroupMemberModel"]: {
		id: ModelTypes["ID"],
	email?: string | undefined | null,
	username?: string | undefined | null,
	firstName: string,
	lastName: string
};
	["GroupModel"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	name: string,
	description?: string | undefined | null,
	memberCount: number,
	members: Array<ModelTypes["GroupMemberModel"]>,
	memberIds: Array<ModelTypes["ID"]>
};
	["LoginEventModel"]: {
		id: ModelTypes["ID"],
	at: ModelTypes["DateTime"],
	method: ModelTypes["LoginMethod"]
};
	["LoginMethod"]:LoginMethod;
	["LoginEventPage"]: {
		events: Array<ModelTypes["LoginEventModel"]>,
	total: number
};
	["LearnerProfile"]: {
		id: ModelTypes["ID"],
	firstName: string,
	lastName: string,
	email?: string | undefined | null,
	username?: string | undefined | null,
	company?: string | undefined | null,
	department?: string | undefined | null,
	status: ModelTypes["AccountStatus"],
	roleName: string,
	roleId: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	groups: Array<ModelTypes["UserGroupModel"]>,
	trainingSeconds: number,
	loginCount: number,
	lastLoginAt?: ModelTypes["DateTime"] | undefined | null,
	averageDaysBetweenLogins?: number | undefined | null,
	completedModules: number,
	totalModules: number
};
	["UsernameCredentials"]: {
		userId: string,
	username: string,
	password: string
};
	["UsernameImportError"]: {
		line: number,
	username: string,
	reason: string
};
	["UsernameImportReport"]: {
		created: Array<ModelTypes["UsernameCredentials"]>,
	errors: Array<ModelTypes["UsernameImportError"]>
};
	["CertificateTemplateModel"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	name: string,
	isDefault: boolean,
	title: string,
	body: string,
	signature?: string | undefined | null,
	showScore: boolean,
	showDate: boolean,
	showTotalTime: boolean,
	emailOnUnlock: boolean,
	logo?: string | undefined | null,
	orientation: ModelTypes["CertificateOrientation"],
	hasSkeleton: boolean,
	marginTop: number,
	marginBottom: number,
	marginLeft: number,
	marginRight: number
};
	["CertificateOrientation"]:CertificateOrientation;
	["CertificateTemplateOptionModel"]: {
		id: ModelTypes["ID"],
	name: string,
	isDefault: boolean
};
	["ComplaintModel"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	category: ModelTypes["ComplaintCategory"],
	status: ModelTypes["ComplaintStatus"],
	origin: ModelTypes["ComplaintOrigin"],
	subject: string,
	message: string,
	response?: string | undefined | null,
	respondedAt?: ModelTypes["DateTime"] | undefined | null,
	resolvedAt?: ModelTypes["DateTime"] | undefined | null,
	authorName?: string | undefined | null,
	authorEmail?: string | undefined | null
};
	["ComplaintCategory"]:ComplaintCategory;
	["ComplaintStatus"]:ComplaintStatus;
	["ComplaintOrigin"]:ComplaintOrigin;
	["TrainingDocumentModel"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	title: string,
	fileName: string,
	sizeBytes: number,
	requiredBeforeStart: boolean,
	sessionId?: ModelTypes["ID"] | undefined | null,
	sessionName?: string | undefined | null,
	acknowledgementCount: number
};
	["DocumentAcknowledgementModel"]: {
		at: ModelTypes["DateTime"],
	name: string,
	email?: string | undefined | null
};
	["DownloadFile"]: {
		fileName: string,
	fileMimeType: string,
	url: string
};
	["MyFiles"]: {
		id: string,
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	eTag: string,
	location: string,
	fileName: string,
	fileMimeType: string,
	ownerId: string
};
	["UploadPreSignedUrl"]: {
		url: string,
	id: string
};
	["HomeCompletionModel"]: {
		sessionId: ModelTypes["ID"],
	sessionName: string,
	moduleId: ModelTypes["ID"],
	moduleTitle: string,
	learners: number
};
	["HomeSessionModel"]: {
		id: ModelTypes["ID"],
	name: string,
	startDate?: ModelTypes["DateTime"] | undefined | null,
	endDate?: ModelTypes["DateTime"] | undefined | null,
	enrolledLearners: number,
	pendingLearners: number
};
	["BackOfficeHomeModel"]: {
		firstName: string,
	timezone: string,
	completedToday: Array<ModelTypes["HomeCompletionModel"]>,
	startingSoon: Array<ModelTypes["HomeSessionModel"]>,
	endingSoon: Array<ModelTypes["HomeSessionModel"]>,
	overdue: Array<ModelTypes["HomeSessionModel"]>,
	overdueLearners: number,
	overdueSessions: number,
	neverStartedLearners: number
};
	["OrganizationModel"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	name: string,
	slug: string,
	status: ModelTypes["OrganizationStatus"],
	userCount: number,
	tier: ModelTypes["BillingTier"],
	billingMode: ModelTypes["BillingMode"],
	billingNote?: string | undefined | null
};
	["OrganizationStatus"]:OrganizationStatus;
	["OrgMemberModel"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	email?: string | undefined | null,
	username?: string | undefined | null,
	firstName: string,
	lastName: string,
	role: string,
	status: string
};
	["PositioningRatingModel"]: {
		objective: string,
	level: number
};
	["PositioningAnswerModel"]: {
		answeredAt: ModelTypes["DateTime"],
	ratings: Array<ModelTypes["PositioningRatingModel"]>,
	needs?: string | undefined | null
};
	["SessionPositioningModel"]: {
		sessionId: ModelTypes["ID"],
	sessionName: string,
	entry?: ModelTypes["PositioningAnswerModel"] | undefined | null,
	exit?: ModelTypes["PositioningAnswerModel"] | undefined | null
};
	["ImprovementActionModel"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	origin: ModelTypes["ImprovementOrigin"],
	status: ModelTypes["ImprovementStatus"],
	title: string,
	description: string,
	owner?: string | undefined | null,
	dueDate?: ModelTypes["DateTime"] | undefined | null,
	effect?: string | undefined | null,
	doneAt?: ModelTypes["DateTime"] | undefined | null
};
	["ImprovementOrigin"]:ImprovementOrigin;
	["ImprovementStatus"]:ImprovementStatus;
	["QualityRiskModel"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	title: string,
	description: string,
	/** Probabilité, de 1 (faible) à 3 (forte). */
	likelihood: number,
	/** Impact, de 1 (faible) à 3 (fort). */
	impact: number,
	/** Gravité = probabilité × impact, de 1 à 9. */
	severity: number,
	mitigation?: string | undefined | null,
	owner?: string | undefined | null,
	status: ModelTypes["QualityRiskStatus"]
};
	["QualityRiskStatus"]:QualityRiskStatus;
	["ReminderSettingsModel"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	enabled: boolean,
	firstDelayDays: number,
	frequencyDays: number,
	maxReminders: number,
	sendHour: number,
	subject: string,
	body: string,
	completionDigestEnabled: boolean,
	convocationEnabled: boolean
};
	["ReminderTestResultModel"]: {
		sent: boolean,
	to: string
};
	["ReportPeriodModel"]: {
		kind: ModelTypes["ReportPeriodKind"],
	from?: string | undefined | null,
	to?: string | undefined | null
};
	["ReportPeriodKind"]:ReportPeriodKind;
	["ReportFiltersModel"]: {
		sessionIds?: Array<ModelTypes["ID"]> | undefined | null,
	groupIds?: Array<ModelTypes["ID"]> | undefined | null,
	state?: ModelTypes["UserProgress"] | undefined | null,
	period?: ModelTypes["ReportPeriodModel"] | undefined | null
};
	["UserProgress"]:UserProgress;
	["ReportScheduleModel"]: {
		frequency: ModelTypes["ReportFrequency"],
	weekday?: number | undefined | null,
	monthDay?: number | undefined | null,
	hour: number,
	recipientIds: Array<ModelTypes["ID"]>,
	enabled: boolean,
	lastSentAt?: ModelTypes["DateTime"] | undefined | null
};
	["ReportFrequency"]:ReportFrequency;
	["ReportTemplateModel"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	name: string,
	granularity: ModelTypes["ReportGranularity"],
	columns: Array<string>,
	filters: ModelTypes["ReportFiltersModel"],
	schedule?: ModelTypes["ReportScheduleModel"] | undefined | null
};
	["ReportGranularity"]:ReportGranularity;
	["ReportColumnLabelModel"]: {
		fr: string,
	en: string
};
	["ReportColumnModel"]: {
		key: string,
	level: string,
	label: ModelTypes["ReportColumnLabelModel"]
};
	["ReportRecipientModel"]: {
		id: ModelTypes["ID"],
	firstName: string,
	lastName: string,
	email?: string | undefined | null
};
	["StorageUsageModel"]: {
		orgId: ModelTypes["ID"],
	orgName?: string | undefined | null,
	orgSlug?: string | undefined | null,
	usedBytes: number,
	quotaBytes?: number | undefined | null,
	remainingBytes?: number | undefined | null,
	plan: ModelTypes["BillingTier"],
	moduleCount: number,
	overQuota: boolean,
	maxUploadBytes: number
};
	["ScormModuleModel"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	title: string,
	description?: string | undefined | null,
	scormVersion?: string | undefined | null,
	launchUrl?: string | undefined | null,
	status: ModelTypes["ScormModuleStatus"],
	masteryScore?: number | undefined | null,
	durationMinutes?: number | undefined | null,
	sizeBytes: number,
	contentUpdatedAt?: ModelTypes["DateTime"] | undefined | null
};
	["ScormModuleStatus"]:ScormModuleStatus;
	["ScormScoModel"]: {
		identifier: string,
	title: string,
	href: string,
	position: number,
	masteryScore?: number | undefined | null
};
	["ScoreCorrectionModel"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	score: number,
	previousScore?: number | undefined | null,
	reason: string,
	correctedBy?: string | undefined | null,
	revokedAt?: ModelTypes["DateTime"] | undefined | null,
	revokedBy?: string | undefined | null
};
	["ScormInteractionModel"]: {
		scoIdentifier: string,
	index: number,
	interactionId: string,
	type?: string | undefined | null,
	description?: string | undefined | null,
	correctResponses: Array<string>,
	learnerResponse?: string | undefined | null,
	result?: string | undefined | null,
	weighting?: number | undefined | null,
	latency?: string | undefined | null,
	timestamp?: string | undefined | null,
	objectiveIds: Array<string>
};
	["QuestionAnswerModel"]: {
		userId: ModelTypes["ID"],
	response?: string | undefined | null,
	result?: string | undefined | null,
	score?: number | undefined | null,
	attemptNumber: number
};
	["QuestionStatModel"]: {
		scoIdentifier: string,
	interactionId: string,
	description?: string | undefined | null,
	type?: string | undefined | null,
	correctResponses: Array<string>,
	respondents: number,
	correctRate?: number | undefined | null,
	averageScore?: number | undefined | null,
	buckets: Array<number>,
	answers: Array<ModelTypes["QuestionAnswerModel"]>
};
	["QuestionLearnerModel"]: {
		id: ModelTypes["ID"],
	firstName: string,
	lastName: string,
	email?: string | undefined | null,
	username?: string | undefined | null
};
	["ModuleQuestionStatsModel"]: {
		questions: Array<ModelTypes["QuestionStatModel"]>,
	learners: Array<ModelTypes["QuestionLearnerModel"]>
};
	["LearnerAttemptModel"]: {
		sessionId: ModelTypes["ID"],
	sessionName: string,
	number: number,
	completionStatus: ModelTypes["ScormCompletionStatus"],
	successStatus: ModelTypes["ScormSuccessStatus"],
	scoreRaw?: number | undefined | null,
	scoreMax?: number | undefined | null,
	scoreScaled?: number | undefined | null,
	totalTime?: string | undefined | null,
	updatedAt: ModelTypes["DateTime"],
	interactions: Array<ModelTypes["ScormInteractionModel"]>
};
	["ScormCompletionStatus"]:ScormCompletionStatus;
	["ScormSuccessStatus"]:ScormSuccessStatus;
	["ScormScoStateModel"]: {
		scoIdentifier: string,
	completionStatus: ModelTypes["ScormCompletionStatus"],
	successStatus: ModelTypes["ScormSuccessStatus"],
	scoreRaw?: number | undefined | null,
	scoreMin?: number | undefined | null,
	scoreMax?: number | undefined | null,
	scoreScaled?: number | undefined | null,
	totalTime?: string | undefined | null,
	suspendData?: string | undefined | null,
	location?: string | undefined | null
};
	["ScormAttemptModel"]: {
		number: number,
	completionStatus: ModelTypes["ScormCompletionStatus"],
	successStatus: ModelTypes["ScormSuccessStatus"],
	scoreRaw?: number | undefined | null,
	scoreMin?: number | undefined | null,
	scoreMax?: number | undefined | null,
	scoreScaled?: number | undefined | null,
	totalTime?: string | undefined | null,
	interactions: Array<ModelTypes["ScormInteractionModel"]>,
	scoStates: Array<ModelTypes["ScormScoStateModel"]>
};
	["ScormTrackingModel"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	completionStatus: ModelTypes["ScormCompletionStatus"],
	successStatus: ModelTypes["ScormSuccessStatus"],
	scoreRaw?: number | undefined | null,
	scoreMin?: number | undefined | null,
	scoreMax?: number | undefined | null,
	scoreScaled?: number | undefined | null,
	totalTime?: string | undefined | null,
	totalTimeSeconds?: number | undefined | null,
	sessionTime?: string | undefined | null,
	suspendData?: string | undefined | null,
	location?: string | undefined | null,
	completedAt?: ModelTypes["DateTime"] | undefined | null,
	userId: string,
	sessionId: string,
	attemptNumber: number,
	currentAttempt?: ModelTypes["ScormAttemptModel"] | undefined | null,
	currentScoIdentifier?: string | undefined | null
};
	["ScormTrackingWithUser"]: {
		id: ModelTypes["ID"],
	correctedScore?: number | undefined | null,
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	completionStatus: ModelTypes["ScormCompletionStatus"],
	successStatus: ModelTypes["ScormSuccessStatus"],
	scoreRaw?: number | undefined | null,
	scoreMin?: number | undefined | null,
	scoreMax?: number | undefined | null,
	scoreScaled?: number | undefined | null,
	totalTime?: string | undefined | null,
	sessionTime?: string | undefined | null,
	suspendData?: string | undefined | null,
	location?: string | undefined | null,
	completedAt?: ModelTypes["DateTime"] | undefined | null,
	userId: string,
	userEmail?: string | undefined | null,
	userUsername?: string | undefined | null,
	userFirstName: string,
	userLastName: string,
	sessionId: string,
	sessionName: string
};
	["ScormTrackingStats"]: {
		total: number,
	learners: number,
	completed: number,
	inProgress: number,
	notStarted: number,
	completionUnknown: number,
	neverOpened: number,
	notYetUnlocked: number,
	passed: number,
	failed: number,
	averageScorePercent?: number | undefined | null,
	scoredCount: number,
	averageTimeSeconds?: number | undefined | null,
	timedCount: number,
	totalTimeSeconds: number
};
	["ScormCompletionPoint"]: {
		day: string,
	completed: number
};
	["ScormTrackingPagination"]: {
		trackings: Array<ModelTypes["ScormTrackingWithUser"] | undefined | null>,
	total: number
};
	["SessionParticipantResult"]: {
		userId: ModelTypes["ID"],
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	email?: string | undefined | null,
	username?: string | undefined | null,
	groups: Array<string>,
	state: ModelTypes["UserProgress"],
	completedModules: number,
	totalModules: number,
	averageScorePercent?: number | undefined | null,
	timeSpentSeconds: number,
	lastActivityAt?: ModelTypes["DateTime"] | undefined | null,
	droppedAt?: ModelTypes["DateTime"] | undefined | null,
	dropReason?: ModelTypes["DropoutReason"] | undefined | null,
	dropNote?: string | undefined | null
};
	["DropoutReason"]:DropoutReason;
	["SessionModuleResult"]: {
		moduleId: ModelTypes["ID"],
	completedCount: number
};
	["SessionResults"]: {
		stats: ModelTypes["ScormTrackingStats"],
	participants: Array<ModelTypes["SessionParticipantResult"]>,
	modules: Array<ModelTypes["SessionModuleResult"]>
};
	["LearnerDocumentModel"]: {
		id: ModelTypes["ID"],
	title: string,
	requiredBeforeStart: boolean,
	acknowledgedAt?: ModelTypes["DateTime"] | undefined | null
};
	["LearnerPositioningModel"]: {
		required: boolean,
	entryPending: boolean,
	entryDone: boolean,
	exitDone: boolean
};
	["SessionUserModel"]: {
		id: ModelTypes["ID"],
	email?: string | undefined | null,
	username?: string | undefined | null,
	firstName: string,
	lastName: string
};
	["SessionTrainerModel"]: {
		id: ModelTypes["ID"],
	email?: string | undefined | null,
	firstName: string,
	lastName: string,
	role: ModelTypes["RoleEnum"],
	assignedAt: ModelTypes["DateTime"]
};
	["SessionSectionModel"]: {
		id: ModelTypes["ID"],
	title: string,
	position: number
};
	["SessionModuleModel"]: {
		id: ModelTypes["ID"],
	position: number,
	unlockAt?: ModelTypes["DateTime"] | undefined | null,
	prerequisiteModuleId?: ModelTypes["ID"] | undefined | null,
	prerequisiteMinScore?: number | undefined | null,
	allowRetake: boolean,
	scoreRetention: ModelTypes["ScoreRetention"],
	sectionId?: ModelTypes["ID"] | undefined | null,
	module: ModelTypes["ScormModuleModel"],
	unlocked?: boolean | undefined | null,
	lockReason?: ModelTypes["ModuleLockReason"] | undefined | null,
	myTracking?: ModelTypes["ScormTrackingModel"] | undefined | null
};
	["ScoreRetention"]:ScoreRetention;
	["ModuleLockReason"]:ModuleLockReason;
	["SessionProgressModel"]: {
		totalModules: number,
	completedModules: number,
	completed: boolean
};
	["SessionTagModel"]: {
		id: ModelTypes["ID"],
	name: string
};
	["SessionCertificateModel"]: {
		unlocked: boolean,
	reason?: ModelTypes["CertificateLockReason"] | undefined | null,
	blockingModuleIds: Array<ModelTypes["ID"]>
};
	["CertificateLockReason"]:CertificateLockReason;
	["SessionModel"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	name: string,
	objectives: Array<string>,
	prerequisites?: string | undefined | null,
	audience?: string | undefined | null,
	teachingMethods?: string | undefined | null,
	assessmentMethods?: string | undefined | null,
	accessibility?: string | undefined | null,
	contact?: string | undefined | null,
	startDate?: ModelTypes["DateTime"] | undefined | null,
	endDate?: ModelTypes["DateTime"] | undefined | null,
	status: ModelTypes["SessionStatus"],
	progressionMode: ModelTypes["SessionProgressionMode"],
	certificateCondition: ModelTypes["CertificateCondition"],
	certificateMinScore?: number | undefined | null,
	certificateTemplateId?: ModelTypes["ID"] | undefined | null,
	module: ModelTypes["ScormModuleModel"],
	modules: Array<ModelTypes["SessionModuleModel"]>,
	sections: Array<ModelTypes["SessionSectionModel"]>,
	enrolledUsers: Array<ModelTypes["SessionUserModel"]>,
	tags: Array<ModelTypes["SessionTagModel"]>,
	trainers: Array<ModelTypes["SessionTrainerModel"]>,
	myTracking?: ModelTypes["ScormTrackingModel"] | undefined | null,
	myEnrolledAt?: ModelTypes["DateTime"] | undefined | null,
	progress?: ModelTypes["SessionProgressModel"] | undefined | null,
	certificate?: ModelTypes["SessionCertificateModel"] | undefined | null,
	positioningEnabled: boolean,
	myPositioning?: ModelTypes["LearnerPositioningModel"] | undefined | null,
	documents?: Array<ModelTypes["LearnerDocumentModel"]> | undefined | null
};
	["SessionStatus"]:SessionStatus;
	["SessionProgressionMode"]:SessionProgressionMode;
	["CertificateCondition"]:CertificateCondition;
	["RequestTrialResult"]: {
		accepted: boolean
};
	["ConfirmTrialResult"]: {
		status: ModelTypes["TrialReviewStatus"],
	email: string,
	slug?: string | undefined | null,
	rejectionReason?: string | undefined | null
};
	["TrialReviewStatus"]:TrialReviewStatus;
	["TrialRequestModel"]: {
		id: ModelTypes["ID"],
	email: string,
	firstName: string,
	lastName: string,
	orgName: string,
	jobTitle?: string | undefined | null,
	phone?: string | undefined | null,
	createdAt: ModelTypes["DateTime"],
	emailConfirmedAt: ModelTypes["DateTime"]
};
	["ApproveTrialResult"]: {
		slug: string
};
	["SsoOrgSettingsModel"]: {
		enabled: boolean
};
	["SsoPresetModel"]: {
		kind: ModelTypes["SsoProviderKind"],
	protocol: string,
	defaultLabel: string,
	defaultIssuer?: string | undefined | null,
	issuerHint?: string | undefined | null,
	sharedIssuer: boolean
};
	["SsoProviderKind"]:SsoProviderKind;
	["SsoProviderModel"]: {
		id: ModelTypes["ID"],
	kind: ModelTypes["SsoProviderKind"],
	protocol: string,
	label: string,
	enabled: boolean,
	issuer?: string | undefined | null,
	clientId?: string | undefined | null,
	hasClientSecret: boolean,
	entryPoint?: string | undefined | null,
	idpIssuer?: string | undefined | null,
	idpCert?: string | undefined | null,
	allowedDomains: Array<string>,
	requiresAllowedDomains: boolean,
	callbackUrl: string,
	metadataUrl?: string | undefined | null
};
	["PublicSsoProviderModel"]: {
		id: ModelTypes["ID"],
	kind: ModelTypes["SsoProviderKind"],
	label: string,
	loginUrl: string
};
	["SurveyQuestionModel"]: {
		id: ModelTypes["ID"],
	position: number,
	kind: ModelTypes["SurveyQuestionKind"],
	label: string,
	isOverall: boolean
};
	["SurveyQuestionKind"]:SurveyQuestionKind;
	["SurveyModuleModel"]: {
		id: ModelTypes["ID"],
	title: string
};
	["LearnerSurveyModel"]: {
		pending: boolean,
	questions: Array<ModelTypes["SurveyQuestionModel"]>,
	modules: Array<ModelTypes["SurveyModuleModel"]>
};
	["SurveyQuestionAverageModel"]: {
		questionId: ModelTypes["ID"],
	label: string,
	average: number,
	count: number
};
	["SurveyModuleAverageModel"]: {
		moduleId: ModelTypes["ID"],
	title: string,
	average: number,
	count: number
};
	["SurveyCommentModel"]: {
		label: string,
	text: string,
	at: ModelTypes["DateTime"]
};
	["SurveyResultsModel"]: {
		answered: number,
	skipped: number,
	satisfactionRate?: number | undefined | null,
	questions: Array<ModelTypes["SurveyQuestionAverageModel"]>,
	modules: Array<ModelTypes["SurveyModuleAverageModel"]>,
	comments: Array<ModelTypes["SurveyCommentModel"]>
};
	["WebhookEndpointModel"]: {
		url: string,
	enabled: boolean,
	updatedAt: ModelTypes["DateTime"]
};
	["WebhookEndpointSaveResult"]: {
		endpoint: ModelTypes["WebhookEndpointModel"],
	secret?: string | undefined | null
};
	["WebhookDeliveryModel"]: {
		id: ModelTypes["ID"],
	event: string,
	status: ModelTypes["WebhookDeliveryStatus"],
	attempts: number,
	lastStatusCode?: number | undefined | null,
	lastError?: string | undefined | null,
	createdAt: ModelTypes["DateTime"],
	nextAttemptAt?: ModelTypes["DateTime"] | undefined | null,
	deliveredAt?: ModelTypes["DateTime"] | undefined | null
};
	["WebhookDeliveryStatus"]:WebhookDeliveryStatus;
	["Health"]: {
		env: string,
	time: string,
	status: string,
	version: string
};
	["StatsNotice"]: {
		status: ModelTypes["ConsentStatus"],
	acknowledgedAt?: ModelTypes["DateTime"] | undefined | null,
	version?: string | undefined | null,
	currentVersion: string,
	needsAcknowledgement: boolean
};
	["ConsentStatus"]:ConsentStatus;
	["PendingLegalDocument"]: {
		document: ModelTypes["LegalDocument"],
	version: string
};
	["LegalDocument"]:LegalDocument;
	["LegalAcceptance"]: {
		pending: Array<ModelTypes["PendingLegalDocument"]>
};
	["Query"]: {
		getHealthGql: ModelTypes["Health"],
	getRole: ModelTypes["Role"],
	getRoles: Array<ModelTypes["Role"]>,
	getPermission: ModelTypes["Permissions"],
	getPermissions: Array<ModelTypes["Permissions"]>,
	trainerCapabilities: Array<ModelTypes["TrainerCapabilityModel"]>,
	webhookEndpoint?: ModelTypes["WebhookEndpointModel"] | undefined | null,
	webhookDeliveries: Array<ModelTypes["WebhookDeliveryModel"]>,
	getMail: ModelTypes["Mail"],
	getMails: Array<ModelTypes["Mail"]>,
	appConfig: ModelTypes["AppConfigModel"],
	learnerCounters: ModelTypes["LearnerCountersModel"],
	capacityAlert?: ModelTypes["CapacityAlertModel"] | undefined | null,
	learnerCountersByOrganization: Array<ModelTypes["LearnerCountersModel"]>,
	billingAccount: ModelTypes["BillingAccountModel"],
	billingOffers: Array<ModelTypes["BillingOfferModel"]>,
	billingEstimate: ModelTypes["BillingEstimateModel"],
	billingHistory: Array<ModelTypes["BillingHistoryEntryModel"]>,
	invitation: ModelTypes["Invitation"],
	me: ModelTypes["UserInfo"],
	myAccount: ModelTypes["MyAccount"],
	complaints: Array<ModelTypes["ComplaintModel"]>,
	mySurvey: ModelTypes["LearnerSurveyModel"],
	surveyQuestions: Array<ModelTypes["SurveyQuestionModel"]>,
	surveyResults: ModelTypes["SurveyResultsModel"],
	improvementActions: Array<ModelTypes["ImprovementActionModel"]>,
	qualityRisks: Array<ModelTypes["QualityRiskModel"]>,
	learnerPositioning: Array<ModelTypes["SessionPositioningModel"]>,
	getUsers: Array<ModelTypes["Users"]>,
	getExistingUserEmails: Array<string>,
	getFilteredUsers: ModelTypes["UserPagination"],
	learnerProfile: ModelTypes["LearnerProfile"],
	learnerLogins: ModelTypes["LoginEventPage"],
	groups: Array<ModelTypes["GroupModel"]>,
	group: ModelTypes["GroupModel"],
	trainingDocuments: Array<ModelTypes["TrainingDocumentModel"]>,
	documentAcknowledgements: Array<ModelTypes["DocumentAcknowledgementModel"]>,
	myAccommodation: ModelTypes["MyAccommodationModel"],
	accommodationRequests: Array<ModelTypes["OrgAccommodationRequestModel"]>,
	disabilityReferent: ModelTypes["DisabilityReferentModel"],
	ssoProviders: Array<ModelTypes["PublicSsoProviderModel"]>,
	ssoSettings: ModelTypes["SsoOrgSettingsModel"],
	ssoPresets: Array<ModelTypes["SsoPresetModel"]>,
	ssoProviderConfigs: Array<ModelTypes["SsoProviderModel"]>,
	scormModules: Array<ModelTypes["ScormModuleModel"]>,
	scormModule: ModelTypes["ScormModuleModel"],
	moduleScos: Array<ModelTypes["ScormScoModel"]>,
	storageUsage: ModelTypes["StorageUsageModel"],
	storageUsageByOrganization: Array<ModelTypes["StorageUsageModel"]>,
	getMyScormTracking?: ModelTypes["ScormTrackingModel"] | undefined | null,
	myScormResume?: ModelTypes["ScormTrackingModel"] | undefined | null,
	getScormTrackings: ModelTypes["ScormTrackingPagination"],
	getScormTrackingStats: ModelTypes["ScormTrackingStats"],
	getScormCompletionsByDay: Array<ModelTypes["ScormCompletionPoint"]>,
	moduleQuestionStats: ModelTypes["ModuleQuestionStatsModel"],
	learnerModuleAttempts: Array<ModelTypes["LearnerAttemptModel"]>,
	scoreCorrections: Array<ModelTypes["ScoreCorrectionModel"]>,
	sessionResults: ModelTypes["SessionResults"],
	sessions: Array<ModelTypes["SessionModel"]>,
	session: ModelTypes["SessionModel"],
	userSessions: Array<ModelTypes["SessionModel"]>,
	mySessions: Array<ModelTypes["SessionModel"]>,
	pendingTrialRequests: Array<ModelTypes["TrialRequestModel"]>,
	backOfficeHome: ModelTypes["BackOfficeHomeModel"],
	certificateTemplates: Array<ModelTypes["CertificateTemplateModel"]>,
	certificateTemplateOptions: Array<ModelTypes["CertificateTemplateOptionModel"]>,
	certificateTemplate: ModelTypes["CertificateTemplateModel"],
	downloadFile: ModelTypes["DownloadFile"],
	getAllMyFiles: Array<ModelTypes["MyFiles"]>,
	publishBasicSubscription: boolean,
	myStatsNotice: ModelTypes["StatsNotice"],
	myLegalAcceptance: ModelTypes["LegalAcceptance"],
	organizations: Array<ModelTypes["OrganizationModel"]>,
	organizationMembers: Array<ModelTypes["OrgMemberModel"]>,
	findOrganization?: string | undefined | null,
	reminderSettings: ModelTypes["ReminderSettingsModel"],
	reportTemplates: Array<ModelTypes["ReportTemplateModel"]>,
	reportTemplate: ModelTypes["ReportTemplateModel"],
	reportColumns: Array<ModelTypes["ReportColumnModel"]>,
	reportRecipients: Array<ModelTypes["ReportRecipientModel"]>
};
	["FindManyUserWithFiltersInput"]: {
	skip: number,
	take: number,
	searchInput: string,
	orderBy?: ModelTypes["UserOrderByInput"] | undefined | null,
	filterBy?: ModelTypes["UserFilterByInput"] | undefined | null
};
	["UserOrderByInput"]: {
	email?: ModelTypes["OrderByEnum"] | undefined | null,
	firstName?: ModelTypes["OrderByEnum"] | undefined | null,
	lastName?: ModelTypes["OrderByEnum"] | undefined | null,
	lastConnectionAt?: ModelTypes["OrderByEnum"] | undefined | null,
	role?: ModelTypes["OrderByEnum"] | undefined | null,
	status?: ModelTypes["OrderByEnum"] | undefined | null
};
	["OrderByEnum"]:OrderByEnum;
	["UserFilterByInput"]: {
	role?: Array<string> | undefined | null,
	group?: Array<ModelTypes["ID"]> | undefined | null,
	progress?: ModelTypes["UserProgress"] | undefined | null
};
	["FindManyScormTrackingWithFiltersInput"]: {
	skip: number,
	take: number,
	searchInput?: string | undefined | null,
	orderBy?: ModelTypes["ScormTrackingOrderByInput"] | undefined | null,
	filterBy?: ModelTypes["ScormTrackingFilterByInput"] | undefined | null
};
	["ScormTrackingOrderByInput"]: {
	userEmail?: ModelTypes["OrderByEnum"] | undefined | null,
	userFirstName?: ModelTypes["OrderByEnum"] | undefined | null,
	userLastName?: ModelTypes["OrderByEnum"] | undefined | null,
	completionStatus?: ModelTypes["OrderByEnum"] | undefined | null,
	successStatus?: ModelTypes["OrderByEnum"] | undefined | null,
	scoreRaw?: ModelTypes["OrderByEnum"] | undefined | null,
	completedAt?: ModelTypes["OrderByEnum"] | undefined | null
};
	["ScormTrackingFilterByInput"]: {
	completionStatus?: ModelTypes["ScormCompletionStatus"] | undefined | null,
	successStatus?: ModelTypes["ScormSuccessStatus"] | undefined | null,
	sessionId?: ModelTypes["ID"] | undefined | null,
	groupId?: ModelTypes["ID"] | undefined | null
};
	["ScormTrackingStatsInput"]: {
	searchInput?: string | undefined | null,
	filterBy?: ModelTypes["ScormStatsScopeInput"] | undefined | null
};
	["ScormStatsScopeInput"]: {
	sessionId?: ModelTypes["ID"] | undefined | null,
	groupId?: ModelTypes["ID"] | undefined | null
};
	["ScormTrendInput"]: {
	days?: number | undefined | null,
	filterBy?: ModelTypes["ScormStatsScopeInput"] | undefined | null
};
	["ModuleQuestionsInput"]: {
	moduleId: ModelTypes["ID"],
	sessionId?: ModelTypes["ID"] | undefined | null,
	groupId?: ModelTypes["ID"] | undefined | null,
	from?: string | undefined | null,
	to?: string | undefined | null
};
	["LearnerModuleAttemptsInput"]: {
	userId: ModelTypes["ID"],
	moduleId: ModelTypes["ID"],
	sessionId?: ModelTypes["ID"] | undefined | null
};
	["Mutation"]: {
		updateTrainerCapabilities: Array<ModelTypes["TrainerCapabilityModel"]>,
	saveWebhookEndpoint: ModelTypes["WebhookEndpointSaveResult"],
	regenerateWebhookSecret: string,
	sendWebhookTest: boolean,
	updateAppConfig: ModelTypes["AppConfigModel"],
	updateBillingProfile: ModelTypes["BillingAccountModel"],
	startCheckout: string,
	openBillingPortal: string,
	setOrganizationPlan: ModelTypes["BillingAccountModel"],
	setOrganizationBillingMode: ModelTypes["BillingAccountModel"],
	login: ModelTypes["AuthType"],
	requestMagicLink: boolean,
	loginWithMagicLink: ModelTypes["AuthType"],
	askForResetPassword: boolean,
	reSendEmailValidation: boolean,
	resetPassword: boolean,
	verifyEmail: boolean,
	finishRegister: ModelTypes["InvitationStatus"],
	refresh: ModelTypes["AuthType"],
	logout: boolean,
	uniqueAuthFromSso: ModelTypes["UniqueAuth"],
	impersonateUser: ModelTypes["AuthType"],
	stopImpersonate: ModelTypes["AuthType"],
	updateMyProfile: ModelTypes["MyAccount"],
	changeMyPassword: boolean,
	createComplaint: ModelTypes["ComplaintModel"],
	updateComplaint: ModelTypes["ComplaintModel"],
	sendContactRequest: boolean,
	replaceSurveyQuestions: Array<ModelTypes["SurveyQuestionModel"]>,
	submitSurvey: boolean,
	skipSurvey: boolean,
	createImprovementAction: ModelTypes["ImprovementActionModel"],
	updateImprovementAction: ModelTypes["ImprovementActionModel"],
	createQualityRisk: ModelTypes["QualityRiskModel"],
	updateQualityRisk: ModelTypes["QualityRiskModel"],
	submitPositioning: boolean,
	createUser: ModelTypes["Users"],
	importUsers: ModelTypes["ImportUsersReport"],
	updateUser: ModelTypes["Users"],
	deleteUser: boolean,
	createUsernameLearner: ModelTypes["UsernameCredentials"],
	importUsernameLearners: ModelTypes["UsernameImportReport"],
	resetUsernameLearnerPassword: ModelTypes["UsernameCredentials"],
	createGroup: ModelTypes["GroupModel"],
	updateGroup: ModelTypes["GroupModel"],
	deleteGroup: boolean,
	addUsersToGroup: number,
	removeUsersFromGroup: number,
	updateTrainingDocument: ModelTypes["TrainingDocumentModel"],
	archiveTrainingDocument: boolean,
	acknowledgeDocument: boolean,
	submitAccommodation: ModelTypes["AccommodationRequestModel"],
	withdrawAccommodation: boolean,
	respondAccommodation: boolean,
	updateDisabilityReferent: ModelTypes["DisabilityReferentModel"],
	setSsoEnabled: ModelTypes["SsoOrgSettingsModel"],
	upsertSsoProvider: ModelTypes["SsoProviderModel"],
	deleteSsoProvider: boolean,
	renameScormModule: ModelTypes["ScormModuleModel"],
	deleteScormModule: boolean,
	applyModuleReplacement: ModelTypes["ScormModuleModel"],
	cancelModuleReplacement: boolean,
	startScormAttempt?: ModelTypes["ScormTrackingModel"] | undefined | null,
	upsertScormTracking: ModelTypes["ScormTrackingModel"],
	correctScore: boolean,
	revokeScoreCorrection: boolean,
	createSession: ModelTypes["SessionModel"],
	updateSession: ModelTypes["SessionModel"],
	deleteSession: boolean,
	declareDropout: boolean,
	cancelDropout: boolean,
	requestTrialOrganization: ModelTypes["RequestTrialResult"],
	confirmTrialOrganization: ModelTypes["ConfirmTrialResult"],
	approveTrialRequest: ModelTypes["ApproveTrialResult"],
	rejectTrialRequest: boolean,
	createCertificateTemplate: ModelTypes["CertificateTemplateModel"],
	duplicateCertificateTemplate: ModelTypes["CertificateTemplateModel"],
	setDefaultCertificateTemplate: ModelTypes["CertificateTemplateModel"],
	deleteCertificateTemplate: boolean,
	updateCertificateTemplate: ModelTypes["CertificateTemplateModel"],
	deleteFile: boolean,
	uploadPreSignedUrl: ModelTypes["UploadPreSignedUrl"],
	confirmUpload: boolean,
	acknowledgeStatsNotice: ModelTypes["StatsNotice"],
	acceptLegalDocuments: ModelTypes["LegalAcceptance"],
	createOrganization: ModelTypes["OrganizationModel"],
	setOrganizationStatus: ModelTypes["OrganizationModel"],
	updateOrganization: ModelTypes["OrganizationModel"],
	deleteOrganization: boolean,
	inviteOrgMember: ModelTypes["OrgMemberModel"],
	setOrgMemberRole: ModelTypes["OrgMemberModel"],
	removeOrgMember: boolean,
	updateReminderSettings: ModelTypes["ReminderSettingsModel"],
	sendReminderTest: ModelTypes["ReminderTestResultModel"],
	createReportTemplate: ModelTypes["ReportTemplateModel"],
	updateReportTemplate: ModelTypes["ReportTemplateModel"],
	duplicateReportTemplate: ModelTypes["ReportTemplateModel"],
	upsertReportSchedule: ModelTypes["ReportTemplateModel"],
	deleteReportSchedule: ModelTypes["ReportTemplateModel"],
	deleteReportTemplate: boolean
};
	["TrainerCapabilityGrantInput"]: {
	capability: ModelTypes["TrainerCapability"],
	granted: boolean
};
	["SaveWebhookEndpointInput"]: {
	url: string,
	enabled: boolean
};
	["UpdateAppConfigInput"]: {
	appName?: string | undefined | null,
	logo?: string | undefined | null,
	logoDark?: string | undefined | null,
	favicon?: string | undefined | null,
	primaryColor?: string | undefined | null,
	primaryForeground?: string | undefined | null,
	accentColor?: string | undefined | null,
	accentForeground?: string | undefined | null,
	footerText?: string | undefined | null,
	defaultLocale?: string | undefined | null
};
	["UpdateBillingProfileInput"]: {
	companyName?: string | undefined | null,
	addressLine1?: string | undefined | null,
	addressLine2?: string | undefined | null,
	postalCode?: string | undefined | null,
	city?: string | undefined | null,
	country?: string | undefined | null,
	vatNumber?: string | undefined | null,
	billingEmail?: string | undefined | null
};
	["StartCheckoutInput"]: {
	tier: ModelTypes["BillingTier"],
	paymentTerm: ModelTypes["BillingPaymentTerm"]
};
	["ChangeBillingPlanInput"]: {
	tier: ModelTypes["BillingTier"],
	paymentTerm?: ModelTypes["BillingPaymentTerm"] | undefined | null
};
	["SetBillingModeInput"]: {
	mode: ModelTypes["BillingMode"],
	note?: string | undefined | null
};
	["AuthType"]:ModelTypes["UserInfo"] | ModelTypes["CustomError"];
	["CustomError"]: {
		error: ModelTypes["EError"],
	message: string
};
	["EError"]:EError;
	["UpdateMyProfileInput"]: {
	firstName: string,
	lastName: string
};
	["CreateComplaintInput"]: {
	category: ModelTypes["ComplaintCategory"],
	subject: string,
	message: string,
	authorId?: ModelTypes["ID"] | undefined | null
};
	["UpdateComplaintInput"]: {
	id: ModelTypes["ID"],
	category?: ModelTypes["ComplaintCategory"] | undefined | null,
	status?: ModelTypes["ComplaintStatus"] | undefined | null,
	response?: string | undefined | null
};
	["ContactRequestInput"]: {
	subject: string,
	message: string,
	pageUrl: string,
	locale: string,
	attachment?: string | undefined | null,
	category?: ModelTypes["ComplaintCategory"] | undefined | null
};
	["SurveyQuestionInput"]: {
	kind: ModelTypes["SurveyQuestionKind"],
	label: string,
	isOverall?: boolean | undefined | null
};
	["SubmitSurveyInput"]: {
	sessionId: ModelTypes["ID"],
	answers: Array<ModelTypes["SurveyAnswerInput"]>,
	moduleRatings: Array<ModelTypes["ModuleRatingInput"]>
};
	["SurveyAnswerInput"]: {
	questionId: ModelTypes["ID"],
	rating?: number | undefined | null,
	text?: string | undefined | null
};
	["ModuleRatingInput"]: {
	moduleId: ModelTypes["ID"],
	rating: number
};
	["CreateImprovementActionInput"]: {
	origin: ModelTypes["ImprovementOrigin"],
	title: string,
	description: string,
	owner?: string | undefined | null,
	dueDate?: string | undefined | null
};
	["UpdateImprovementActionInput"]: {
	id: ModelTypes["ID"],
	origin?: ModelTypes["ImprovementOrigin"] | undefined | null,
	status?: ModelTypes["ImprovementStatus"] | undefined | null,
	title?: string | undefined | null,
	description?: string | undefined | null,
	owner?: string | undefined | null,
	dueDate?: string | undefined | null,
	effect?: string | undefined | null
};
	["CreateQualityRiskInput"]: {
	title: string,
	description: string,
	likelihood: number,
	impact: number,
	mitigation?: string | undefined | null,
	owner?: string | undefined | null
};
	["UpdateQualityRiskInput"]: {
	id: ModelTypes["ID"],
	title?: string | undefined | null,
	description?: string | undefined | null,
	likelihood?: number | undefined | null,
	impact?: number | undefined | null,
	mitigation?: string | undefined | null,
	owner?: string | undefined | null,
	status?: ModelTypes["QualityRiskStatus"] | undefined | null
};
	["SubmitPositioningInput"]: {
	sessionId: ModelTypes["ID"],
	phase: ModelTypes["PositioningPhase"],
	ratings: Array<ModelTypes["PositioningRatingInput"]>,
	needs?: string | undefined | null
};
	["PositioningPhase"]:PositioningPhase;
	["PositioningRatingInput"]: {
	index: number,
	level: number
};
	["CreateUserInput"]: {
	email: string,
	password?: string | undefined | null,
	firstName: string,
	lastName: string,
	roleId: string,
	group?: string | undefined | null,
	company?: string | undefined | null,
	department?: string | undefined | null
};
	["ImportUserInput"]: {
	email: string,
	firstName: string,
	lastName: string,
	group?: string | undefined | null,
	company?: string | undefined | null,
	department?: string | undefined | null
};
	["UpdateUserInput"]: {
	email?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	roleId?: string | undefined | null,
	company?: string | undefined | null,
	department?: string | undefined | null,
	id: string
};
	["CreateUsernameLearnerInput"]: {
	username: string,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	password?: string | undefined | null,
	group?: string | undefined | null,
	company?: string | undefined | null,
	department?: string | undefined | null
};
	["ImportUsernameLearnerInput"]: {
	username: string,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	group?: string | undefined | null,
	company?: string | undefined | null,
	department?: string | undefined | null
};
	["CreateGroupInput"]: {
	name: string,
	description?: string | undefined | null,
	userIds?: Array<ModelTypes["ID"]> | undefined | null
};
	["UpdateGroupInput"]: {
	name?: string | undefined | null,
	description?: string | undefined | null,
	userIds?: Array<ModelTypes["ID"]> | undefined | null
};
	["UpdateTrainingDocumentInput"]: {
	id: ModelTypes["ID"],
	title?: string | undefined | null,
	sessionId?: ModelTypes["ID"] | undefined | null,
	requiredBeforeStart?: boolean | undefined | null
};
	["SubmitAccommodationInput"]: {
	needs: string,
	consent: boolean
};
	["RespondAccommodationInput"]: {
	id: ModelTypes["ID"],
	response?: string | undefined | null,
	handled: boolean
};
	["DisabilityReferentInput"]: {
	name?: string | undefined | null,
	contact?: string | undefined | null
};
	["UpsertSsoProviderInput"]: {
	kind: ModelTypes["SsoProviderKind"],
	label?: string | undefined | null,
	enabled?: boolean | undefined | null,
	issuer?: string | undefined | null,
	clientId?: string | undefined | null,
	clientSecret?: string | undefined | null,
	entryPoint?: string | undefined | null,
	idpIssuer?: string | undefined | null,
	idpCert?: string | undefined | null,
	allowedDomains?: Array<string> | undefined | null
};
	["UpsertScormTrackingInput"]: {
	sessionId: ModelTypes["ID"],
	moduleId?: ModelTypes["ID"] | undefined | null,
	attemptNumber?: number | undefined | null,
	completionStatus?: ModelTypes["ScormCompletionStatus"] | undefined | null,
	successStatus?: ModelTypes["ScormSuccessStatus"] | undefined | null,
	scoreRaw?: number | undefined | null,
	scoreMin?: number | undefined | null,
	scoreMax?: number | undefined | null,
	scoreScaled?: number | undefined | null,
	totalTime?: string | undefined | null,
	sessionTime?: string | undefined | null,
	suspendData?: string | undefined | null,
	location?: string | undefined | null,
	interactions?: Array<ModelTypes["ScormInteractionInput"]> | undefined | null,
	scoIdentifier?: string | undefined | null
};
	["ScormInteractionInput"]: {
	index: number,
	id: string,
	type?: string | undefined | null,
	description?: string | undefined | null,
	correctResponses?: Array<string> | undefined | null,
	learnerResponse?: string | undefined | null,
	result?: string | undefined | null,
	weighting?: number | undefined | null,
	latency?: string | undefined | null,
	timestamp?: string | undefined | null,
	objectiveIds?: Array<string> | undefined | null
};
	["CorrectScoreInput"]: {
	trackingId: ModelTypes["ID"],
	percent: number,
	reason: string
};
	["CreateSessionInput"]: {
	name: string,
	modules: Array<ModelTypes["SessionModuleInput"]>,
	sections?: Array<ModelTypes["SessionSectionInput"]> | undefined | null,
	progressionMode?: ModelTypes["SessionProgressionMode"] | undefined | null,
	tags?: Array<string> | undefined | null,
	certificateCondition?: ModelTypes["CertificateCondition"] | undefined | null,
	certificateMinScore?: number | undefined | null,
	certificateTemplateId?: ModelTypes["ID"] | undefined | null,
	/** Jour civil au format AAAA-MM-JJ */
	startDate?: string | undefined | null,
	/** Jour civil au format AAAA-MM-JJ */
	endDate?: string | undefined | null,
	userIds?: Array<ModelTypes["ID"]> | undefined | null,
	trainerIds?: Array<ModelTypes["ID"]> | undefined | null,
	sheet?: ModelTypes["TrainingSheetInput"] | undefined | null
};
	["SessionModuleInput"]: {
	moduleId: ModelTypes["ID"],
	/** Jour civil au format AAAA-MM-JJ */
	unlockAt?: string | undefined | null,
	prerequisiteModuleId?: ModelTypes["ID"] | undefined | null,
	prerequisiteMinScore?: number | undefined | null,
	allowRetake?: boolean | undefined | null,
	scoreRetention?: ModelTypes["ScoreRetention"] | undefined | null,
	sectionIndex?: number | undefined | null
};
	["SessionSectionInput"]: {
	title: string
};
	["TrainingSheetInput"]: {
	objectives?: Array<string> | undefined | null,
	prerequisites?: string | undefined | null,
	audience?: string | undefined | null,
	teachingMethods?: string | undefined | null,
	assessmentMethods?: string | undefined | null,
	accessibility?: string | undefined | null,
	contact?: string | undefined | null,
	positioningEnabled?: boolean | undefined | null
};
	["UpdateSessionInput"]: {
	name?: string | undefined | null,
	/** Jour civil au format AAAA-MM-JJ */
	startDate?: string | undefined | null,
	/** Jour civil au format AAAA-MM-JJ */
	endDate?: string | undefined | null,
	status?: ModelTypes["SessionStatus"] | undefined | null,
	tags?: Array<string> | undefined | null,
	certificateCondition?: ModelTypes["CertificateCondition"] | undefined | null,
	certificateMinScore?: number | undefined | null,
	certificateTemplateId?: ModelTypes["ID"] | undefined | null,
	progressionMode?: ModelTypes["SessionProgressionMode"] | undefined | null,
	modules?: Array<ModelTypes["SessionModuleInput"]> | undefined | null,
	sections?: Array<ModelTypes["SessionSectionInput"]> | undefined | null,
	userIds?: Array<ModelTypes["ID"]> | undefined | null,
	trainerIds?: Array<ModelTypes["ID"]> | undefined | null,
	sheet?: ModelTypes["TrainingSheetInput"] | undefined | null
};
	["DeclareDropoutInput"]: {
	sessionId: ModelTypes["ID"],
	userId: ModelTypes["ID"],
	reason: ModelTypes["DropoutReason"],
	note?: string | undefined | null
};
	["SessionEnrollmentRefInput"]: {
	sessionId: ModelTypes["ID"],
	userId: ModelTypes["ID"]
};
	["RequestTrialInput"]: {
	email: string,
	firstName: string,
	lastName: string,
	orgName: string,
	phone?: string | undefined | null,
	jobTitle?: string | undefined | null,
	acceptTerms: boolean
};
	["UpdateCertificateTemplateInput"]: {
	name?: string | undefined | null,
	title?: string | undefined | null,
	body?: string | undefined | null,
	signature?: string | undefined | null,
	showScore?: boolean | undefined | null,
	showDate?: boolean | undefined | null,
	showTotalTime?: boolean | undefined | null,
	emailOnUnlock?: boolean | undefined | null,
	logo?: string | undefined | null,
	orientation?: ModelTypes["CertificateOrientation"] | undefined | null,
	skeletonPdf?: string | undefined | null,
	marginTop?: number | undefined | null,
	marginBottom?: number | undefined | null,
	marginLeft?: number | undefined | null,
	marginRight?: number | undefined | null
};
	["CreateOrganizationInput"]: {
	name: string,
	slug: string,
	adminEmail: string,
	adminFirstName: string,
	adminLastName: string
};
	["UpdateOrganizationInput"]: {
	id: ModelTypes["ID"],
	name?: string | undefined | null,
	slug?: string | undefined | null,
	status?: ModelTypes["OrganizationStatus"] | undefined | null
};
	["InviteOrgMemberInput"]: {
	orgId: ModelTypes["ID"],
	email: string,
	firstName: string,
	lastName: string,
	role: ModelTypes["RoleEnum"]
};
	["SetOrgMemberRoleInput"]: {
	orgId: ModelTypes["ID"],
	userId: ModelTypes["ID"],
	role: ModelTypes["RoleEnum"]
};
	["UpdateReminderSettingsInput"]: {
	enabled?: boolean | undefined | null,
	firstDelayDays?: number | undefined | null,
	frequencyDays?: number | undefined | null,
	maxReminders?: number | undefined | null,
	sendHour?: number | undefined | null,
	subject?: string | undefined | null,
	body?: string | undefined | null,
	completionDigestEnabled?: boolean | undefined | null,
	convocationEnabled?: boolean | undefined | null
};
	["ReportTemplateInput"]: {
	name: string,
	granularity: ModelTypes["ReportGranularity"],
	columns: Array<string>,
	filters?: ModelTypes["ReportFiltersInput"] | undefined | null
};
	["ReportFiltersInput"]: {
	sessionIds?: Array<ModelTypes["ID"]> | undefined | null,
	groupIds?: Array<ModelTypes["ID"]> | undefined | null,
	state?: ModelTypes["UserProgress"] | undefined | null,
	period?: ModelTypes["ReportPeriodInput"] | undefined | null
};
	["ReportPeriodInput"]: {
	kind: ModelTypes["ReportPeriodKind"],
	from?: string | undefined | null,
	to?: string | undefined | null
};
	["ReportScheduleInput"]: {
	frequency: ModelTypes["ReportFrequency"],
	weekday?: number | undefined | null,
	monthDay?: number | undefined | null,
	hour: number,
	recipientIds: Array<ModelTypes["ID"]>,
	enabled?: boolean | undefined | null
};
	["Subscription"]: {
		basicSubscription?: string | undefined | null
};
	["schema"]: {
	query?: ModelTypes["Query"] | undefined | null,
	mutation?: ModelTypes["Mutation"] | undefined | null,
	subscription?: ModelTypes["Subscription"] | undefined | null
};
	["ID"]:any
    }

export type GraphQLTypes = {
    // ------------------------------------------------------;
	// THIS FILE WAS AUTOMATICALLY GENERATED (DO NOT MODIFY);
	// ------------------------------------------------------;
	["Permissions"]: {
	__typename: "Permissions",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	name: string,
	roles: Array<GraphQLTypes["Role"]>,
	['...on Permissions']: Omit<GraphQLTypes["Permissions"], "...on Permissions">
};
	/** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
["DateTime"]: "scalar" & { name: "DateTime" };
	["UserGroupModel"]: {
	__typename: "UserGroupModel",
	id: GraphQLTypes["ID"],
	name: string,
	['...on UserGroupModel']: Omit<GraphQLTypes["UserGroupModel"], "...on UserGroupModel">
};
	["Users"]: {
	__typename: "Users",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	status: GraphQLTypes["AccountStatus"],
	email?: string | undefined | null,
	username?: string | undefined | null,
	emailVerified: boolean,
	firstName: string,
	lastName: string,
	company?: string | undefined | null,
	department?: string | undefined | null,
	lastConnectionAt: GraphQLTypes["DateTime"],
	role: GraphQLTypes["Role"],
	roleId: string,
	groups?: Array<GraphQLTypes["UserGroupModel"]> | undefined | null,
	['...on Users']: Omit<GraphQLTypes["Users"], "...on Users">
};
	["AccountStatus"]: AccountStatus;
	["UserPagination"]: {
	__typename: "UserPagination",
	users: Array<GraphQLTypes["Users"] | undefined | null>,
	total: number,
	['...on UserPagination']: Omit<GraphQLTypes["UserPagination"], "...on UserPagination">
};
	["ImportUserError"]: {
	__typename: "ImportUserError",
	line: number,
	email: string,
	reason: string,
	['...on ImportUserError']: Omit<GraphQLTypes["ImportUserError"], "...on ImportUserError">
};
	["ImportUsersReport"]: {
	__typename: "ImportUsersReport",
	createdCount: number,
	errorCount: number,
	errors: Array<GraphQLTypes["ImportUserError"]>,
	['...on ImportUsersReport']: Omit<GraphQLTypes["ImportUsersReport"], "...on ImportUsersReport">
};
	["Role"]: {
	__typename: "Role",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	name: string,
	permissions: Array<GraphQLTypes["Permissions"] | undefined | null>,
	users: Array<GraphQLTypes["Users"] | undefined | null>,
	['...on Role']: Omit<GraphQLTypes["Role"], "...on Role">
};
	["DisabilityReferentModel"]: {
	__typename: "DisabilityReferentModel",
	name?: string | undefined | null,
	contact?: string | undefined | null,
	['...on DisabilityReferentModel']: Omit<GraphQLTypes["DisabilityReferentModel"], "...on DisabilityReferentModel">
};
	["AccommodationRequestModel"]: {
	__typename: "AccommodationRequestModel",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	needs: string,
	status: GraphQLTypes["AccommodationStatus"],
	response?: string | undefined | null,
	handledAt?: GraphQLTypes["DateTime"] | undefined | null,
	['...on AccommodationRequestModel']: Omit<GraphQLTypes["AccommodationRequestModel"], "...on AccommodationRequestModel">
};
	["AccommodationStatus"]: AccommodationStatus;
	["OrgAccommodationRequestModel"]: {
	__typename: "OrgAccommodationRequestModel",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	needs: string,
	status: GraphQLTypes["AccommodationStatus"],
	response?: string | undefined | null,
	handledAt?: GraphQLTypes["DateTime"] | undefined | null,
	learnerName: string,
	learnerEmail?: string | undefined | null,
	['...on OrgAccommodationRequestModel']: Omit<GraphQLTypes["OrgAccommodationRequestModel"], "...on OrgAccommodationRequestModel">
};
	["MyAccommodationModel"]: {
	__typename: "MyAccommodationModel",
	referent: GraphQLTypes["DisabilityReferentModel"],
	request?: GraphQLTypes["AccommodationRequestModel"] | undefined | null,
	['...on MyAccommodationModel']: Omit<GraphQLTypes["MyAccommodationModel"], "...on MyAccommodationModel">
};
	["UniqueAuth"]: {
	__typename: "UniqueAuth",
	access_token: string,
	refresh_token: string,
	firstName: string,
	lastName: string,
	role: string,
	email?: string | undefined | null,
	id: string,
	['...on UniqueAuth']: Omit<GraphQLTypes["UniqueAuth"], "...on UniqueAuth">
};
	["Invitation"]: {
	__typename: "Invitation",
	status: GraphQLTypes["InvitationStatus"],
	email?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	['...on Invitation']: Omit<GraphQLTypes["Invitation"], "...on Invitation">
};
	["InvitationStatus"]: InvitationStatus;
	["UserInfo"]: {
	__typename: "UserInfo",
	firstName: string,
	lastName: string,
	roles: GraphQLTypes["RoleEnum"],
	email?: string | undefined | null,
	username?: string | undefined | null,
	id: string,
	orgId?: string | undefined | null,
	impersonatorId?: string | undefined | null,
	capabilities: Array<GraphQLTypes["TrainerCapability"]>,
	orgSlug?: string | undefined | null,
	['...on UserInfo']: Omit<GraphQLTypes["UserInfo"], "...on UserInfo">
};
	["RoleEnum"]: RoleEnum;
	/** Ce que le rôle Formateur peut faire, réglable par organisation (#11) */
["TrainerCapability"]: TrainerCapability;
	["Mail"]: {
	__typename: "Mail",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	key: string,
	to: string,
	data: string,
	['...on Mail']: Omit<GraphQLTypes["Mail"], "...on Mail">
};
	["BillingAccountModel"]: {
	__typename: "BillingAccountModel",
	id: GraphQLTypes["ID"],
	tier: GraphQLTypes["BillingTier"],
	paymentTerm: GraphQLTypes["BillingPaymentTerm"],
	mode: GraphQLTypes["BillingMode"],
	tierChangedAt?: GraphQLTypes["DateTime"] | undefined | null,
	subscriptionStatus?: string | undefined | null,
	currentPeriodEnd?: GraphQLTypes["DateTime"] | undefined | null,
	cancelAtPeriodEnd: boolean,
	scheduledTier?: GraphQLTypes["BillingTier"] | undefined | null,
	scheduledPaymentTerm?: GraphQLTypes["BillingPaymentTerm"] | undefined | null,
	scheduledChangeAt?: GraphQLTypes["DateTime"] | undefined | null,
	cancelAt?: GraphQLTypes["DateTime"] | undefined | null,
	companyName?: string | undefined | null,
	addressLine1?: string | undefined | null,
	addressLine2?: string | undefined | null,
	postalCode?: string | undefined | null,
	city?: string | undefined | null,
	country?: string | undefined | null,
	vatNumber?: string | undefined | null,
	billingEmail?: string | undefined | null,
	subscribed: boolean,
	billingPortalAvailable: boolean,
	paymentFailed: boolean,
	['...on BillingAccountModel']: Omit<GraphQLTypes["BillingAccountModel"], "...on BillingAccountModel">
};
	["BillingTier"]: BillingTier;
	["BillingPaymentTerm"]: BillingPaymentTerm;
	["BillingMode"]: BillingMode;
	["BillingOfferModel"]: {
	__typename: "BillingOfferModel",
	tier: GraphQLTypes["BillingTier"],
	capacity: number,
	monthlyPriceCents: number,
	upfrontYearlyAmountCents: number,
	['...on BillingOfferModel']: Omit<GraphQLTypes["BillingOfferModel"], "...on BillingOfferModel">
};
	["LearnerCountersModel"]: {
	__typename: "LearnerCountersModel",
	orgId: GraphQLTypes["ID"],
	orgName: string,
	orgSlug: string,
	month: string,
	monthlyActive: number,
	learnerCount: number,
	registeredLearners: number,
	leavingWithinThreeMonths: number,
	subscribedTier: GraphQLTypes["BillingTier"],
	effectiveTier: GraphQLTypes["BillingTier"],
	billedTier: GraphQLTypes["BillingTier"],
	placesRemaining?: number | undefined | null,
	nextTier?: GraphQLTypes["BillingTier"] | undefined | null,
	paymentTerm: GraphQLTypes["BillingPaymentTerm"],
	estimatedRevenueCents: number,
	managed: boolean,
	overCapacity: boolean,
	['...on LearnerCountersModel']: Omit<GraphQLTypes["LearnerCountersModel"], "...on LearnerCountersModel">
};
	["BillingEstimateModel"]: {
	__typename: "BillingEstimateModel",
	month: string,
	subscribedTier: GraphQLTypes["BillingTier"],
	effectiveTier: GraphQLTypes["BillingTier"],
	billedTier: GraphQLTypes["BillingTier"],
	paymentTerm: GraphQLTypes["BillingPaymentTerm"],
	learnerCount: number,
	monthlyActive: number,
	registeredLearners: number,
	placesRemaining?: number | undefined | null,
	nextTier?: GraphQLTypes["BillingTier"] | undefined | null,
	leavingWithinThreeMonths: number,
	monthlyPriceCents?: number | undefined | null,
	monthlyAmountCents?: number | undefined | null,
	upfrontYearlyAmountCents?: number | undefined | null,
	isCustom: boolean,
	managed: boolean,
	overCapacity: boolean,
	['...on BillingEstimateModel']: Omit<GraphQLTypes["BillingEstimateModel"], "...on BillingEstimateModel">
};
	["BillingHistoryEntryModel"]: {
	__typename: "BillingHistoryEntryModel",
	month: string,
	monthlyActive: number,
	learnerCount: number,
	tier: GraphQLTypes["BillingTier"],
	amountCents: number,
	['...on BillingHistoryEntryModel']: Omit<GraphQLTypes["BillingHistoryEntryModel"], "...on BillingHistoryEntryModel">
};
	["CapacityAlertModel"]: {
	__typename: "CapacityAlertModel",
	learnerCount: number,
	tier: GraphQLTypes["BillingTier"],
	neededTier: GraphQLTypes["BillingTier"],
	['...on CapacityAlertModel']: Omit<GraphQLTypes["CapacityAlertModel"], "...on CapacityAlertModel">
};
	["MyAccount"]: {
	__typename: "MyAccount",
	id: GraphQLTypes["ID"],
	firstName: string,
	lastName: string,
	email?: string | undefined | null,
	username?: string | undefined | null,
	role: string,
	organizationName?: string | undefined | null,
	lastConnectionAt: GraphQLTypes["DateTime"],
	hasPassword: boolean,
	['...on MyAccount']: Omit<GraphQLTypes["MyAccount"], "...on MyAccount">
};
	["AppConfigModel"]: {
	__typename: "AppConfigModel",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	appName: string,
	logo?: string | undefined | null,
	logoDark?: string | undefined | null,
	favicon?: string | undefined | null,
	primaryColor?: string | undefined | null,
	primaryForeground?: string | undefined | null,
	accentColor?: string | undefined | null,
	accentForeground?: string | undefined | null,
	footerText?: string | undefined | null,
	defaultLocale: string,
	timezone: string,
	signupCtaVisible: boolean,
	billingSelfService: boolean,
	['...on AppConfigModel']: Omit<GraphQLTypes["AppConfigModel"], "...on AppConfigModel">
};
	["TrainerCapabilityModel"]: {
	__typename: "TrainerCapabilityModel",
	capability: GraphQLTypes["TrainerCapability"],
	granted: boolean,
	dependsOn: Array<GraphQLTypes["TrainerCapability"]>,
	['...on TrainerCapabilityModel']: Omit<GraphQLTypes["TrainerCapabilityModel"], "...on TrainerCapabilityModel">
};
	["GroupMemberModel"]: {
	__typename: "GroupMemberModel",
	id: GraphQLTypes["ID"],
	email?: string | undefined | null,
	username?: string | undefined | null,
	firstName: string,
	lastName: string,
	['...on GroupMemberModel']: Omit<GraphQLTypes["GroupMemberModel"], "...on GroupMemberModel">
};
	["GroupModel"]: {
	__typename: "GroupModel",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	name: string,
	description?: string | undefined | null,
	memberCount: number,
	members: Array<GraphQLTypes["GroupMemberModel"]>,
	memberIds: Array<GraphQLTypes["ID"]>,
	['...on GroupModel']: Omit<GraphQLTypes["GroupModel"], "...on GroupModel">
};
	["LoginEventModel"]: {
	__typename: "LoginEventModel",
	id: GraphQLTypes["ID"],
	at: GraphQLTypes["DateTime"],
	method: GraphQLTypes["LoginMethod"],
	['...on LoginEventModel']: Omit<GraphQLTypes["LoginEventModel"], "...on LoginEventModel">
};
	["LoginMethod"]: LoginMethod;
	["LoginEventPage"]: {
	__typename: "LoginEventPage",
	events: Array<GraphQLTypes["LoginEventModel"]>,
	total: number,
	['...on LoginEventPage']: Omit<GraphQLTypes["LoginEventPage"], "...on LoginEventPage">
};
	["LearnerProfile"]: {
	__typename: "LearnerProfile",
	id: GraphQLTypes["ID"],
	firstName: string,
	lastName: string,
	email?: string | undefined | null,
	username?: string | undefined | null,
	company?: string | undefined | null,
	department?: string | undefined | null,
	status: GraphQLTypes["AccountStatus"],
	roleName: string,
	roleId: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	groups: Array<GraphQLTypes["UserGroupModel"]>,
	trainingSeconds: number,
	loginCount: number,
	lastLoginAt?: GraphQLTypes["DateTime"] | undefined | null,
	averageDaysBetweenLogins?: number | undefined | null,
	completedModules: number,
	totalModules: number,
	['...on LearnerProfile']: Omit<GraphQLTypes["LearnerProfile"], "...on LearnerProfile">
};
	["UsernameCredentials"]: {
	__typename: "UsernameCredentials",
	userId: string,
	username: string,
	password: string,
	['...on UsernameCredentials']: Omit<GraphQLTypes["UsernameCredentials"], "...on UsernameCredentials">
};
	["UsernameImportError"]: {
	__typename: "UsernameImportError",
	line: number,
	username: string,
	reason: string,
	['...on UsernameImportError']: Omit<GraphQLTypes["UsernameImportError"], "...on UsernameImportError">
};
	["UsernameImportReport"]: {
	__typename: "UsernameImportReport",
	created: Array<GraphQLTypes["UsernameCredentials"]>,
	errors: Array<GraphQLTypes["UsernameImportError"]>,
	['...on UsernameImportReport']: Omit<GraphQLTypes["UsernameImportReport"], "...on UsernameImportReport">
};
	["CertificateTemplateModel"]: {
	__typename: "CertificateTemplateModel",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	name: string,
	isDefault: boolean,
	title: string,
	body: string,
	signature?: string | undefined | null,
	showScore: boolean,
	showDate: boolean,
	showTotalTime: boolean,
	emailOnUnlock: boolean,
	logo?: string | undefined | null,
	orientation: GraphQLTypes["CertificateOrientation"],
	hasSkeleton: boolean,
	marginTop: number,
	marginBottom: number,
	marginLeft: number,
	marginRight: number,
	['...on CertificateTemplateModel']: Omit<GraphQLTypes["CertificateTemplateModel"], "...on CertificateTemplateModel">
};
	["CertificateOrientation"]: CertificateOrientation;
	["CertificateTemplateOptionModel"]: {
	__typename: "CertificateTemplateOptionModel",
	id: GraphQLTypes["ID"],
	name: string,
	isDefault: boolean,
	['...on CertificateTemplateOptionModel']: Omit<GraphQLTypes["CertificateTemplateOptionModel"], "...on CertificateTemplateOptionModel">
};
	["ComplaintModel"]: {
	__typename: "ComplaintModel",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	category: GraphQLTypes["ComplaintCategory"],
	status: GraphQLTypes["ComplaintStatus"],
	origin: GraphQLTypes["ComplaintOrigin"],
	subject: string,
	message: string,
	response?: string | undefined | null,
	respondedAt?: GraphQLTypes["DateTime"] | undefined | null,
	resolvedAt?: GraphQLTypes["DateTime"] | undefined | null,
	authorName?: string | undefined | null,
	authorEmail?: string | undefined | null,
	['...on ComplaintModel']: Omit<GraphQLTypes["ComplaintModel"], "...on ComplaintModel">
};
	/** Nature d'une demande ou réclamation (#325) ; REPORT = signalement de violence, harcèlement ou discrimination. */
["ComplaintCategory"]: ComplaintCategory;
	["ComplaintStatus"]: ComplaintStatus;
	["ComplaintOrigin"]: ComplaintOrigin;
	["TrainingDocumentModel"]: {
	__typename: "TrainingDocumentModel",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	title: string,
	fileName: string,
	sizeBytes: number,
	requiredBeforeStart: boolean,
	sessionId?: GraphQLTypes["ID"] | undefined | null,
	sessionName?: string | undefined | null,
	acknowledgementCount: number,
	['...on TrainingDocumentModel']: Omit<GraphQLTypes["TrainingDocumentModel"], "...on TrainingDocumentModel">
};
	["DocumentAcknowledgementModel"]: {
	__typename: "DocumentAcknowledgementModel",
	at: GraphQLTypes["DateTime"],
	name: string,
	email?: string | undefined | null,
	['...on DocumentAcknowledgementModel']: Omit<GraphQLTypes["DocumentAcknowledgementModel"], "...on DocumentAcknowledgementModel">
};
	["DownloadFile"]: {
	__typename: "DownloadFile",
	fileName: string,
	fileMimeType: string,
	url: string,
	['...on DownloadFile']: Omit<GraphQLTypes["DownloadFile"], "...on DownloadFile">
};
	["MyFiles"]: {
	__typename: "MyFiles",
	id: string,
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	eTag: string,
	location: string,
	fileName: string,
	fileMimeType: string,
	ownerId: string,
	['...on MyFiles']: Omit<GraphQLTypes["MyFiles"], "...on MyFiles">
};
	["UploadPreSignedUrl"]: {
	__typename: "UploadPreSignedUrl",
	url: string,
	id: string,
	['...on UploadPreSignedUrl']: Omit<GraphQLTypes["UploadPreSignedUrl"], "...on UploadPreSignedUrl">
};
	["HomeCompletionModel"]: {
	__typename: "HomeCompletionModel",
	sessionId: GraphQLTypes["ID"],
	sessionName: string,
	moduleId: GraphQLTypes["ID"],
	moduleTitle: string,
	learners: number,
	['...on HomeCompletionModel']: Omit<GraphQLTypes["HomeCompletionModel"], "...on HomeCompletionModel">
};
	["HomeSessionModel"]: {
	__typename: "HomeSessionModel",
	id: GraphQLTypes["ID"],
	name: string,
	startDate?: GraphQLTypes["DateTime"] | undefined | null,
	endDate?: GraphQLTypes["DateTime"] | undefined | null,
	enrolledLearners: number,
	pendingLearners: number,
	['...on HomeSessionModel']: Omit<GraphQLTypes["HomeSessionModel"], "...on HomeSessionModel">
};
	["BackOfficeHomeModel"]: {
	__typename: "BackOfficeHomeModel",
	firstName: string,
	timezone: string,
	completedToday: Array<GraphQLTypes["HomeCompletionModel"]>,
	startingSoon: Array<GraphQLTypes["HomeSessionModel"]>,
	endingSoon: Array<GraphQLTypes["HomeSessionModel"]>,
	overdue: Array<GraphQLTypes["HomeSessionModel"]>,
	overdueLearners: number,
	overdueSessions: number,
	neverStartedLearners: number,
	['...on BackOfficeHomeModel']: Omit<GraphQLTypes["BackOfficeHomeModel"], "...on BackOfficeHomeModel">
};
	["OrganizationModel"]: {
	__typename: "OrganizationModel",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	name: string,
	slug: string,
	status: GraphQLTypes["OrganizationStatus"],
	userCount: number,
	tier: GraphQLTypes["BillingTier"],
	billingMode: GraphQLTypes["BillingMode"],
	billingNote?: string | undefined | null,
	['...on OrganizationModel']: Omit<GraphQLTypes["OrganizationModel"], "...on OrganizationModel">
};
	["OrganizationStatus"]: OrganizationStatus;
	["OrgMemberModel"]: {
	__typename: "OrgMemberModel",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	email?: string | undefined | null,
	username?: string | undefined | null,
	firstName: string,
	lastName: string,
	role: string,
	status: string,
	['...on OrgMemberModel']: Omit<GraphQLTypes["OrgMemberModel"], "...on OrgMemberModel">
};
	["PositioningRatingModel"]: {
	__typename: "PositioningRatingModel",
	objective: string,
	level: number,
	['...on PositioningRatingModel']: Omit<GraphQLTypes["PositioningRatingModel"], "...on PositioningRatingModel">
};
	["PositioningAnswerModel"]: {
	__typename: "PositioningAnswerModel",
	answeredAt: GraphQLTypes["DateTime"],
	ratings: Array<GraphQLTypes["PositioningRatingModel"]>,
	needs?: string | undefined | null,
	['...on PositioningAnswerModel']: Omit<GraphQLTypes["PositioningAnswerModel"], "...on PositioningAnswerModel">
};
	["SessionPositioningModel"]: {
	__typename: "SessionPositioningModel",
	sessionId: GraphQLTypes["ID"],
	sessionName: string,
	entry?: GraphQLTypes["PositioningAnswerModel"] | undefined | null,
	exit?: GraphQLTypes["PositioningAnswerModel"] | undefined | null,
	['...on SessionPositioningModel']: Omit<GraphQLTypes["SessionPositioningModel"], "...on SessionPositioningModel">
};
	["ImprovementActionModel"]: {
	__typename: "ImprovementActionModel",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	origin: GraphQLTypes["ImprovementOrigin"],
	status: GraphQLTypes["ImprovementStatus"],
	title: string,
	description: string,
	owner?: string | undefined | null,
	dueDate?: GraphQLTypes["DateTime"] | undefined | null,
	effect?: string | undefined | null,
	doneAt?: GraphQLTypes["DateTime"] | undefined | null,
	['...on ImprovementActionModel']: Omit<GraphQLTypes["ImprovementActionModel"], "...on ImprovementActionModel">
};
	/** Le retour qui a fait naître une action d'amélioration (#328). */
["ImprovementOrigin"]: ImprovementOrigin;
	["ImprovementStatus"]: ImprovementStatus;
	["QualityRiskModel"]: {
	__typename: "QualityRiskModel",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	title: string,
	description: string,
	/** Probabilité, de 1 (faible) à 3 (forte). */
	likelihood: number,
	/** Impact, de 1 (faible) à 3 (fort). */
	impact: number,
	/** Gravité = probabilité × impact, de 1 à 9. */
	severity: number,
	mitigation?: string | undefined | null,
	owner?: string | undefined | null,
	status: GraphQLTypes["QualityRiskStatus"],
	['...on QualityRiskModel']: Omit<GraphQLTypes["QualityRiskModel"], "...on QualityRiskModel">
};
	["QualityRiskStatus"]: QualityRiskStatus;
	["ReminderSettingsModel"]: {
	__typename: "ReminderSettingsModel",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	enabled: boolean,
	firstDelayDays: number,
	frequencyDays: number,
	maxReminders: number,
	sendHour: number,
	subject: string,
	body: string,
	completionDigestEnabled: boolean,
	convocationEnabled: boolean,
	['...on ReminderSettingsModel']: Omit<GraphQLTypes["ReminderSettingsModel"], "...on ReminderSettingsModel">
};
	["ReminderTestResultModel"]: {
	__typename: "ReminderTestResultModel",
	sent: boolean,
	to: string,
	['...on ReminderTestResultModel']: Omit<GraphQLTypes["ReminderTestResultModel"], "...on ReminderTestResultModel">
};
	["ReportPeriodModel"]: {
	__typename: "ReportPeriodModel",
	kind: GraphQLTypes["ReportPeriodKind"],
	from?: string | undefined | null,
	to?: string | undefined | null,
	['...on ReportPeriodModel']: Omit<GraphQLTypes["ReportPeriodModel"], "...on ReportPeriodModel">
};
	["ReportPeriodKind"]: ReportPeriodKind;
	["ReportFiltersModel"]: {
	__typename: "ReportFiltersModel",
	sessionIds?: Array<GraphQLTypes["ID"]> | undefined | null,
	groupIds?: Array<GraphQLTypes["ID"]> | undefined | null,
	state?: GraphQLTypes["UserProgress"] | undefined | null,
	period?: GraphQLTypes["ReportPeriodModel"] | undefined | null,
	['...on ReportFiltersModel']: Omit<GraphQLTypes["ReportFiltersModel"], "...on ReportFiltersModel">
};
	["UserProgress"]: UserProgress;
	["ReportScheduleModel"]: {
	__typename: "ReportScheduleModel",
	frequency: GraphQLTypes["ReportFrequency"],
	weekday?: number | undefined | null,
	monthDay?: number | undefined | null,
	hour: number,
	recipientIds: Array<GraphQLTypes["ID"]>,
	enabled: boolean,
	lastSentAt?: GraphQLTypes["DateTime"] | undefined | null,
	['...on ReportScheduleModel']: Omit<GraphQLTypes["ReportScheduleModel"], "...on ReportScheduleModel">
};
	["ReportFrequency"]: ReportFrequency;
	["ReportTemplateModel"]: {
	__typename: "ReportTemplateModel",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	name: string,
	granularity: GraphQLTypes["ReportGranularity"],
	columns: Array<string>,
	filters: GraphQLTypes["ReportFiltersModel"],
	schedule?: GraphQLTypes["ReportScheduleModel"] | undefined | null,
	['...on ReportTemplateModel']: Omit<GraphQLTypes["ReportTemplateModel"], "...on ReportTemplateModel">
};
	/** Ce qu'est une ligne du rapport (#163). */
["ReportGranularity"]: ReportGranularity;
	["ReportColumnLabelModel"]: {
	__typename: "ReportColumnLabelModel",
	fr: string,
	en: string,
	['...on ReportColumnLabelModel']: Omit<GraphQLTypes["ReportColumnLabelModel"], "...on ReportColumnLabelModel">
};
	["ReportColumnModel"]: {
	__typename: "ReportColumnModel",
	key: string,
	level: string,
	label: GraphQLTypes["ReportColumnLabelModel"],
	['...on ReportColumnModel']: Omit<GraphQLTypes["ReportColumnModel"], "...on ReportColumnModel">
};
	["ReportRecipientModel"]: {
	__typename: "ReportRecipientModel",
	id: GraphQLTypes["ID"],
	firstName: string,
	lastName: string,
	email?: string | undefined | null,
	['...on ReportRecipientModel']: Omit<GraphQLTypes["ReportRecipientModel"], "...on ReportRecipientModel">
};
	["StorageUsageModel"]: {
	__typename: "StorageUsageModel",
	orgId: GraphQLTypes["ID"],
	orgName?: string | undefined | null,
	orgSlug?: string | undefined | null,
	usedBytes: number,
	quotaBytes?: number | undefined | null,
	remainingBytes?: number | undefined | null,
	plan: GraphQLTypes["BillingTier"],
	moduleCount: number,
	overQuota: boolean,
	maxUploadBytes: number,
	['...on StorageUsageModel']: Omit<GraphQLTypes["StorageUsageModel"], "...on StorageUsageModel">
};
	["ScormModuleModel"]: {
	__typename: "ScormModuleModel",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	title: string,
	description?: string | undefined | null,
	scormVersion?: string | undefined | null,
	launchUrl?: string | undefined | null,
	status: GraphQLTypes["ScormModuleStatus"],
	masteryScore?: number | undefined | null,
	durationMinutes?: number | undefined | null,
	sizeBytes: number,
	contentUpdatedAt?: GraphQLTypes["DateTime"] | undefined | null,
	['...on ScormModuleModel']: Omit<GraphQLTypes["ScormModuleModel"], "...on ScormModuleModel">
};
	["ScormModuleStatus"]: ScormModuleStatus;
	["ScormScoModel"]: {
	__typename: "ScormScoModel",
	identifier: string,
	title: string,
	href: string,
	position: number,
	masteryScore?: number | undefined | null,
	['...on ScormScoModel']: Omit<GraphQLTypes["ScormScoModel"], "...on ScormScoModel">
};
	["ScoreCorrectionModel"]: {
	__typename: "ScoreCorrectionModel",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	score: number,
	previousScore?: number | undefined | null,
	reason: string,
	correctedBy?: string | undefined | null,
	revokedAt?: GraphQLTypes["DateTime"] | undefined | null,
	revokedBy?: string | undefined | null,
	['...on ScoreCorrectionModel']: Omit<GraphQLTypes["ScoreCorrectionModel"], "...on ScoreCorrectionModel">
};
	["ScormInteractionModel"]: {
	__typename: "ScormInteractionModel",
	scoIdentifier: string,
	index: number,
	interactionId: string,
	type?: string | undefined | null,
	description?: string | undefined | null,
	correctResponses: Array<string>,
	learnerResponse?: string | undefined | null,
	result?: string | undefined | null,
	weighting?: number | undefined | null,
	latency?: string | undefined | null,
	timestamp?: string | undefined | null,
	objectiveIds: Array<string>,
	['...on ScormInteractionModel']: Omit<GraphQLTypes["ScormInteractionModel"], "...on ScormInteractionModel">
};
	["QuestionAnswerModel"]: {
	__typename: "QuestionAnswerModel",
	userId: GraphQLTypes["ID"],
	response?: string | undefined | null,
	result?: string | undefined | null,
	score?: number | undefined | null,
	attemptNumber: number,
	['...on QuestionAnswerModel']: Omit<GraphQLTypes["QuestionAnswerModel"], "...on QuestionAnswerModel">
};
	["QuestionStatModel"]: {
	__typename: "QuestionStatModel",
	scoIdentifier: string,
	interactionId: string,
	description?: string | undefined | null,
	type?: string | undefined | null,
	correctResponses: Array<string>,
	respondents: number,
	correctRate?: number | undefined | null,
	averageScore?: number | undefined | null,
	buckets: Array<number>,
	answers: Array<GraphQLTypes["QuestionAnswerModel"]>,
	['...on QuestionStatModel']: Omit<GraphQLTypes["QuestionStatModel"], "...on QuestionStatModel">
};
	["QuestionLearnerModel"]: {
	__typename: "QuestionLearnerModel",
	id: GraphQLTypes["ID"],
	firstName: string,
	lastName: string,
	email?: string | undefined | null,
	username?: string | undefined | null,
	['...on QuestionLearnerModel']: Omit<GraphQLTypes["QuestionLearnerModel"], "...on QuestionLearnerModel">
};
	["ModuleQuestionStatsModel"]: {
	__typename: "ModuleQuestionStatsModel",
	questions: Array<GraphQLTypes["QuestionStatModel"]>,
	learners: Array<GraphQLTypes["QuestionLearnerModel"]>,
	['...on ModuleQuestionStatsModel']: Omit<GraphQLTypes["ModuleQuestionStatsModel"], "...on ModuleQuestionStatsModel">
};
	["LearnerAttemptModel"]: {
	__typename: "LearnerAttemptModel",
	sessionId: GraphQLTypes["ID"],
	sessionName: string,
	number: number,
	completionStatus: GraphQLTypes["ScormCompletionStatus"],
	successStatus: GraphQLTypes["ScormSuccessStatus"],
	scoreRaw?: number | undefined | null,
	scoreMax?: number | undefined | null,
	scoreScaled?: number | undefined | null,
	totalTime?: string | undefined | null,
	updatedAt: GraphQLTypes["DateTime"],
	interactions: Array<GraphQLTypes["ScormInteractionModel"]>,
	['...on LearnerAttemptModel']: Omit<GraphQLTypes["LearnerAttemptModel"], "...on LearnerAttemptModel">
};
	["ScormCompletionStatus"]: ScormCompletionStatus;
	["ScormSuccessStatus"]: ScormSuccessStatus;
	["ScormScoStateModel"]: {
	__typename: "ScormScoStateModel",
	scoIdentifier: string,
	completionStatus: GraphQLTypes["ScormCompletionStatus"],
	successStatus: GraphQLTypes["ScormSuccessStatus"],
	scoreRaw?: number | undefined | null,
	scoreMin?: number | undefined | null,
	scoreMax?: number | undefined | null,
	scoreScaled?: number | undefined | null,
	totalTime?: string | undefined | null,
	suspendData?: string | undefined | null,
	location?: string | undefined | null,
	['...on ScormScoStateModel']: Omit<GraphQLTypes["ScormScoStateModel"], "...on ScormScoStateModel">
};
	["ScormAttemptModel"]: {
	__typename: "ScormAttemptModel",
	number: number,
	completionStatus: GraphQLTypes["ScormCompletionStatus"],
	successStatus: GraphQLTypes["ScormSuccessStatus"],
	scoreRaw?: number | undefined | null,
	scoreMin?: number | undefined | null,
	scoreMax?: number | undefined | null,
	scoreScaled?: number | undefined | null,
	totalTime?: string | undefined | null,
	interactions: Array<GraphQLTypes["ScormInteractionModel"]>,
	scoStates: Array<GraphQLTypes["ScormScoStateModel"]>,
	['...on ScormAttemptModel']: Omit<GraphQLTypes["ScormAttemptModel"], "...on ScormAttemptModel">
};
	["ScormTrackingModel"]: {
	__typename: "ScormTrackingModel",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	completionStatus: GraphQLTypes["ScormCompletionStatus"],
	successStatus: GraphQLTypes["ScormSuccessStatus"],
	scoreRaw?: number | undefined | null,
	scoreMin?: number | undefined | null,
	scoreMax?: number | undefined | null,
	scoreScaled?: number | undefined | null,
	totalTime?: string | undefined | null,
	totalTimeSeconds?: number | undefined | null,
	sessionTime?: string | undefined | null,
	suspendData?: string | undefined | null,
	location?: string | undefined | null,
	completedAt?: GraphQLTypes["DateTime"] | undefined | null,
	userId: string,
	sessionId: string,
	attemptNumber: number,
	currentAttempt?: GraphQLTypes["ScormAttemptModel"] | undefined | null,
	currentScoIdentifier?: string | undefined | null,
	['...on ScormTrackingModel']: Omit<GraphQLTypes["ScormTrackingModel"], "...on ScormTrackingModel">
};
	["ScormTrackingWithUser"]: {
	__typename: "ScormTrackingWithUser",
	id: GraphQLTypes["ID"],
	correctedScore?: number | undefined | null,
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	completionStatus: GraphQLTypes["ScormCompletionStatus"],
	successStatus: GraphQLTypes["ScormSuccessStatus"],
	scoreRaw?: number | undefined | null,
	scoreMin?: number | undefined | null,
	scoreMax?: number | undefined | null,
	scoreScaled?: number | undefined | null,
	totalTime?: string | undefined | null,
	sessionTime?: string | undefined | null,
	suspendData?: string | undefined | null,
	location?: string | undefined | null,
	completedAt?: GraphQLTypes["DateTime"] | undefined | null,
	userId: string,
	userEmail?: string | undefined | null,
	userUsername?: string | undefined | null,
	userFirstName: string,
	userLastName: string,
	sessionId: string,
	sessionName: string,
	['...on ScormTrackingWithUser']: Omit<GraphQLTypes["ScormTrackingWithUser"], "...on ScormTrackingWithUser">
};
	["ScormTrackingStats"]: {
	__typename: "ScormTrackingStats",
	total: number,
	learners: number,
	completed: number,
	inProgress: number,
	notStarted: number,
	completionUnknown: number,
	neverOpened: number,
	notYetUnlocked: number,
	passed: number,
	failed: number,
	averageScorePercent?: number | undefined | null,
	scoredCount: number,
	averageTimeSeconds?: number | undefined | null,
	timedCount: number,
	totalTimeSeconds: number,
	['...on ScormTrackingStats']: Omit<GraphQLTypes["ScormTrackingStats"], "...on ScormTrackingStats">
};
	["ScormCompletionPoint"]: {
	__typename: "ScormCompletionPoint",
	day: string,
	completed: number,
	['...on ScormCompletionPoint']: Omit<GraphQLTypes["ScormCompletionPoint"], "...on ScormCompletionPoint">
};
	["ScormTrackingPagination"]: {
	__typename: "ScormTrackingPagination",
	trackings: Array<GraphQLTypes["ScormTrackingWithUser"] | undefined | null>,
	total: number,
	['...on ScormTrackingPagination']: Omit<GraphQLTypes["ScormTrackingPagination"], "...on ScormTrackingPagination">
};
	["SessionParticipantResult"]: {
	__typename: "SessionParticipantResult",
	userId: GraphQLTypes["ID"],
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	email?: string | undefined | null,
	username?: string | undefined | null,
	groups: Array<string>,
	state: GraphQLTypes["UserProgress"],
	completedModules: number,
	totalModules: number,
	averageScorePercent?: number | undefined | null,
	timeSpentSeconds: number,
	lastActivityAt?: GraphQLTypes["DateTime"] | undefined | null,
	droppedAt?: GraphQLTypes["DateTime"] | undefined | null,
	dropReason?: GraphQLTypes["DropoutReason"] | undefined | null,
	dropNote?: string | undefined | null,
	['...on SessionParticipantResult']: Omit<GraphQLTypes["SessionParticipantResult"], "...on SessionParticipantResult">
};
	/** Motif d'un abandon déclaré par l'organisme (#324). */
["DropoutReason"]: DropoutReason;
	["SessionModuleResult"]: {
	__typename: "SessionModuleResult",
	moduleId: GraphQLTypes["ID"],
	completedCount: number,
	['...on SessionModuleResult']: Omit<GraphQLTypes["SessionModuleResult"], "...on SessionModuleResult">
};
	["SessionResults"]: {
	__typename: "SessionResults",
	stats: GraphQLTypes["ScormTrackingStats"],
	participants: Array<GraphQLTypes["SessionParticipantResult"]>,
	modules: Array<GraphQLTypes["SessionModuleResult"]>,
	['...on SessionResults']: Omit<GraphQLTypes["SessionResults"], "...on SessionResults">
};
	["LearnerDocumentModel"]: {
	__typename: "LearnerDocumentModel",
	id: GraphQLTypes["ID"],
	title: string,
	requiredBeforeStart: boolean,
	acknowledgedAt?: GraphQLTypes["DateTime"] | undefined | null,
	['...on LearnerDocumentModel']: Omit<GraphQLTypes["LearnerDocumentModel"], "...on LearnerDocumentModel">
};
	["LearnerPositioningModel"]: {
	__typename: "LearnerPositioningModel",
	required: boolean,
	entryPending: boolean,
	entryDone: boolean,
	exitDone: boolean,
	['...on LearnerPositioningModel']: Omit<GraphQLTypes["LearnerPositioningModel"], "...on LearnerPositioningModel">
};
	["SessionUserModel"]: {
	__typename: "SessionUserModel",
	id: GraphQLTypes["ID"],
	email?: string | undefined | null,
	username?: string | undefined | null,
	firstName: string,
	lastName: string,
	['...on SessionUserModel']: Omit<GraphQLTypes["SessionUserModel"], "...on SessionUserModel">
};
	["SessionTrainerModel"]: {
	__typename: "SessionTrainerModel",
	id: GraphQLTypes["ID"],
	email?: string | undefined | null,
	firstName: string,
	lastName: string,
	role: GraphQLTypes["RoleEnum"],
	assignedAt: GraphQLTypes["DateTime"],
	['...on SessionTrainerModel']: Omit<GraphQLTypes["SessionTrainerModel"], "...on SessionTrainerModel">
};
	["SessionSectionModel"]: {
	__typename: "SessionSectionModel",
	id: GraphQLTypes["ID"],
	title: string,
	position: number,
	['...on SessionSectionModel']: Omit<GraphQLTypes["SessionSectionModel"], "...on SessionSectionModel">
};
	["SessionModuleModel"]: {
	__typename: "SessionModuleModel",
	id: GraphQLTypes["ID"],
	position: number,
	unlockAt?: GraphQLTypes["DateTime"] | undefined | null,
	prerequisiteModuleId?: GraphQLTypes["ID"] | undefined | null,
	prerequisiteMinScore?: number | undefined | null,
	allowRetake: boolean,
	scoreRetention: GraphQLTypes["ScoreRetention"],
	sectionId?: GraphQLTypes["ID"] | undefined | null,
	module: GraphQLTypes["ScormModuleModel"],
	unlocked?: boolean | undefined | null,
	lockReason?: GraphQLTypes["ModuleLockReason"] | undefined | null,
	myTracking?: GraphQLTypes["ScormTrackingModel"] | undefined | null,
	['...on SessionModuleModel']: Omit<GraphQLTypes["SessionModuleModel"], "...on SessionModuleModel">
};
	/** Score retenu quand un apprenant refait un module : meilleur, dernier ou moyenne (#84) */
["ScoreRetention"]: ScoreRetention;
	/** Pourquoi un module est fermé — une date à attendre, ou un module à finir. */
["ModuleLockReason"]: ModuleLockReason;
	["SessionProgressModel"]: {
	__typename: "SessionProgressModel",
	totalModules: number,
	completedModules: number,
	completed: boolean,
	['...on SessionProgressModel']: Omit<GraphQLTypes["SessionProgressModel"], "...on SessionProgressModel">
};
	["SessionTagModel"]: {
	__typename: "SessionTagModel",
	id: GraphQLTypes["ID"],
	name: string,
	['...on SessionTagModel']: Omit<GraphQLTypes["SessionTagModel"], "...on SessionTagModel">
};
	["SessionCertificateModel"]: {
	__typename: "SessionCertificateModel",
	unlocked: boolean,
	reason?: GraphQLTypes["CertificateLockReason"] | undefined | null,
	blockingModuleIds: Array<GraphQLTypes["ID"]>,
	['...on SessionCertificateModel']: Omit<GraphQLTypes["SessionCertificateModel"], "...on SessionCertificateModel">
};
	/** Pourquoi l'attestation est verrouillée : modules à terminer, à réussir, ou sous le seuil. */
["CertificateLockReason"]: CertificateLockReason;
	["SessionModel"]: {
	__typename: "SessionModel",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	name: string,
	objectives: Array<string>,
	prerequisites?: string | undefined | null,
	audience?: string | undefined | null,
	teachingMethods?: string | undefined | null,
	assessmentMethods?: string | undefined | null,
	accessibility?: string | undefined | null,
	contact?: string | undefined | null,
	startDate?: GraphQLTypes["DateTime"] | undefined | null,
	endDate?: GraphQLTypes["DateTime"] | undefined | null,
	status: GraphQLTypes["SessionStatus"],
	progressionMode: GraphQLTypes["SessionProgressionMode"],
	certificateCondition: GraphQLTypes["CertificateCondition"],
	certificateMinScore?: number | undefined | null,
	certificateTemplateId?: GraphQLTypes["ID"] | undefined | null,
	module: GraphQLTypes["ScormModuleModel"],
	modules: Array<GraphQLTypes["SessionModuleModel"]>,
	sections: Array<GraphQLTypes["SessionSectionModel"]>,
	enrolledUsers: Array<GraphQLTypes["SessionUserModel"]>,
	tags: Array<GraphQLTypes["SessionTagModel"]>,
	trainers: Array<GraphQLTypes["SessionTrainerModel"]>,
	myTracking?: GraphQLTypes["ScormTrackingModel"] | undefined | null,
	myEnrolledAt?: GraphQLTypes["DateTime"] | undefined | null,
	progress?: GraphQLTypes["SessionProgressModel"] | undefined | null,
	certificate?: GraphQLTypes["SessionCertificateModel"] | undefined | null,
	positioningEnabled: boolean,
	myPositioning?: GraphQLTypes["LearnerPositioningModel"] | undefined | null,
	documents?: Array<GraphQLTypes["LearnerDocumentModel"]> | undefined | null,
	['...on SessionModel']: Omit<GraphQLTypes["SessionModel"], "...on SessionModel">
};
	["SessionStatus"]: SessionStatus;
	/** Règle d'enchaînement du parcours. Le déblocage par date n'est pas une valeur ici : c'est un second verrou, porté par SessionModule.unlockAt. */
["SessionProgressionMode"]: SessionProgressionMode;
	/** Ce qu'exige l'attestation d'un parcours, au-delà de terminer tous ses modules (#10). */
["CertificateCondition"]: CertificateCondition;
	["RequestTrialResult"]: {
	__typename: "RequestTrialResult",
	accepted: boolean,
	['...on RequestTrialResult']: Omit<GraphQLTypes["RequestTrialResult"], "...on RequestTrialResult">
};
	["ConfirmTrialResult"]: {
	__typename: "ConfirmTrialResult",
	status: GraphQLTypes["TrialReviewStatus"],
	email: string,
	slug?: string | undefined | null,
	rejectionReason?: string | undefined | null,
	['...on ConfirmTrialResult']: Omit<GraphQLTypes["ConfirmTrialResult"], "...on ConfirmTrialResult">
};
	["TrialReviewStatus"]: TrialReviewStatus;
	["TrialRequestModel"]: {
	__typename: "TrialRequestModel",
	id: GraphQLTypes["ID"],
	email: string,
	firstName: string,
	lastName: string,
	orgName: string,
	jobTitle?: string | undefined | null,
	phone?: string | undefined | null,
	createdAt: GraphQLTypes["DateTime"],
	emailConfirmedAt: GraphQLTypes["DateTime"],
	['...on TrialRequestModel']: Omit<GraphQLTypes["TrialRequestModel"], "...on TrialRequestModel">
};
	["ApproveTrialResult"]: {
	__typename: "ApproveTrialResult",
	slug: string,
	['...on ApproveTrialResult']: Omit<GraphQLTypes["ApproveTrialResult"], "...on ApproveTrialResult">
};
	["SsoOrgSettingsModel"]: {
	__typename: "SsoOrgSettingsModel",
	enabled: boolean,
	['...on SsoOrgSettingsModel']: Omit<GraphQLTypes["SsoOrgSettingsModel"], "...on SsoOrgSettingsModel">
};
	["SsoPresetModel"]: {
	__typename: "SsoPresetModel",
	kind: GraphQLTypes["SsoProviderKind"],
	protocol: string,
	defaultLabel: string,
	defaultIssuer?: string | undefined | null,
	issuerHint?: string | undefined | null,
	sharedIssuer: boolean,
	['...on SsoPresetModel']: Omit<GraphQLTypes["SsoPresetModel"], "...on SsoPresetModel">
};
	/** Fournisseur d'identité pré-listé (#40). */
["SsoProviderKind"]: SsoProviderKind;
	["SsoProviderModel"]: {
	__typename: "SsoProviderModel",
	id: GraphQLTypes["ID"],
	kind: GraphQLTypes["SsoProviderKind"],
	protocol: string,
	label: string,
	enabled: boolean,
	issuer?: string | undefined | null,
	clientId?: string | undefined | null,
	hasClientSecret: boolean,
	entryPoint?: string | undefined | null,
	idpIssuer?: string | undefined | null,
	idpCert?: string | undefined | null,
	allowedDomains: Array<string>,
	requiresAllowedDomains: boolean,
	callbackUrl: string,
	metadataUrl?: string | undefined | null,
	['...on SsoProviderModel']: Omit<GraphQLTypes["SsoProviderModel"], "...on SsoProviderModel">
};
	["PublicSsoProviderModel"]: {
	__typename: "PublicSsoProviderModel",
	id: GraphQLTypes["ID"],
	kind: GraphQLTypes["SsoProviderKind"],
	label: string,
	loginUrl: string,
	['...on PublicSsoProviderModel']: Omit<GraphQLTypes["PublicSsoProviderModel"], "...on PublicSsoProviderModel">
};
	["SurveyQuestionModel"]: {
	__typename: "SurveyQuestionModel",
	id: GraphQLTypes["ID"],
	position: number,
	kind: GraphQLTypes["SurveyQuestionKind"],
	label: string,
	isOverall: boolean,
	['...on SurveyQuestionModel']: Omit<GraphQLTypes["SurveyQuestionModel"], "...on SurveyQuestionModel">
};
	/** Note de 1 à 5, ou réponse libre (#320). */
["SurveyQuestionKind"]: SurveyQuestionKind;
	["SurveyModuleModel"]: {
	__typename: "SurveyModuleModel",
	id: GraphQLTypes["ID"],
	title: string,
	['...on SurveyModuleModel']: Omit<GraphQLTypes["SurveyModuleModel"], "...on SurveyModuleModel">
};
	["LearnerSurveyModel"]: {
	__typename: "LearnerSurveyModel",
	pending: boolean,
	questions: Array<GraphQLTypes["SurveyQuestionModel"]>,
	modules: Array<GraphQLTypes["SurveyModuleModel"]>,
	['...on LearnerSurveyModel']: Omit<GraphQLTypes["LearnerSurveyModel"], "...on LearnerSurveyModel">
};
	["SurveyQuestionAverageModel"]: {
	__typename: "SurveyQuestionAverageModel",
	questionId: GraphQLTypes["ID"],
	label: string,
	average: number,
	count: number,
	['...on SurveyQuestionAverageModel']: Omit<GraphQLTypes["SurveyQuestionAverageModel"], "...on SurveyQuestionAverageModel">
};
	["SurveyModuleAverageModel"]: {
	__typename: "SurveyModuleAverageModel",
	moduleId: GraphQLTypes["ID"],
	title: string,
	average: number,
	count: number,
	['...on SurveyModuleAverageModel']: Omit<GraphQLTypes["SurveyModuleAverageModel"], "...on SurveyModuleAverageModel">
};
	["SurveyCommentModel"]: {
	__typename: "SurveyCommentModel",
	label: string,
	text: string,
	at: GraphQLTypes["DateTime"],
	['...on SurveyCommentModel']: Omit<GraphQLTypes["SurveyCommentModel"], "...on SurveyCommentModel">
};
	["SurveyResultsModel"]: {
	__typename: "SurveyResultsModel",
	answered: number,
	skipped: number,
	satisfactionRate?: number | undefined | null,
	questions: Array<GraphQLTypes["SurveyQuestionAverageModel"]>,
	modules: Array<GraphQLTypes["SurveyModuleAverageModel"]>,
	comments: Array<GraphQLTypes["SurveyCommentModel"]>,
	['...on SurveyResultsModel']: Omit<GraphQLTypes["SurveyResultsModel"], "...on SurveyResultsModel">
};
	["WebhookEndpointModel"]: {
	__typename: "WebhookEndpointModel",
	url: string,
	enabled: boolean,
	updatedAt: GraphQLTypes["DateTime"],
	['...on WebhookEndpointModel']: Omit<GraphQLTypes["WebhookEndpointModel"], "...on WebhookEndpointModel">
};
	["WebhookEndpointSaveResult"]: {
	__typename: "WebhookEndpointSaveResult",
	endpoint: GraphQLTypes["WebhookEndpointModel"],
	secret?: string | undefined | null,
	['...on WebhookEndpointSaveResult']: Omit<GraphQLTypes["WebhookEndpointSaveResult"], "...on WebhookEndpointSaveResult">
};
	["WebhookDeliveryModel"]: {
	__typename: "WebhookDeliveryModel",
	id: GraphQLTypes["ID"],
	event: string,
	status: GraphQLTypes["WebhookDeliveryStatus"],
	attempts: number,
	lastStatusCode?: number | undefined | null,
	lastError?: string | undefined | null,
	createdAt: GraphQLTypes["DateTime"],
	nextAttemptAt?: GraphQLTypes["DateTime"] | undefined | null,
	deliveredAt?: GraphQLTypes["DateTime"] | undefined | null,
	['...on WebhookDeliveryModel']: Omit<GraphQLTypes["WebhookDeliveryModel"], "...on WebhookDeliveryModel">
};
	/** Où en est un appel de webhook (#5) : en file, en cours, reçu ou abandonné. */
["WebhookDeliveryStatus"]: WebhookDeliveryStatus;
	["Health"]: {
	__typename: "Health",
	env: string,
	time: string,
	status: string,
	version: string,
	['...on Health']: Omit<GraphQLTypes["Health"], "...on Health">
};
	["StatsNotice"]: {
	__typename: "StatsNotice",
	status: GraphQLTypes["ConsentStatus"],
	acknowledgedAt?: GraphQLTypes["DateTime"] | undefined | null,
	version?: string | undefined | null,
	currentVersion: string,
	needsAcknowledgement: boolean,
	['...on StatsNotice']: Omit<GraphQLTypes["StatsNotice"], "...on StatsNotice">
};
	["ConsentStatus"]: ConsentStatus;
	["PendingLegalDocument"]: {
	__typename: "PendingLegalDocument",
	document: GraphQLTypes["LegalDocument"],
	version: string,
	['...on PendingLegalDocument']: Omit<GraphQLTypes["PendingLegalDocument"], "...on PendingLegalDocument">
};
	["LegalDocument"]: LegalDocument;
	["LegalAcceptance"]: {
	__typename: "LegalAcceptance",
	pending: Array<GraphQLTypes["PendingLegalDocument"]>,
	['...on LegalAcceptance']: Omit<GraphQLTypes["LegalAcceptance"], "...on LegalAcceptance">
};
	["Query"]: {
	__typename: "Query",
	getHealthGql: GraphQLTypes["Health"],
	getRole: GraphQLTypes["Role"],
	getRoles: Array<GraphQLTypes["Role"]>,
	getPermission: GraphQLTypes["Permissions"],
	getPermissions: Array<GraphQLTypes["Permissions"]>,
	trainerCapabilities: Array<GraphQLTypes["TrainerCapabilityModel"]>,
	webhookEndpoint?: GraphQLTypes["WebhookEndpointModel"] | undefined | null,
	webhookDeliveries: Array<GraphQLTypes["WebhookDeliveryModel"]>,
	getMail: GraphQLTypes["Mail"],
	getMails: Array<GraphQLTypes["Mail"]>,
	appConfig: GraphQLTypes["AppConfigModel"],
	learnerCounters: GraphQLTypes["LearnerCountersModel"],
	capacityAlert?: GraphQLTypes["CapacityAlertModel"] | undefined | null,
	learnerCountersByOrganization: Array<GraphQLTypes["LearnerCountersModel"]>,
	billingAccount: GraphQLTypes["BillingAccountModel"],
	billingOffers: Array<GraphQLTypes["BillingOfferModel"]>,
	billingEstimate: GraphQLTypes["BillingEstimateModel"],
	billingHistory: Array<GraphQLTypes["BillingHistoryEntryModel"]>,
	invitation: GraphQLTypes["Invitation"],
	me: GraphQLTypes["UserInfo"],
	myAccount: GraphQLTypes["MyAccount"],
	complaints: Array<GraphQLTypes["ComplaintModel"]>,
	mySurvey: GraphQLTypes["LearnerSurveyModel"],
	surveyQuestions: Array<GraphQLTypes["SurveyQuestionModel"]>,
	surveyResults: GraphQLTypes["SurveyResultsModel"],
	improvementActions: Array<GraphQLTypes["ImprovementActionModel"]>,
	qualityRisks: Array<GraphQLTypes["QualityRiskModel"]>,
	learnerPositioning: Array<GraphQLTypes["SessionPositioningModel"]>,
	getUsers: Array<GraphQLTypes["Users"]>,
	getExistingUserEmails: Array<string>,
	getFilteredUsers: GraphQLTypes["UserPagination"],
	learnerProfile: GraphQLTypes["LearnerProfile"],
	learnerLogins: GraphQLTypes["LoginEventPage"],
	groups: Array<GraphQLTypes["GroupModel"]>,
	group: GraphQLTypes["GroupModel"],
	trainingDocuments: Array<GraphQLTypes["TrainingDocumentModel"]>,
	documentAcknowledgements: Array<GraphQLTypes["DocumentAcknowledgementModel"]>,
	myAccommodation: GraphQLTypes["MyAccommodationModel"],
	accommodationRequests: Array<GraphQLTypes["OrgAccommodationRequestModel"]>,
	disabilityReferent: GraphQLTypes["DisabilityReferentModel"],
	ssoProviders: Array<GraphQLTypes["PublicSsoProviderModel"]>,
	ssoSettings: GraphQLTypes["SsoOrgSettingsModel"],
	ssoPresets: Array<GraphQLTypes["SsoPresetModel"]>,
	ssoProviderConfigs: Array<GraphQLTypes["SsoProviderModel"]>,
	scormModules: Array<GraphQLTypes["ScormModuleModel"]>,
	scormModule: GraphQLTypes["ScormModuleModel"],
	moduleScos: Array<GraphQLTypes["ScormScoModel"]>,
	storageUsage: GraphQLTypes["StorageUsageModel"],
	storageUsageByOrganization: Array<GraphQLTypes["StorageUsageModel"]>,
	getMyScormTracking?: GraphQLTypes["ScormTrackingModel"] | undefined | null,
	myScormResume?: GraphQLTypes["ScormTrackingModel"] | undefined | null,
	getScormTrackings: GraphQLTypes["ScormTrackingPagination"],
	getScormTrackingStats: GraphQLTypes["ScormTrackingStats"],
	getScormCompletionsByDay: Array<GraphQLTypes["ScormCompletionPoint"]>,
	moduleQuestionStats: GraphQLTypes["ModuleQuestionStatsModel"],
	learnerModuleAttempts: Array<GraphQLTypes["LearnerAttemptModel"]>,
	scoreCorrections: Array<GraphQLTypes["ScoreCorrectionModel"]>,
	sessionResults: GraphQLTypes["SessionResults"],
	sessions: Array<GraphQLTypes["SessionModel"]>,
	session: GraphQLTypes["SessionModel"],
	userSessions: Array<GraphQLTypes["SessionModel"]>,
	mySessions: Array<GraphQLTypes["SessionModel"]>,
	pendingTrialRequests: Array<GraphQLTypes["TrialRequestModel"]>,
	backOfficeHome: GraphQLTypes["BackOfficeHomeModel"],
	certificateTemplates: Array<GraphQLTypes["CertificateTemplateModel"]>,
	certificateTemplateOptions: Array<GraphQLTypes["CertificateTemplateOptionModel"]>,
	certificateTemplate: GraphQLTypes["CertificateTemplateModel"],
	downloadFile: GraphQLTypes["DownloadFile"],
	getAllMyFiles: Array<GraphQLTypes["MyFiles"]>,
	publishBasicSubscription: boolean,
	myStatsNotice: GraphQLTypes["StatsNotice"],
	myLegalAcceptance: GraphQLTypes["LegalAcceptance"],
	organizations: Array<GraphQLTypes["OrganizationModel"]>,
	organizationMembers: Array<GraphQLTypes["OrgMemberModel"]>,
	findOrganization?: string | undefined | null,
	reminderSettings: GraphQLTypes["ReminderSettingsModel"],
	reportTemplates: Array<GraphQLTypes["ReportTemplateModel"]>,
	reportTemplate: GraphQLTypes["ReportTemplateModel"],
	reportColumns: Array<GraphQLTypes["ReportColumnModel"]>,
	reportRecipients: Array<GraphQLTypes["ReportRecipientModel"]>,
	['...on Query']: Omit<GraphQLTypes["Query"], "...on Query">
};
	["FindManyUserWithFiltersInput"]: {
		skip: number,
	take: number,
	searchInput: string,
	orderBy?: GraphQLTypes["UserOrderByInput"] | undefined | null,
	filterBy?: GraphQLTypes["UserFilterByInput"] | undefined | null
};
	["UserOrderByInput"]: {
		email?: GraphQLTypes["OrderByEnum"] | undefined | null,
	firstName?: GraphQLTypes["OrderByEnum"] | undefined | null,
	lastName?: GraphQLTypes["OrderByEnum"] | undefined | null,
	lastConnectionAt?: GraphQLTypes["OrderByEnum"] | undefined | null,
	role?: GraphQLTypes["OrderByEnum"] | undefined | null,
	status?: GraphQLTypes["OrderByEnum"] | undefined | null
};
	["OrderByEnum"]: OrderByEnum;
	["UserFilterByInput"]: {
		role?: Array<string> | undefined | null,
	group?: Array<GraphQLTypes["ID"]> | undefined | null,
	progress?: GraphQLTypes["UserProgress"] | undefined | null
};
	["FindManyScormTrackingWithFiltersInput"]: {
		skip: number,
	take: number,
	searchInput?: string | undefined | null,
	orderBy?: GraphQLTypes["ScormTrackingOrderByInput"] | undefined | null,
	filterBy?: GraphQLTypes["ScormTrackingFilterByInput"] | undefined | null
};
	["ScormTrackingOrderByInput"]: {
		userEmail?: GraphQLTypes["OrderByEnum"] | undefined | null,
	userFirstName?: GraphQLTypes["OrderByEnum"] | undefined | null,
	userLastName?: GraphQLTypes["OrderByEnum"] | undefined | null,
	completionStatus?: GraphQLTypes["OrderByEnum"] | undefined | null,
	successStatus?: GraphQLTypes["OrderByEnum"] | undefined | null,
	scoreRaw?: GraphQLTypes["OrderByEnum"] | undefined | null,
	completedAt?: GraphQLTypes["OrderByEnum"] | undefined | null
};
	["ScormTrackingFilterByInput"]: {
		completionStatus?: GraphQLTypes["ScormCompletionStatus"] | undefined | null,
	successStatus?: GraphQLTypes["ScormSuccessStatus"] | undefined | null,
	sessionId?: GraphQLTypes["ID"] | undefined | null,
	groupId?: GraphQLTypes["ID"] | undefined | null
};
	["ScormTrackingStatsInput"]: {
		searchInput?: string | undefined | null,
	filterBy?: GraphQLTypes["ScormStatsScopeInput"] | undefined | null
};
	["ScormStatsScopeInput"]: {
		sessionId?: GraphQLTypes["ID"] | undefined | null,
	groupId?: GraphQLTypes["ID"] | undefined | null
};
	["ScormTrendInput"]: {
		days?: number | undefined | null,
	filterBy?: GraphQLTypes["ScormStatsScopeInput"] | undefined | null
};
	["ModuleQuestionsInput"]: {
		moduleId: GraphQLTypes["ID"],
	sessionId?: GraphQLTypes["ID"] | undefined | null,
	groupId?: GraphQLTypes["ID"] | undefined | null,
	from?: string | undefined | null,
	to?: string | undefined | null
};
	["LearnerModuleAttemptsInput"]: {
		userId: GraphQLTypes["ID"],
	moduleId: GraphQLTypes["ID"],
	sessionId?: GraphQLTypes["ID"] | undefined | null
};
	["Mutation"]: {
	__typename: "Mutation",
	updateTrainerCapabilities: Array<GraphQLTypes["TrainerCapabilityModel"]>,
	saveWebhookEndpoint: GraphQLTypes["WebhookEndpointSaveResult"],
	regenerateWebhookSecret: string,
	sendWebhookTest: boolean,
	updateAppConfig: GraphQLTypes["AppConfigModel"],
	updateBillingProfile: GraphQLTypes["BillingAccountModel"],
	startCheckout: string,
	openBillingPortal: string,
	setOrganizationPlan: GraphQLTypes["BillingAccountModel"],
	setOrganizationBillingMode: GraphQLTypes["BillingAccountModel"],
	login: GraphQLTypes["AuthType"],
	requestMagicLink: boolean,
	loginWithMagicLink: GraphQLTypes["AuthType"],
	askForResetPassword: boolean,
	reSendEmailValidation: boolean,
	resetPassword: boolean,
	verifyEmail: boolean,
	finishRegister: GraphQLTypes["InvitationStatus"],
	refresh: GraphQLTypes["AuthType"],
	logout: boolean,
	uniqueAuthFromSso: GraphQLTypes["UniqueAuth"],
	impersonateUser: GraphQLTypes["AuthType"],
	stopImpersonate: GraphQLTypes["AuthType"],
	updateMyProfile: GraphQLTypes["MyAccount"],
	changeMyPassword: boolean,
	createComplaint: GraphQLTypes["ComplaintModel"],
	updateComplaint: GraphQLTypes["ComplaintModel"],
	sendContactRequest: boolean,
	replaceSurveyQuestions: Array<GraphQLTypes["SurveyQuestionModel"]>,
	submitSurvey: boolean,
	skipSurvey: boolean,
	createImprovementAction: GraphQLTypes["ImprovementActionModel"],
	updateImprovementAction: GraphQLTypes["ImprovementActionModel"],
	createQualityRisk: GraphQLTypes["QualityRiskModel"],
	updateQualityRisk: GraphQLTypes["QualityRiskModel"],
	submitPositioning: boolean,
	createUser: GraphQLTypes["Users"],
	importUsers: GraphQLTypes["ImportUsersReport"],
	updateUser: GraphQLTypes["Users"],
	deleteUser: boolean,
	createUsernameLearner: GraphQLTypes["UsernameCredentials"],
	importUsernameLearners: GraphQLTypes["UsernameImportReport"],
	resetUsernameLearnerPassword: GraphQLTypes["UsernameCredentials"],
	createGroup: GraphQLTypes["GroupModel"],
	updateGroup: GraphQLTypes["GroupModel"],
	deleteGroup: boolean,
	addUsersToGroup: number,
	removeUsersFromGroup: number,
	updateTrainingDocument: GraphQLTypes["TrainingDocumentModel"],
	archiveTrainingDocument: boolean,
	acknowledgeDocument: boolean,
	submitAccommodation: GraphQLTypes["AccommodationRequestModel"],
	withdrawAccommodation: boolean,
	respondAccommodation: boolean,
	updateDisabilityReferent: GraphQLTypes["DisabilityReferentModel"],
	setSsoEnabled: GraphQLTypes["SsoOrgSettingsModel"],
	upsertSsoProvider: GraphQLTypes["SsoProviderModel"],
	deleteSsoProvider: boolean,
	renameScormModule: GraphQLTypes["ScormModuleModel"],
	deleteScormModule: boolean,
	applyModuleReplacement: GraphQLTypes["ScormModuleModel"],
	cancelModuleReplacement: boolean,
	startScormAttempt?: GraphQLTypes["ScormTrackingModel"] | undefined | null,
	upsertScormTracking: GraphQLTypes["ScormTrackingModel"],
	correctScore: boolean,
	revokeScoreCorrection: boolean,
	createSession: GraphQLTypes["SessionModel"],
	updateSession: GraphQLTypes["SessionModel"],
	deleteSession: boolean,
	declareDropout: boolean,
	cancelDropout: boolean,
	requestTrialOrganization: GraphQLTypes["RequestTrialResult"],
	confirmTrialOrganization: GraphQLTypes["ConfirmTrialResult"],
	approveTrialRequest: GraphQLTypes["ApproveTrialResult"],
	rejectTrialRequest: boolean,
	createCertificateTemplate: GraphQLTypes["CertificateTemplateModel"],
	duplicateCertificateTemplate: GraphQLTypes["CertificateTemplateModel"],
	setDefaultCertificateTemplate: GraphQLTypes["CertificateTemplateModel"],
	deleteCertificateTemplate: boolean,
	updateCertificateTemplate: GraphQLTypes["CertificateTemplateModel"],
	deleteFile: boolean,
	uploadPreSignedUrl: GraphQLTypes["UploadPreSignedUrl"],
	confirmUpload: boolean,
	acknowledgeStatsNotice: GraphQLTypes["StatsNotice"],
	acceptLegalDocuments: GraphQLTypes["LegalAcceptance"],
	createOrganization: GraphQLTypes["OrganizationModel"],
	setOrganizationStatus: GraphQLTypes["OrganizationModel"],
	updateOrganization: GraphQLTypes["OrganizationModel"],
	deleteOrganization: boolean,
	inviteOrgMember: GraphQLTypes["OrgMemberModel"],
	setOrgMemberRole: GraphQLTypes["OrgMemberModel"],
	removeOrgMember: boolean,
	updateReminderSettings: GraphQLTypes["ReminderSettingsModel"],
	sendReminderTest: GraphQLTypes["ReminderTestResultModel"],
	createReportTemplate: GraphQLTypes["ReportTemplateModel"],
	updateReportTemplate: GraphQLTypes["ReportTemplateModel"],
	duplicateReportTemplate: GraphQLTypes["ReportTemplateModel"],
	upsertReportSchedule: GraphQLTypes["ReportTemplateModel"],
	deleteReportSchedule: GraphQLTypes["ReportTemplateModel"],
	deleteReportTemplate: boolean,
	['...on Mutation']: Omit<GraphQLTypes["Mutation"], "...on Mutation">
};
	["TrainerCapabilityGrantInput"]: {
		capability: GraphQLTypes["TrainerCapability"],
	granted: boolean
};
	["SaveWebhookEndpointInput"]: {
		url: string,
	enabled: boolean
};
	["UpdateAppConfigInput"]: {
		appName?: string | undefined | null,
	logo?: string | undefined | null,
	logoDark?: string | undefined | null,
	favicon?: string | undefined | null,
	primaryColor?: string | undefined | null,
	primaryForeground?: string | undefined | null,
	accentColor?: string | undefined | null,
	accentForeground?: string | undefined | null,
	footerText?: string | undefined | null,
	defaultLocale?: string | undefined | null
};
	["UpdateBillingProfileInput"]: {
		companyName?: string | undefined | null,
	addressLine1?: string | undefined | null,
	addressLine2?: string | undefined | null,
	postalCode?: string | undefined | null,
	city?: string | undefined | null,
	country?: string | undefined | null,
	vatNumber?: string | undefined | null,
	billingEmail?: string | undefined | null
};
	["StartCheckoutInput"]: {
		tier: GraphQLTypes["BillingTier"],
	paymentTerm: GraphQLTypes["BillingPaymentTerm"]
};
	["ChangeBillingPlanInput"]: {
		tier: GraphQLTypes["BillingTier"],
	paymentTerm?: GraphQLTypes["BillingPaymentTerm"] | undefined | null
};
	["SetBillingModeInput"]: {
		mode: GraphQLTypes["BillingMode"],
	note?: string | undefined | null
};
	["AuthType"]:{
        	__typename:"UserInfo" | "CustomError"
        	['...on UserInfo']: '__union' & GraphQLTypes["UserInfo"];
	['...on CustomError']: '__union' & GraphQLTypes["CustomError"];
};
	["CustomError"]: {
	__typename: "CustomError",
	error: GraphQLTypes["EError"],
	message: string,
	['...on CustomError']: Omit<GraphQLTypes["CustomError"], "...on CustomError">
};
	["EError"]: EError;
	["UpdateMyProfileInput"]: {
		firstName: string,
	lastName: string
};
	["CreateComplaintInput"]: {
		category: GraphQLTypes["ComplaintCategory"],
	subject: string,
	message: string,
	authorId?: GraphQLTypes["ID"] | undefined | null
};
	["UpdateComplaintInput"]: {
		id: GraphQLTypes["ID"],
	category?: GraphQLTypes["ComplaintCategory"] | undefined | null,
	status?: GraphQLTypes["ComplaintStatus"] | undefined | null,
	response?: string | undefined | null
};
	["ContactRequestInput"]: {
		subject: string,
	message: string,
	pageUrl: string,
	locale: string,
	attachment?: string | undefined | null,
	category?: GraphQLTypes["ComplaintCategory"] | undefined | null
};
	["SurveyQuestionInput"]: {
		kind: GraphQLTypes["SurveyQuestionKind"],
	label: string,
	isOverall?: boolean | undefined | null
};
	["SubmitSurveyInput"]: {
		sessionId: GraphQLTypes["ID"],
	answers: Array<GraphQLTypes["SurveyAnswerInput"]>,
	moduleRatings: Array<GraphQLTypes["ModuleRatingInput"]>
};
	["SurveyAnswerInput"]: {
		questionId: GraphQLTypes["ID"],
	rating?: number | undefined | null,
	text?: string | undefined | null
};
	["ModuleRatingInput"]: {
		moduleId: GraphQLTypes["ID"],
	rating: number
};
	["CreateImprovementActionInput"]: {
		origin: GraphQLTypes["ImprovementOrigin"],
	title: string,
	description: string,
	owner?: string | undefined | null,
	dueDate?: string | undefined | null
};
	["UpdateImprovementActionInput"]: {
		id: GraphQLTypes["ID"],
	origin?: GraphQLTypes["ImprovementOrigin"] | undefined | null,
	status?: GraphQLTypes["ImprovementStatus"] | undefined | null,
	title?: string | undefined | null,
	description?: string | undefined | null,
	owner?: string | undefined | null,
	dueDate?: string | undefined | null,
	effect?: string | undefined | null
};
	["CreateQualityRiskInput"]: {
		title: string,
	description: string,
	likelihood: number,
	impact: number,
	mitigation?: string | undefined | null,
	owner?: string | undefined | null
};
	["UpdateQualityRiskInput"]: {
		id: GraphQLTypes["ID"],
	title?: string | undefined | null,
	description?: string | undefined | null,
	likelihood?: number | undefined | null,
	impact?: number | undefined | null,
	mitigation?: string | undefined | null,
	owner?: string | undefined | null,
	status?: GraphQLTypes["QualityRiskStatus"] | undefined | null
};
	["SubmitPositioningInput"]: {
		sessionId: GraphQLTypes["ID"],
	phase: GraphQLTypes["PositioningPhase"],
	ratings: Array<GraphQLTypes["PositioningRatingInput"]>,
	needs?: string | undefined | null
};
	/** Positionnement d'entrée (obligatoire si demandé) ou de sortie (facultatif), #321. */
["PositioningPhase"]: PositioningPhase;
	["PositioningRatingInput"]: {
		index: number,
	level: number
};
	["CreateUserInput"]: {
		email: string,
	password?: string | undefined | null,
	firstName: string,
	lastName: string,
	roleId: string,
	group?: string | undefined | null,
	company?: string | undefined | null,
	department?: string | undefined | null
};
	["ImportUserInput"]: {
		email: string,
	firstName: string,
	lastName: string,
	group?: string | undefined | null,
	company?: string | undefined | null,
	department?: string | undefined | null
};
	["UpdateUserInput"]: {
		email?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	roleId?: string | undefined | null,
	company?: string | undefined | null,
	department?: string | undefined | null,
	id: string
};
	["CreateUsernameLearnerInput"]: {
		username: string,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	password?: string | undefined | null,
	group?: string | undefined | null,
	company?: string | undefined | null,
	department?: string | undefined | null
};
	["ImportUsernameLearnerInput"]: {
		username: string,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	group?: string | undefined | null,
	company?: string | undefined | null,
	department?: string | undefined | null
};
	["CreateGroupInput"]: {
		name: string,
	description?: string | undefined | null,
	userIds?: Array<GraphQLTypes["ID"]> | undefined | null
};
	["UpdateGroupInput"]: {
		name?: string | undefined | null,
	description?: string | undefined | null,
	userIds?: Array<GraphQLTypes["ID"]> | undefined | null
};
	["UpdateTrainingDocumentInput"]: {
		id: GraphQLTypes["ID"],
	title?: string | undefined | null,
	sessionId?: GraphQLTypes["ID"] | undefined | null,
	requiredBeforeStart?: boolean | undefined | null
};
	["SubmitAccommodationInput"]: {
		needs: string,
	consent: boolean
};
	["RespondAccommodationInput"]: {
		id: GraphQLTypes["ID"],
	response?: string | undefined | null,
	handled: boolean
};
	["DisabilityReferentInput"]: {
		name?: string | undefined | null,
	contact?: string | undefined | null
};
	["UpsertSsoProviderInput"]: {
		kind: GraphQLTypes["SsoProviderKind"],
	label?: string | undefined | null,
	enabled?: boolean | undefined | null,
	issuer?: string | undefined | null,
	clientId?: string | undefined | null,
	clientSecret?: string | undefined | null,
	entryPoint?: string | undefined | null,
	idpIssuer?: string | undefined | null,
	idpCert?: string | undefined | null,
	allowedDomains?: Array<string> | undefined | null
};
	["UpsertScormTrackingInput"]: {
		sessionId: GraphQLTypes["ID"],
	moduleId?: GraphQLTypes["ID"] | undefined | null,
	attemptNumber?: number | undefined | null,
	completionStatus?: GraphQLTypes["ScormCompletionStatus"] | undefined | null,
	successStatus?: GraphQLTypes["ScormSuccessStatus"] | undefined | null,
	scoreRaw?: number | undefined | null,
	scoreMin?: number | undefined | null,
	scoreMax?: number | undefined | null,
	scoreScaled?: number | undefined | null,
	totalTime?: string | undefined | null,
	sessionTime?: string | undefined | null,
	suspendData?: string | undefined | null,
	location?: string | undefined | null,
	interactions?: Array<GraphQLTypes["ScormInteractionInput"]> | undefined | null,
	scoIdentifier?: string | undefined | null
};
	["ScormInteractionInput"]: {
		index: number,
	id: string,
	type?: string | undefined | null,
	description?: string | undefined | null,
	correctResponses?: Array<string> | undefined | null,
	learnerResponse?: string | undefined | null,
	result?: string | undefined | null,
	weighting?: number | undefined | null,
	latency?: string | undefined | null,
	timestamp?: string | undefined | null,
	objectiveIds?: Array<string> | undefined | null
};
	["CorrectScoreInput"]: {
		trackingId: GraphQLTypes["ID"],
	percent: number,
	reason: string
};
	["CreateSessionInput"]: {
		name: string,
	modules: Array<GraphQLTypes["SessionModuleInput"]>,
	sections?: Array<GraphQLTypes["SessionSectionInput"]> | undefined | null,
	progressionMode?: GraphQLTypes["SessionProgressionMode"] | undefined | null,
	tags?: Array<string> | undefined | null,
	certificateCondition?: GraphQLTypes["CertificateCondition"] | undefined | null,
	certificateMinScore?: number | undefined | null,
	certificateTemplateId?: GraphQLTypes["ID"] | undefined | null,
	/** Jour civil au format AAAA-MM-JJ */
	startDate?: string | undefined | null,
	/** Jour civil au format AAAA-MM-JJ */
	endDate?: string | undefined | null,
	userIds?: Array<GraphQLTypes["ID"]> | undefined | null,
	trainerIds?: Array<GraphQLTypes["ID"]> | undefined | null,
	sheet?: GraphQLTypes["TrainingSheetInput"] | undefined | null
};
	["SessionModuleInput"]: {
		moduleId: GraphQLTypes["ID"],
	/** Jour civil au format AAAA-MM-JJ */
	unlockAt?: string | undefined | null,
	prerequisiteModuleId?: GraphQLTypes["ID"] | undefined | null,
	prerequisiteMinScore?: number | undefined | null,
	allowRetake?: boolean | undefined | null,
	scoreRetention?: GraphQLTypes["ScoreRetention"] | undefined | null,
	sectionIndex?: number | undefined | null
};
	["SessionSectionInput"]: {
		title: string
};
	["TrainingSheetInput"]: {
		objectives?: Array<string> | undefined | null,
	prerequisites?: string | undefined | null,
	audience?: string | undefined | null,
	teachingMethods?: string | undefined | null,
	assessmentMethods?: string | undefined | null,
	accessibility?: string | undefined | null,
	contact?: string | undefined | null,
	positioningEnabled?: boolean | undefined | null
};
	["UpdateSessionInput"]: {
		name?: string | undefined | null,
	/** Jour civil au format AAAA-MM-JJ */
	startDate?: string | undefined | null,
	/** Jour civil au format AAAA-MM-JJ */
	endDate?: string | undefined | null,
	status?: GraphQLTypes["SessionStatus"] | undefined | null,
	tags?: Array<string> | undefined | null,
	certificateCondition?: GraphQLTypes["CertificateCondition"] | undefined | null,
	certificateMinScore?: number | undefined | null,
	certificateTemplateId?: GraphQLTypes["ID"] | undefined | null,
	progressionMode?: GraphQLTypes["SessionProgressionMode"] | undefined | null,
	modules?: Array<GraphQLTypes["SessionModuleInput"]> | undefined | null,
	sections?: Array<GraphQLTypes["SessionSectionInput"]> | undefined | null,
	userIds?: Array<GraphQLTypes["ID"]> | undefined | null,
	trainerIds?: Array<GraphQLTypes["ID"]> | undefined | null,
	sheet?: GraphQLTypes["TrainingSheetInput"] | undefined | null
};
	["DeclareDropoutInput"]: {
		sessionId: GraphQLTypes["ID"],
	userId: GraphQLTypes["ID"],
	reason: GraphQLTypes["DropoutReason"],
	note?: string | undefined | null
};
	["SessionEnrollmentRefInput"]: {
		sessionId: GraphQLTypes["ID"],
	userId: GraphQLTypes["ID"]
};
	["RequestTrialInput"]: {
		email: string,
	firstName: string,
	lastName: string,
	orgName: string,
	phone?: string | undefined | null,
	jobTitle?: string | undefined | null,
	acceptTerms: boolean
};
	["UpdateCertificateTemplateInput"]: {
		name?: string | undefined | null,
	title?: string | undefined | null,
	body?: string | undefined | null,
	signature?: string | undefined | null,
	showScore?: boolean | undefined | null,
	showDate?: boolean | undefined | null,
	showTotalTime?: boolean | undefined | null,
	emailOnUnlock?: boolean | undefined | null,
	logo?: string | undefined | null,
	orientation?: GraphQLTypes["CertificateOrientation"] | undefined | null,
	skeletonPdf?: string | undefined | null,
	marginTop?: number | undefined | null,
	marginBottom?: number | undefined | null,
	marginLeft?: number | undefined | null,
	marginRight?: number | undefined | null
};
	["CreateOrganizationInput"]: {
		name: string,
	slug: string,
	adminEmail: string,
	adminFirstName: string,
	adminLastName: string
};
	["UpdateOrganizationInput"]: {
		id: GraphQLTypes["ID"],
	name?: string | undefined | null,
	slug?: string | undefined | null,
	status?: GraphQLTypes["OrganizationStatus"] | undefined | null
};
	["InviteOrgMemberInput"]: {
		orgId: GraphQLTypes["ID"],
	email: string,
	firstName: string,
	lastName: string,
	role: GraphQLTypes["RoleEnum"]
};
	["SetOrgMemberRoleInput"]: {
		orgId: GraphQLTypes["ID"],
	userId: GraphQLTypes["ID"],
	role: GraphQLTypes["RoleEnum"]
};
	["UpdateReminderSettingsInput"]: {
		enabled?: boolean | undefined | null,
	firstDelayDays?: number | undefined | null,
	frequencyDays?: number | undefined | null,
	maxReminders?: number | undefined | null,
	sendHour?: number | undefined | null,
	subject?: string | undefined | null,
	body?: string | undefined | null,
	completionDigestEnabled?: boolean | undefined | null,
	convocationEnabled?: boolean | undefined | null
};
	["ReportTemplateInput"]: {
		name: string,
	granularity: GraphQLTypes["ReportGranularity"],
	columns: Array<string>,
	filters?: GraphQLTypes["ReportFiltersInput"] | undefined | null
};
	["ReportFiltersInput"]: {
		sessionIds?: Array<GraphQLTypes["ID"]> | undefined | null,
	groupIds?: Array<GraphQLTypes["ID"]> | undefined | null,
	state?: GraphQLTypes["UserProgress"] | undefined | null,
	period?: GraphQLTypes["ReportPeriodInput"] | undefined | null
};
	["ReportPeriodInput"]: {
		kind: GraphQLTypes["ReportPeriodKind"],
	from?: string | undefined | null,
	to?: string | undefined | null
};
	["ReportScheduleInput"]: {
		frequency: GraphQLTypes["ReportFrequency"],
	weekday?: number | undefined | null,
	monthDay?: number | undefined | null,
	hour: number,
	recipientIds: Array<GraphQLTypes["ID"]>,
	enabled?: boolean | undefined | null
};
	["Subscription"]: {
	__typename: "Subscription",
	basicSubscription?: string | undefined | null,
	['...on Subscription']: Omit<GraphQLTypes["Subscription"], "...on Subscription">
};
	["ID"]: "scalar" & { name: "ID" }
    }
export enum AccountStatus {
	PENDING_ACTIVATION = "PENDING_ACTIVATION",
	ENABLED = "ENABLED",
	DISABLED = "DISABLED"
}
export enum AccommodationStatus {
	PENDING = "PENDING",
	HANDLED = "HANDLED"
}
export enum InvitationStatus {
	VALID = "VALID",
	INVALID = "INVALID",
	EXPIRED = "EXPIRED"
}
export enum RoleEnum {
	SuperAdmin = "SuperAdmin",
	Admin = "Admin",
	Formateur = "Formateur",
	User = "User",
	Guest = "Guest"
}
/** Ce que le rôle Formateur peut faire, réglable par organisation (#11) */
export enum TrainerCapability {
	SESSIONS_VIEW = "SESSIONS_VIEW",
	SESSIONS_MANAGE = "SESSIONS_MANAGE",
	SESSIONS_DELETE = "SESSIONS_DELETE",
	MODULES_VIEW = "MODULES_VIEW",
	MODULES_IMPORT = "MODULES_IMPORT",
	MODULES_DELETE = "MODULES_DELETE",
	LEARNERS_VIEW = "LEARNERS_VIEW",
	STATISTICS_VIEW = "STATISTICS_VIEW",
	STATISTICS_EXPORT = "STATISTICS_EXPORT"
}
export enum BillingTier {
	FREE = "FREE",
	S = "S",
	M = "M",
	L = "L",
	XL = "XL",
	CUSTOM = "CUSTOM"
}
export enum BillingPaymentTerm {
	UPFRONT = "UPFRONT",
	MONTHLY = "MONTHLY"
}
export enum BillingMode {
	SELF_SERVICE = "SELF_SERVICE",
	MANAGED = "MANAGED"
}
export enum LoginMethod {
	PASSWORD = "PASSWORD",
	MAGIC_LINK = "MAGIC_LINK",
	SSO = "SSO"
}
export enum CertificateOrientation {
	LANDSCAPE = "LANDSCAPE",
	PORTRAIT = "PORTRAIT"
}
/** Nature d'une demande ou réclamation (#325) ; REPORT = signalement de violence, harcèlement ou discrimination. */
export enum ComplaintCategory {
	QUESTION = "QUESTION",
	PEDAGOGICAL = "PEDAGOGICAL",
	TECHNICAL = "TECHNICAL",
	ADMINISTRATIVE = "ADMINISTRATIVE",
	REPORT = "REPORT",
	OTHER = "OTHER"
}
export enum ComplaintStatus {
	OPEN = "OPEN",
	IN_PROGRESS = "IN_PROGRESS",
	RESOLVED = "RESOLVED"
}
export enum ComplaintOrigin {
	CONTACT_FORM = "CONTACT_FORM",
	MANUAL = "MANUAL"
}
export enum OrganizationStatus {
	ACTIVE = "ACTIVE",
	SUSPENDED = "SUSPENDED"
}
/** Le retour qui a fait naître une action d'amélioration (#328). */
export enum ImprovementOrigin {
	SURVEY = "SURVEY",
	COMPLAINT = "COMPLAINT",
	DROPOUT = "DROPOUT",
	AUDIT = "AUDIT",
	REVIEW = "REVIEW",
	OTHER = "OTHER"
}
export enum ImprovementStatus {
	PLANNED = "PLANNED",
	IN_PROGRESS = "IN_PROGRESS",
	DONE = "DONE",
	CANCELLED = "CANCELLED"
}
export enum QualityRiskStatus {
	OPEN = "OPEN",
	MITIGATED = "MITIGATED",
	CLOSED = "CLOSED"
}
export enum ReportPeriodKind {
	ALL = "ALL",
	LAST_7_DAYS = "LAST_7_DAYS",
	LAST_30_DAYS = "LAST_30_DAYS",
	CURRENT_MONTH = "CURRENT_MONTH",
	PREVIOUS_MONTH = "PREVIOUS_MONTH",
	RANGE = "RANGE"
}
export enum UserProgress {
	NOT_STARTED = "NOT_STARTED",
	IN_PROGRESS = "IN_PROGRESS",
	COMPLETED = "COMPLETED"
}
export enum ReportFrequency {
	WEEKLY = "WEEKLY",
	MONTHLY = "MONTHLY"
}
/** Ce qu'est une ligne du rapport (#163). */
export enum ReportGranularity {
	LEARNER = "LEARNER",
	ENROLLMENT = "ENROLLMENT",
	MODULE = "MODULE"
}
export enum ScormModuleStatus {
	PROCESSING = "PROCESSING",
	READY = "READY",
	FAILED = "FAILED"
}
export enum ScormCompletionStatus {
	COMPLETED = "COMPLETED",
	INCOMPLETE = "INCOMPLETE",
	NOT_ATTEMPTED = "NOT_ATTEMPTED",
	UNKNOWN = "UNKNOWN"
}
export enum ScormSuccessStatus {
	PASSED = "PASSED",
	FAILED = "FAILED",
	UNKNOWN = "UNKNOWN"
}
/** Motif d'un abandon déclaré par l'organisme (#324). */
export enum DropoutReason {
	PERSONAL = "PERSONAL",
	PROFESSIONAL = "PROFESSIONAL",
	HEALTH = "HEALTH",
	CONTENT = "CONTENT",
	TECHNICAL = "TECHNICAL",
	OTHER = "OTHER"
}
/** Score retenu quand un apprenant refait un module : meilleur, dernier ou moyenne (#84) */
export enum ScoreRetention {
	BEST = "BEST",
	LAST = "LAST",
	AVERAGE = "AVERAGE"
}
/** Pourquoi un module est fermé — une date à attendre, ou un module à finir. */
export enum ModuleLockReason {
	OPEN = "OPEN",
	SCHEDULED = "SCHEDULED",
	AWAITING_PREVIOUS = "AWAITING_PREVIOUS",
	AWAITING_PREREQUISITE = "AWAITING_PREREQUISITE",
	AWAITING_SCORE = "AWAITING_SCORE",
	AWAITING_POSITIONING = "AWAITING_POSITIONING",
	AWAITING_DOCUMENTS = "AWAITING_DOCUMENTS"
}
/** Pourquoi l'attestation est verrouillée : modules à terminer, à réussir, ou sous le seuil. */
export enum CertificateLockReason {
	INCOMPLETE = "INCOMPLETE",
	NOT_PASSED = "NOT_PASSED",
	SCORE_TOO_LOW = "SCORE_TOO_LOW"
}
export enum SessionStatus {
	ACTIVE = "ACTIVE",
	ARCHIVED = "ARCHIVED"
}
/** Règle d'enchaînement du parcours. Le déblocage par date n'est pas une valeur ici : c'est un second verrou, porté par SessionModule.unlockAt. */
export enum SessionProgressionMode {
	FREE = "FREE",
	SEQUENTIAL = "SEQUENTIAL"
}
/** Ce qu'exige l'attestation d'un parcours, au-delà de terminer tous ses modules (#10). */
export enum CertificateCondition {
	COMPLETION = "COMPLETION",
	SUCCESS = "SUCCESS",
	SCORE = "SCORE"
}
export enum TrialReviewStatus {
	PENDING = "PENDING",
	APPROVED = "APPROVED",
	REJECTED = "REJECTED"
}
/** Fournisseur d'identité pré-listé (#40). */
export enum SsoProviderKind {
	ENTRA_ID = "ENTRA_ID",
	GOOGLE = "GOOGLE",
	OKTA = "OKTA",
	OIDC = "OIDC",
	SAML = "SAML"
}
/** Note de 1 à 5, ou réponse libre (#320). */
export enum SurveyQuestionKind {
	SCALE = "SCALE",
	TEXT = "TEXT"
}
/** Où en est un appel de webhook (#5) : en file, en cours, reçu ou abandonné. */
export enum WebhookDeliveryStatus {
	PENDING = "PENDING",
	SENDING = "SENDING",
	DELIVERED = "DELIVERED",
	FAILED = "FAILED"
}
export enum ConsentStatus {
	PENDING = "PENDING",
	GRANTED = "GRANTED",
	DENIED = "DENIED",
	ACKNOWLEDGED = "ACKNOWLEDGED"
}
export enum LegalDocument {
	TERMS_OF_USE = "TERMS_OF_USE",
	TERMS_OF_SALE = "TERMS_OF_SALE"
}
export enum OrderByEnum {
	ASC = "ASC",
	DESC = "DESC"
}
export enum EError {
	AUTH = "AUTH"
}
/** Positionnement d'entrée (obligatoire si demandé) ou de sortie (facultatif), #321. */
export enum PositioningPhase {
	ENTRY = "ENTRY",
	EXIT = "EXIT"
}

type ZEUS_VARIABLES = {
	["DateTime"]: ValueTypes["DateTime"];
	["AccountStatus"]: ValueTypes["AccountStatus"];
	["AccommodationStatus"]: ValueTypes["AccommodationStatus"];
	["InvitationStatus"]: ValueTypes["InvitationStatus"];
	["RoleEnum"]: ValueTypes["RoleEnum"];
	["TrainerCapability"]: ValueTypes["TrainerCapability"];
	["BillingTier"]: ValueTypes["BillingTier"];
	["BillingPaymentTerm"]: ValueTypes["BillingPaymentTerm"];
	["BillingMode"]: ValueTypes["BillingMode"];
	["LoginMethod"]: ValueTypes["LoginMethod"];
	["CertificateOrientation"]: ValueTypes["CertificateOrientation"];
	["ComplaintCategory"]: ValueTypes["ComplaintCategory"];
	["ComplaintStatus"]: ValueTypes["ComplaintStatus"];
	["ComplaintOrigin"]: ValueTypes["ComplaintOrigin"];
	["OrganizationStatus"]: ValueTypes["OrganizationStatus"];
	["ImprovementOrigin"]: ValueTypes["ImprovementOrigin"];
	["ImprovementStatus"]: ValueTypes["ImprovementStatus"];
	["QualityRiskStatus"]: ValueTypes["QualityRiskStatus"];
	["ReportPeriodKind"]: ValueTypes["ReportPeriodKind"];
	["UserProgress"]: ValueTypes["UserProgress"];
	["ReportFrequency"]: ValueTypes["ReportFrequency"];
	["ReportGranularity"]: ValueTypes["ReportGranularity"];
	["ScormModuleStatus"]: ValueTypes["ScormModuleStatus"];
	["ScormCompletionStatus"]: ValueTypes["ScormCompletionStatus"];
	["ScormSuccessStatus"]: ValueTypes["ScormSuccessStatus"];
	["DropoutReason"]: ValueTypes["DropoutReason"];
	["ScoreRetention"]: ValueTypes["ScoreRetention"];
	["ModuleLockReason"]: ValueTypes["ModuleLockReason"];
	["CertificateLockReason"]: ValueTypes["CertificateLockReason"];
	["SessionStatus"]: ValueTypes["SessionStatus"];
	["SessionProgressionMode"]: ValueTypes["SessionProgressionMode"];
	["CertificateCondition"]: ValueTypes["CertificateCondition"];
	["TrialReviewStatus"]: ValueTypes["TrialReviewStatus"];
	["SsoProviderKind"]: ValueTypes["SsoProviderKind"];
	["SurveyQuestionKind"]: ValueTypes["SurveyQuestionKind"];
	["WebhookDeliveryStatus"]: ValueTypes["WebhookDeliveryStatus"];
	["ConsentStatus"]: ValueTypes["ConsentStatus"];
	["LegalDocument"]: ValueTypes["LegalDocument"];
	["FindManyUserWithFiltersInput"]: ValueTypes["FindManyUserWithFiltersInput"];
	["UserOrderByInput"]: ValueTypes["UserOrderByInput"];
	["OrderByEnum"]: ValueTypes["OrderByEnum"];
	["UserFilterByInput"]: ValueTypes["UserFilterByInput"];
	["FindManyScormTrackingWithFiltersInput"]: ValueTypes["FindManyScormTrackingWithFiltersInput"];
	["ScormTrackingOrderByInput"]: ValueTypes["ScormTrackingOrderByInput"];
	["ScormTrackingFilterByInput"]: ValueTypes["ScormTrackingFilterByInput"];
	["ScormTrackingStatsInput"]: ValueTypes["ScormTrackingStatsInput"];
	["ScormStatsScopeInput"]: ValueTypes["ScormStatsScopeInput"];
	["ScormTrendInput"]: ValueTypes["ScormTrendInput"];
	["ModuleQuestionsInput"]: ValueTypes["ModuleQuestionsInput"];
	["LearnerModuleAttemptsInput"]: ValueTypes["LearnerModuleAttemptsInput"];
	["TrainerCapabilityGrantInput"]: ValueTypes["TrainerCapabilityGrantInput"];
	["SaveWebhookEndpointInput"]: ValueTypes["SaveWebhookEndpointInput"];
	["UpdateAppConfigInput"]: ValueTypes["UpdateAppConfigInput"];
	["UpdateBillingProfileInput"]: ValueTypes["UpdateBillingProfileInput"];
	["StartCheckoutInput"]: ValueTypes["StartCheckoutInput"];
	["ChangeBillingPlanInput"]: ValueTypes["ChangeBillingPlanInput"];
	["SetBillingModeInput"]: ValueTypes["SetBillingModeInput"];
	["EError"]: ValueTypes["EError"];
	["UpdateMyProfileInput"]: ValueTypes["UpdateMyProfileInput"];
	["CreateComplaintInput"]: ValueTypes["CreateComplaintInput"];
	["UpdateComplaintInput"]: ValueTypes["UpdateComplaintInput"];
	["ContactRequestInput"]: ValueTypes["ContactRequestInput"];
	["SurveyQuestionInput"]: ValueTypes["SurveyQuestionInput"];
	["SubmitSurveyInput"]: ValueTypes["SubmitSurveyInput"];
	["SurveyAnswerInput"]: ValueTypes["SurveyAnswerInput"];
	["ModuleRatingInput"]: ValueTypes["ModuleRatingInput"];
	["CreateImprovementActionInput"]: ValueTypes["CreateImprovementActionInput"];
	["UpdateImprovementActionInput"]: ValueTypes["UpdateImprovementActionInput"];
	["CreateQualityRiskInput"]: ValueTypes["CreateQualityRiskInput"];
	["UpdateQualityRiskInput"]: ValueTypes["UpdateQualityRiskInput"];
	["SubmitPositioningInput"]: ValueTypes["SubmitPositioningInput"];
	["PositioningPhase"]: ValueTypes["PositioningPhase"];
	["PositioningRatingInput"]: ValueTypes["PositioningRatingInput"];
	["CreateUserInput"]: ValueTypes["CreateUserInput"];
	["ImportUserInput"]: ValueTypes["ImportUserInput"];
	["UpdateUserInput"]: ValueTypes["UpdateUserInput"];
	["CreateUsernameLearnerInput"]: ValueTypes["CreateUsernameLearnerInput"];
	["ImportUsernameLearnerInput"]: ValueTypes["ImportUsernameLearnerInput"];
	["CreateGroupInput"]: ValueTypes["CreateGroupInput"];
	["UpdateGroupInput"]: ValueTypes["UpdateGroupInput"];
	["UpdateTrainingDocumentInput"]: ValueTypes["UpdateTrainingDocumentInput"];
	["SubmitAccommodationInput"]: ValueTypes["SubmitAccommodationInput"];
	["RespondAccommodationInput"]: ValueTypes["RespondAccommodationInput"];
	["DisabilityReferentInput"]: ValueTypes["DisabilityReferentInput"];
	["UpsertSsoProviderInput"]: ValueTypes["UpsertSsoProviderInput"];
	["UpsertScormTrackingInput"]: ValueTypes["UpsertScormTrackingInput"];
	["ScormInteractionInput"]: ValueTypes["ScormInteractionInput"];
	["CorrectScoreInput"]: ValueTypes["CorrectScoreInput"];
	["CreateSessionInput"]: ValueTypes["CreateSessionInput"];
	["SessionModuleInput"]: ValueTypes["SessionModuleInput"];
	["SessionSectionInput"]: ValueTypes["SessionSectionInput"];
	["TrainingSheetInput"]: ValueTypes["TrainingSheetInput"];
	["UpdateSessionInput"]: ValueTypes["UpdateSessionInput"];
	["DeclareDropoutInput"]: ValueTypes["DeclareDropoutInput"];
	["SessionEnrollmentRefInput"]: ValueTypes["SessionEnrollmentRefInput"];
	["RequestTrialInput"]: ValueTypes["RequestTrialInput"];
	["UpdateCertificateTemplateInput"]: ValueTypes["UpdateCertificateTemplateInput"];
	["CreateOrganizationInput"]: ValueTypes["CreateOrganizationInput"];
	["UpdateOrganizationInput"]: ValueTypes["UpdateOrganizationInput"];
	["InviteOrgMemberInput"]: ValueTypes["InviteOrgMemberInput"];
	["SetOrgMemberRoleInput"]: ValueTypes["SetOrgMemberRoleInput"];
	["UpdateReminderSettingsInput"]: ValueTypes["UpdateReminderSettingsInput"];
	["ReportTemplateInput"]: ValueTypes["ReportTemplateInput"];
	["ReportFiltersInput"]: ValueTypes["ReportFiltersInput"];
	["ReportPeriodInput"]: ValueTypes["ReportPeriodInput"];
	["ReportScheduleInput"]: ValueTypes["ReportScheduleInput"];
	["ID"]: ValueTypes["ID"];
}